import { jsx as x, jsxs as N, Fragment as Me } from "react/jsx-runtime";
import * as at from "react";
import me, { useContext as H, useMemo as E, useState as B, useEffect as K, useCallback as D, createContext as ce, useRef as ge, useLayoutEffect as hr, Fragment as Ke, useReducer as an, forwardRef as yr, useImperativeHandle as cn } from "react";
import { AtlasAuto as un, ModeContext as ln, mergeStyles as fn, RegionHighlight as pn, TileSet as dn, HTMLPortal as hn } from "@atlas-viewer/atlas";
import { serialize as yn, serializeConfigPresentation2 as vn, serializeConfigPresentation3 as gn, isSpecificResource as mn, HAS_PART as Ze, PART_OF as Xe, frameResource as vr, normalize as bn } from "@iiif/parser";
import { ImageServiceLoader as gr, getImageServices as mt, getFixedSizeFromImage as Yt } from "@atlas-viewer/iiif-image-api";
function bt(e, t) {
  return bt = Object.setPrototypeOf || function(i, n) {
    return i.__proto__ = n, i;
  }, bt(e, t);
}
function An(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, bt(e, t);
}
var xn = function(t, r) {
  return t === void 0 && (t = []), r === void 0 && (r = []), t.length !== r.length || t.some(function(i, n) {
    return !Object.is(i, r[n]);
  });
}, Gt = {
  error: null
}, wn = /* @__PURE__ */ function(e) {
  An(t, e);
  function t() {
    for (var i, n = arguments.length, s = new Array(n), o = 0; o < n; o++)
      s[o] = arguments[o];
    return i = e.call.apply(e, [this].concat(s)) || this, i.state = Gt, i.resetErrorBoundary = function() {
      for (var a, u = arguments.length, d = new Array(u), l = 0; l < u; l++)
        d[l] = arguments[l];
      i.props.onReset == null || (a = i.props).onReset.apply(a, d), i.reset();
    }, i;
  }
  t.getDerivedStateFromError = function(n) {
    return {
      error: n
    };
  };
  var r = t.prototype;
  return r.reset = function() {
    this.setState(Gt);
  }, r.componentDidCatch = function(n, s) {
    var o, a;
    (o = (a = this.props).onError) == null || o.call(a, n, s);
  }, r.componentDidUpdate = function(n, s) {
    var o = this.state.error, a = this.props.resetKeys;
    if (o !== null && s.error !== null && xn(n.resetKeys, a)) {
      var u, d;
      (u = (d = this.props).onResetKeysChange) == null || u.call(d, n.resetKeys, a), this.reset();
    }
  }, r.render = function() {
    var n = this.state.error, s = this.props, o = s.fallbackRender, a = s.FallbackComponent, u = s.fallback;
    if (n !== null) {
      var d = {
        error: n,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (/* @__PURE__ */ at.isValidElement(u))
        return u;
      if (typeof o == "function")
        return o(d);
      if (a)
        return /* @__PURE__ */ at.createElement(a, d);
      throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
    }
    return this.props.children;
  }, t;
}(at.Component);
const Sn = {
  collection: void 0,
  manifest: void 0,
  range: void 0,
  canvas: void 0,
  annotation: void 0,
  annotationPage: void 0
}, Et = me.createContext(Sn), be = () => H(Et);
function Te({ value: e, children: t }) {
  const r = be(), i = E(() => ({
    ...r,
    ...e
  }), [e, r]);
  return /* @__PURE__ */ x(Et.Provider, { value: i, children: t });
}
var Cn = Object.defineProperty, Mn = (e, t, r) => t in e ? Cn(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, ve = (e, t, r) => (Mn(e, typeof t != "symbol" ? t + "" : t, r), r);
const q = function(e) {
  return function() {
    const t = { type: e, getType: () => e, toString: () => e };
    return (r, i) => ({
      ...t,
      ...r !== void 0 && { payload: r },
      ...i !== void 0 && { meta: i }
    });
  };
}, mr = "@iiif/IMPORT_ENTITIES", br = "@iiif/MODIFY_ENTITY_FIELD", Ar = "@iiif/REORDER_ENTITY_FIELD", xr = "@iiif/ADD_REFERENCE", At = "@iiif/UPDATE_REFERENCE", wr = "@iiif/REMOVE_REFERENCE", Sr = "@iiif/ADD_METADATA", Cr = "@iiif/REMOVE_METADATA", xt = "@iiif/UPDATE_METADATA", Mr = "@iiif/REORDER_METADATA", Rr = q(mr)(), Rn = q(br)(), In = q(Ar)(), Tn = q(xr)(), kn = q(wr)(), On = q(At)(), En = q(Sr)(), Pn = q(xt)(), Ln = q(Cr)(), Fn = q(Mr)(), jn = {
  importEntities: Rr,
  modifyEntityField: Rn,
  reorderEntityField: In,
  addReference: Tn,
  removeReference: kn,
  updateReference: On,
  addMetadata: En,
  removeMetadata: Ln,
  updateMetadata: Pn,
  reorderMetadata: Fn
}, Ir = "@iiif/ADD_MAPPING", Tr = "@iiif/ADD_MAPPINGS", $n = q(Ir)(), Dn = q(Tr)(), kr = "@iiif/SET_META_VALUE", Or = "@iiif/SET_META_VALUE_DYNAMIC", Er = "@iiif/UNSET_META_VALUE", qn = q(kr)(), _n = q(Or)(), Un = q(Er)(), Jt = {
  setMetaValue: qn,
  setMetaValueDynamic: _n,
  unsetMetaValue: Un
}, wt = "RESOURCE_ERROR", Pr = "RESOURCE_LOADING", St = "RESOURCE_READY", Lr = "@iiif/REQUEST_RESOURCE", Fr = "@iiif/REQUEST_ERROR", jr = "@iiif/REQUEST_MISMATCH", $r = "@iiif/REQUEST_COMPLETE", Vn = "@iiif/REQUEST_OFFLINE_RESOURCE", Nn = q(Lr)(), Dr = q(Fr)(), Hn = q(jr)(), Bn = q($r)(), Pt = "@iiif/BATCH", zn = "@iiif/BATCH_IMPORT", Ct = q(Pt)(), Wn = (e, t) => {
  const { entities: r, resource: i, mapping: n } = bn(t);
  if (i.id === void 0)
    return [Dr({ id: e, message: "ID is not defined in resource." })];
  const s = [Rr({ entities: r }), Dn({ mapping: n })];
  return i.id !== e && (s.push($n({ id: e, type: i.type })), s.push(Hn({ requestId: e, actualId: i.id }))), s.push(Bn({ id: e })), s;
}, Kt = Number.isNaN || function(e) {
  return typeof e == "number" && e !== e;
};
function Qn(e, t) {
  return !!(e === t || Kt(e) && Kt(t));
}
function Zt(e, t) {
  if (!Array.isArray(e) || !Array.isArray(t))
    return e === t;
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; r++)
    if (!Qn(e[r], t[r]))
      return !1;
  return !0;
}
function ct(e, t, r) {
  const i = e.iiif.requests[t], n = e.iiif.mapping[t];
  if (!n || !e.iiif.entities[n][i.resourceUri])
    return;
  const s = e.iiif.entities[n][i.resourceUri];
  if (s && s[Ze]) {
    const o = s[Ze].find((a) => r ? a[Xe] === r.id : a[Xe] === s.id);
    return vr(s, o);
  }
  return s;
}
function Xt(e, t, { waitTimeout: r = 30 } = {}) {
  return async (i, n) => {
    const s = e.getStore(), o = s.getState(), a = o.iiif.requests[i];
    if (a)
      switch (a.loadingState) {
        case wt:
          break;
        case Pr: {
          let u, d = !1;
          try {
            const l = await Promise.race([
              new Promise((p, v) => {
                d || (u = s.subscribe(() => {
                  const m = s.getState();
                  if (m.iiif.requests[i].loadingState === wt) {
                    v();
                    return;
                  }
                  if (m.iiif.requests[i].loadingState === St) {
                    const h = ct(m, i);
                    h ? p(h) : v();
                  }
                }));
              }),
              new Promise(
                (p, v) => setTimeout(() => {
                  d = !0, v();
                }, r * 60 * 1e3)
              )
            ]);
            if (u && u(), l)
              return l;
          } catch {
            u && u();
            break;
          }
          break;
        }
        case St: {
          const u = ct(o, i);
          if (u)
            return u;
          break;
        }
      }
    e.dispatch(Nn({ id: i }));
    try {
      const u = await t(i, n);
      !u.id && !u["@id"] && (u["@type"] && (u["@id"] = i), u.id = i);
      const d = Wn(i, u);
      return e.dispatch(Ct({ actions: d })), ct(s.getState(), i);
    } catch (u) {
      throw e.dispatch(Dr({ id: i, message: u.toString() })), u;
    }
  };
}
function qr() {
  return {
    Collection: {},
    Manifest: {},
    Canvas: {},
    AnnotationPage: {},
    AnnotationCollection: {},
    Annotation: {},
    ContentResource: {},
    Range: {},
    Service: {},
    Selector: {},
    Agent: {}
  };
}
const er = (e) => {
  let t;
  const r = /* @__PURE__ */ new Set(), i = (o, a) => {
    const u = typeof o == "function" ? o(t) : o;
    if (!Object.is(u, t)) {
      const d = t;
      t = a ?? typeof u != "object" ? u : Object.assign({}, t, u), r.forEach((l) => l(t, d));
    }
  }, n = () => t, s = { setState: i, getState: n, subscribe: (o) => (r.add(o), () => r.delete(o)), destroy: () => {
    r.clear();
  } };
  return t = e(i, n, s), s;
}, Yn = (e) => e ? er(e) : er, Gn = (e, t) => (r, i, n) => (n.dispatch = (s) => (r((o) => e(o, s), !1, s), s), n.dispatchFromDevtools = !0, { dispatch: (...s) => n.dispatch(...s), ...t }), Jn = Gn, Mt = /* @__PURE__ */ new Map(), Ne = (e) => {
  const t = Mt.get(e);
  return t ? Object.fromEntries(
    Object.entries(t.stores).map(([r, i]) => [r, i.getState()])
  ) : {};
}, Kn = (e, t, r) => {
  if (e === void 0)
    return {
      type: "untracked",
      connection: t.connect(r)
    };
  const i = Mt.get(r.name);
  if (i)
    return { type: "tracked", store: e, ...i };
  const n = {
    connection: t.connect(r),
    stores: {}
  };
  return Mt.set(r.name, n), { type: "tracked", store: e, ...n };
}, Zn = (e, t = {}) => (r, i, n) => {
  const { enabled: s, anonymousActionType: o, store: a, ...u } = t;
  let d;
  try {
    d = (s ?? !1) && window.__REDUX_DEVTOOLS_EXTENSION__;
  } catch {
  }
  if (!d)
    return e(r, i, n);
  const { connection: l, ...p } = Kn(a, d, u);
  let v = !0;
  n.setState = (g, b, A) => {
    const w = r(g, b);
    if (!v)
      return w;
    const C = A === void 0 ? { type: o || "anonymous" } : typeof A == "string" ? { type: A } : A;
    return a === void 0 ? (l == null || l.send(C, i()), w) : (l == null || l.send(
      {
        ...C,
        type: `${a}/${C.type}`
      },
      {
        ...Ne(u.name),
        [a]: n.getState()
      }
    ), w);
  };
  const m = (...g) => {
    const b = v;
    v = !1, r(...g), v = b;
  }, h = e(n.setState, i, n);
  if (p.type === "untracked" ? l == null || l.init(h) : (p.stores[p.store] = n, l == null || l.init(
    Object.fromEntries(
      Object.entries(p.stores).map(([g, b]) => [
        g,
        g === p.store ? h : b.getState()
      ])
    )
  )), n.dispatchFromDevtools && typeof n.dispatch == "function") {
    const g = n.dispatch;
    n.dispatch = (...b) => {
      g(...b);
    };
  }
  return l.subscribe((g) => {
    var b;
    switch (g.type) {
      case "ACTION":
        if (typeof g.payload != "string") {
          console.error(
            "[zustand devtools middleware] Unsupported action format"
          );
          return;
        }
        return ut(
          g.payload,
          (A) => {
            if (A.type === "__setState") {
              if (a === void 0) {
                m(A.state);
                return;
              }
              Object.keys(A.state).length !== 1 && console.error(
                `
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `
              );
              const w = A.state[a];
              if (w == null)
                return;
              JSON.stringify(n.getState()) !== JSON.stringify(w) && m(w);
              return;
            }
            n.dispatchFromDevtools && typeof n.dispatch == "function" && n.dispatch(A);
          }
        );
      case "DISPATCH":
        switch (g.payload.type) {
          case "RESET":
            return m(h), a === void 0 ? l == null ? void 0 : l.init(n.getState()) : l == null ? void 0 : l.init(Ne(u.name));
          case "COMMIT":
            if (a === void 0) {
              l == null || l.init(n.getState());
              return;
            }
            return l == null ? void 0 : l.init(Ne(u.name));
          case "ROLLBACK":
            return ut(g.state, (A) => {
              if (a === void 0) {
                m(A), l == null || l.init(n.getState());
                return;
              }
              m(A[a]), l == null || l.init(Ne(u.name));
            });
          case "JUMP_TO_STATE":
          case "JUMP_TO_ACTION":
            return ut(g.state, (A) => {
              if (a === void 0) {
                m(A);
                return;
              }
              JSON.stringify(n.getState()) !== JSON.stringify(A[a]) && m(A[a]);
            });
          case "IMPORT_STATE": {
            const { nextLiftedState: A } = g.payload, w = (b = A.computedStates.slice(-1)[0]) == null ? void 0 : b.state;
            if (!w)
              return;
            m(a === void 0 ? w : w[a]), l == null || l.send(
              null,
              // FIXME no-any
              A
            );
            return;
          }
          case "PAUSE_RECORDING":
            return v = !v;
        }
        return;
    }
  }), h;
}, Xn = Zn, ut = (e, t) => {
  let r;
  try {
    r = JSON.parse(e);
  } catch (i) {
    console.error(
      "[zustand devtools middleware] Could not parse the received json",
      i
    );
  }
  r !== void 0 && t(r);
}, es = (e) => (t, r, i) => {
  const n = i.subscribe;
  return i.subscribe = (s, o, a) => {
    let u = s;
    if (o) {
      const d = (a == null ? void 0 : a.equalityFn) || Object.is;
      let l = s(i.getState());
      u = (p) => {
        const v = s(p);
        if (!d(l, v)) {
          const m = l;
          o(l = v, m);
        }
      }, a != null && a.fireImmediately && o(l, l);
    }
    return n(u);
  }, e(t, r, i);
}, ts = es, rs = (e = {}, t) => {
  switch (t.type) {
    case Ir:
      return {
        ...e,
        [t.payload.id]: t.payload.type
      };
    case Tr:
      return {
        ...e,
        ...t.payload.mapping
      };
    default:
      return e;
  }
};
function lt(e, t, r, i) {
  return !(!e[r] || !e[r][t] || !e[r][t][i] || !Array.isArray(e[r][t][i]));
}
function is(e, t) {
  const r = {}, i = [];
  for (const [n, s] of Object.entries(e || {})) {
    i.push(n);
    const o = (t || {})[n];
    if (!o || o.length === 0) {
      r[n] = s;
      continue;
    }
    r[n] = o;
  }
  for (const [n, s] of Object.entries(t || {}))
    i.indexOf(n) === -1 && (r[n] = s);
  return r;
}
function R(e) {
  return e.payload;
}
function ft(e, t) {
  return typeof e > "u" ? t : e;
}
const ns = (e = qr(), t) => {
  var r;
  const i = (n, s) => ({
    ...e,
    [R(t).type]: {
      ...e[R(t).type],
      [R(t).id]: {
        ...n,
        ...s
      }
    }
  });
  switch (t.type) {
    case br: {
      if (!e[R(t).type] || !e[R(t).type][R(t).id])
        return e;
      const n = e[R(t).type][R(t).id];
      return typeof n == "string" ? e : i(n, { [R(t).key]: R(t).value });
    }
    case Ar: {
      if (!lt(e, R(t).id, R(t).type, R(t).key))
        return e;
      const n = e[R(t).type][R(t).id];
      if (typeof n == "string")
        return e;
      const s = Array.from(n[R(t).key]), [o] = s.splice(R(t).startIndex, 1);
      return s.splice(R(t).endIndex, 0, o), i(n, { [R(t).key]: s });
    }
    case mr: {
      const n = Object.keys(R(t).entities), s = { ...e };
      for (const o of n) {
        const a = R(t).entities[o], u = { ...e[o] || {} };
        let d = !1;
        const l = Object.keys(a || {}) || [];
        if (a && l) {
          for (const p of l)
            d = !0, u[p] = e[o][p] ? is(e[o][p], a[p]) : a[p];
          d && (s[o] = u);
        }
      }
      return s;
    }
    case xr: {
      if (!lt(e, R(t).id, R(t).type, R(t).key))
        return e;
      const n = e[R(t).type][R(t).id], s = Array.from(n[R(t).key]);
      return s.splice(ft(R(t).index, s.length + 1), 0, R(t).reference), i(n, { [R(t).key]: s });
    }
    case At:
    case wr: {
      if (!lt(e, R(t).id, R(t).type, R(t).key))
        return e;
      const n = e[R(t).type][R(t).id], s = Array.from(n[R(t).key]), o = ft(
        R(t).index,
        s.findIndex((a) => a && a.id === R(t).reference.id)
      );
      return o === -1 || ((r = s[o]) == null ? void 0 : r.id) !== R(t).reference.id ? e : (t.type === At ? s.splice(o, 1, R(t).reference) : s.splice(o, 1), i(n, { [R(t).key]: s }));
    }
    case Sr: {
      const n = e[R(t).type][R(t).id];
      if (!n)
        return e;
      const s = Array.from(n.metadata || []), o = R(t);
      return s.splice(ft(t.payload.beforeIndex, s.length + 1), 0, {
        label: o.label,
        value: o.label
      }), i(n, { metadata: s });
    }
    case Mr: {
      const n = e[R(t).type][R(t).id];
      if (typeof n == "string" || !n)
        return e;
      const s = Array.from(n.metadata || []), [o] = s.splice(R(t).startIndex, 1);
      return s.splice(R(t).endIndex, 0, o), i(n, { metadata: s });
    }
    case xt:
    case Cr: {
      const n = e[R(t).type][R(t).id], s = Array.from(n.metadata || []), o = R(t).atIndex;
      return typeof o > "u" || o === -1 || !s[o] ? e : (t.type === xt ? s.splice(o, 1, { label: R(t).label, value: R(t).value }) : s.splice(o, 1), i(n, { metadata: s }));
    }
    default:
      return e;
  }
}, ss = (e = {}, t) => {
  switch (t.type) {
    case Lr:
    case Vn:
      return {
        ...e,
        [t.payload.id]: {
          requestUri: t.payload.id,
          loadingState: Pr,
          uriMismatch: !1,
          resourceUri: t.payload.id
        }
      };
    case jr:
      return {
        ...e,
        [t.payload.requestId]: {
          ...e[t.payload.requestId] || {},
          uriMismatch: !0,
          resourceUri: t.payload.actualId
        },
        [t.payload.actualId]: {
          requestUri: t.payload.requestId,
          loadingState: e[t.payload.requestId].loadingState,
          uriMismatch: !0,
          resourceUri: t.payload.actualId
        }
      };
    case Fr:
      return {
        ...e,
        [t.payload.id]: {
          ...e[t.payload.id] || {},
          loadingState: wt,
          error: t.payload.message
        }
      };
    case $r:
      return {
        ...e,
        [t.payload.id]: {
          ...e[t.payload.id] || {},
          loadingState: St,
          error: void 0
        }
      };
  }
  return e;
}, os = (e = {}, t) => {
  const { id: r, updateValue: i, value: n, meta: s, key: o } = t && t.payload || {};
  switch (t.type) {
    case kr:
      return {
        ...e,
        [r]: {
          ...e[r] || {},
          [s]: {
            ...e[r] ? e[r][s] || {} : {},
            [o]: n
          }
        }
      };
    case Or:
      return {
        ...e,
        [r]: {
          ...e[r] || {},
          [s]: {
            ...e[r] ? e[r][s] || {} : {},
            [o]: e[r] && e[r][s] ? i(e[r][s][o]) : i(void 0)
          }
        }
      };
    case Er:
      return e[r] && e[r][s] && e[r][s][o] ? {
        ...e,
        [r]: {
          ...e[r] || {},
          [s]: {
            ...e[r] ? e[r][s] || {} : {},
            [o]: void 0
          }
        }
      } : e;
    default:
      return e;
  }
};
function _r(e = {}) {
  const t = Object.keys(e);
  return function(r = {}, i) {
    let n = !1;
    const s = {};
    for (let o = 0; o < t.length; o++) {
      const a = t[o];
      s[a] = e[a](r[a], i), n = n || s[a] !== r[a];
    }
    return n ? s : r;
  };
}
function as(e) {
  return (t, r) => r && r.type === Pt ? r.payload.actions.reduce(e, t) : r && r.type === zn ? {
    ...t,
    iiif: {
      ...t.iiif,
      ...r.payload.state
    }
  } : e(t, r);
}
const cs = _r({
  mapping: rs,
  entities: ns,
  requests: ss,
  meta: os
});
function us() {
  return {
    iiif: {
      entities: qr(),
      meta: {},
      mapping: {},
      requests: {}
    }
  };
}
function ls(e = {}) {
  const {
    enableDevtools: t = !1,
    iiifStoreName: r = "iiif",
    defaultState: i = us(),
    customReducers: n = {}
  } = e, s = as(_r({ [r]: cs, ...n }));
  return Yn(ts(Xn(Jn(s, i), { enabled: t })));
}
function fs(e) {
  return { all: e = e || /* @__PURE__ */ new Map(), on: function(t, r) {
    var i = e.get(t);
    i ? i.push(r) : e.set(t, [r]);
  }, off: function(t, r) {
    var i = e.get(t);
    i && (r ? i.splice(i.indexOf(r) >>> 0, 1) : e.set(t, []));
  }, emit: function(t, r) {
    var i = e.get(t);
    i && i.slice().map(function(n) {
      n(r);
    }), (i = e.get("*")) && i.slice().map(function(n) {
      n(t, r);
    });
  } };
}
function G(e, t, r, i = !0) {
  t[Oe] = t[Oe] || [], t[Oe].push(e);
  const n = /* @__PURE__ */ new Map();
  Object.defineProperty(t, e, {
    enumerable: i,
    get() {
      if (typeof t[Se][e] > "u")
        return;
      const s = t[Se][e];
      if (!s)
        return s;
      const o = r.get(t[Se][e], {
        parent: this.id ? { id: this.id, type: this.type } : void 0
      });
      return n.has(o) || (n.clear(), n.set(o, Ce(o, r))), n.get(o);
    },
    set(s) {
      t[Se][e] !== s && (this[we] ? r.modifyEntityField({ id: this.id, type: this.type }, e, Ur(s)) : this[Se][e] = s);
    }
  });
}
const Se = Symbol.for("_refs_"), we = Symbol.for("_reactive_"), Oe = Symbol.for("_defined_"), tr = Symbol.for("_parent_");
function ps(e, t = !1, r) {
  const i = {
    id: "",
    type: "unknown",
    [Oe]: [],
    [Se]: {},
    [tr]: r || null,
    [we]: null,
    is(n) {
      return typeof n == "string" ? this.id === n : n.id ? n.id === this.id : !1;
    },
    reactive() {
      if (!this[we])
        return this[we] = this.subscribe(() => this.refresh(), !0), () => {
          this.unreactive();
        };
    },
    refresh() {
      if (this.id) {
        const n = this.unwrap();
        for (const s of Object.keys(n || {}))
          this[Oe].includes(s) ? this[Se][s] = n[s] : this[s] = n[s];
      }
    },
    unreactive() {
      this[we] && (this[we](), this[we] = null);
    },
    unwrap() {
      if (!this.id)
        throw new Error("Invalid object");
      const n = this[tr];
      return e.get(this.id, { parent: n ? { id: n, type: "unknown" } : void 0 });
    },
    toPresentation3() {
      return e.toPresentation3(this.unwrap());
    },
    toPresentation2() {
      return e.toPresentation2(this.unwrap());
    },
    valueOf() {
      return this.unwrap();
    },
    toJSON() {
      const n = this;
      return {
        ...n,
        items: n.items,
        annotations: n.annotations,
        structures: n.structures,
        seeAlso: n.seeAlso,
        service: n.service,
        services: n.services,
        rendering: n.rendering,
        partOf: n.partOf,
        start: n.start,
        supplementary: n.supplementary,
        homepage: n.homepage,
        thumbnail: n.thumbnail,
        placeholderCanvas: n.placeholderCanvas,
        accompanyingCanvas: n.accompanyingCanvas,
        provider: n.provider
      };
    },
    subscribe(n, s = !0) {
      return e.subscribe(
        () => this.id ? e.get(this.id) : null,
        n,
        s
      );
    }
  };
  return G("items", i, e), G("annotations", i, e), G("structures", i, e), G("seeAlso", i, e), G("rendering", i, e), G("partOf", i, e), G("start", i, e, !1), G("supplementary", i, e), G("homepage", i, e), G("thumbnail", i, e), G("placeholderCanvas", i, e, !1), G("accompanyingCanvas", i, e, !1), G("provider", i, e), G("body", i, e), G("logo", i, e), i;
}
function ds(e) {
  return !!e[Oe];
}
function Ur(e) {
  return Array.isArray(e) ? e.map((t) => Ur(t)) : !e || !e.type ? e : { id: e.id, type: e.type };
}
function Ce(e, t, r = !1, i) {
  if (Array.isArray(e))
    return e.map((a) => Ce(a, t, r));
  if (!e || !e.type || !e.id)
    return e;
  const n = ps(t, r), s = Object.create(n), o = Object.assign(s, e);
  return r && o.reactive(), o;
}
function rr(e) {
  switch (e) {
    case "Image":
    case "Video":
    case "Sound":
    case "Dataset":
    case "Text":
    case "Composite":
    case "List":
    case "Independents":
    case "Audience":
      return "ContentResource";
    case "ImageService1":
    case "ImageService2":
    case "ImageService3":
      return "Service";
  }
  return e;
}
let Rt = class {
  constructor(t, r) {
    ve(this, "options"), ve(this, "store"), ve(this, "emitter"), ve(this, "isBatching", !1), ve(this, "batchQueue", []), ve(this, "remoteFetcher"), ve(this, "staticFetcher"), ve(this, "defaultFetcher", (i) => fetch(i).then((n) => n.json())), this.options = Object.assign(
      {
        reducers: {},
        customFetcher: this.defaultFetcher,
        enableDevtools: !0
      },
      t || {}
    ), this.store = r || ls({
      customReducers: this.options.reducers,
      defaultState: this.options.defaultState,
      enableDevtools: this.options.enableDevtools
    }), this.emitter = fs(), this.remoteFetcher = Xt(this, this.options.customFetcher), this.staticFetcher = Xt(this, (i, n) => n);
  }
  batch(t) {
    this.isBatching = !0;
    try {
      t(this), this.isBatching = !1, this.dispatch(Ct({ actions: this.batchQueue }));
    } catch (r) {
      throw this.batchQueue = [], this.isBatching = !1, r;
    }
    this.batchQueue = [];
  }
  async asyncBatch(t) {
    this.isBatching = !0;
    try {
      await t(this), this.isBatching = !1, this.dispatch(Ct({ actions: this.batchQueue }));
    } catch (r) {
      throw this.batchQueue = [], this.isBatching = !1, r;
    }
    this.batchQueue = [];
  }
  modifyEntityField(t, r, i) {
    this.dispatch(
      jn.modifyEntityField({
        id: t.id,
        type: t.type,
        key: r,
        value: i
      })
    );
  }
  dispatch(t) {
    if (this.isBatching)
      this.batchQueue.push(t);
    else {
      if (t.type === Pt) {
        for (const n of t.payload.actions)
          this.emitter.emit(n.type, { action: n, state: this.store.getState() });
        this.store.dispatch(t);
        const i = this.getState();
        for (const n of t.payload.actions)
          this.emitter.emit(`after:${n.type}`, { action: n, state: i });
        return;
      }
      this.emitter.emit(t.type, { action: t, state: this.store.getState() }), this.store.dispatch(t);
      const r = this.store.getState();
      this.emitter.emit(`after:${t.type}`, { action: t, state: r });
      return;
    }
  }
  on(t, r) {
    return this.emitter.on(t, r), () => {
      this.emitter.off(t, r);
    };
  }
  serialize(t, r) {
    return yn(this.getState().iiif, t, r);
  }
  toPresentation2(t) {
    return this.serialize(t, vn);
  }
  toPresentation3(t) {
    return this.serialize(t, gn);
  }
  hydrate(t, r, i = {}) {
    return this.get(t, r, { ...i, skipSelfReturn: !1 });
  }
  get(t, r, i = {}) {
    typeof r != "string" && (i = r || {}, r = void 0);
    const { skipSelfReturn: n = !0 } = i || {};
    let s = i.parent ? typeof i.parent == "string" ? i.parent : i.parent.id : void 0;
    if (Array.isArray(t))
      return t.map((p) => this.get(p, i));
    const o = this.getState();
    if (mn(t) && !i.preserveSpecificResources && (t = t.source), typeof t == "string") {
      const p = rr(r || o.iiif.mapping[t]);
      if (!p)
        return n ? null : { id: t, type: "unknown" };
      t = { id: t, type: p };
    }
    if (t && t.partOf && !s && !i.skipPartOfCheck) {
      const p = Array.isArray(t.partOf) ? t.partOf[0] : t.partOf;
      p && (typeof p == "string" && (s = p), typeof p.id == "string" && (s = p.id));
    }
    const a = rr(r || (t == null ? void 0 : t.type)), u = t == null ? void 0 : t.id, d = o.iiif.entities[a];
    if (!d) {
      const p = o.iiif.requests[u];
      return p && p.resourceUri !== u ? this.get(p.resourceUri, i) : n ? null : t;
    }
    const l = d[t.id];
    if (l && l[Ze]) {
      const p = l[Ze].find((v) => s ? v[Xe] === s : v[Xe] === l.id);
      return vr(l, p);
    }
    return d[t.id] || (n ? null : t);
  }
  select(t) {
    return t(this.getState());
  }
  getStore() {
    return this.store;
  }
  getState() {
    return this.store.getState();
  }
  deep(t, r) {
    if (typeof t > "u")
      return this.get(r, { skipSelfReturn: !1 });
    if (typeof t == "function")
      try {
        const n = t(this.get(r, { skipSelfReturn: !1 })), s = (o) => this.deep(o, n);
        return s.size = Array.isArray(n) ? n.length : 1, s;
      } catch {
        const n = (s) => this.deep(s, void 0);
        return n.size = 0, n;
      }
    const i = (n) => this.deep(n, t);
    return i.size = Array.isArray(t) ? t.length : 1, i;
  }
  loadManifest(t, r) {
    const i = typeof t == "string" ? t : t.id;
    return this.load(i, r);
  }
  loadCollection(t, r) {
    const i = typeof t == "string" ? t : t.id;
    return this.load(i, r);
  }
  load(t, r) {
    const i = typeof t == "string" ? t : t.id;
    return r ? this.staticFetcher(i, r) : this.remoteFetcher(i);
  }
  areInputsEqual(t, r) {
    return Zt(t, r);
  }
  subscribe(t, r, i) {
    return typeof i > "u" && (typeof r > "u" || r === !1 || r === !0) && (i = r, r = t, t = (n) => n), this.store.subscribe(t, (n) => r(n, this), {
      equalityFn: Zt,
      fireImmediately: !i
    });
  }
  async ensureLoaded(t) {
    const r = typeof t == "string" ? t : t.id;
    this.requestStatus(r) || await this.load(r);
  }
  requestStatus(t) {
    return this.select((r) => r.iiif.requests[t]);
  }
  getResourceMeta(t, r) {
    const i = this.getState().iiif.meta[t];
    if (i)
      return r ? i[r] : i;
  }
  getObject(t, r, i = {}) {
    const { reactive: n, ...s } = i;
    return Ce(this.get(t, r, s), this, n);
  }
  async loadObject(t, r) {
    return Ce(await this.load(t, r), this);
  }
  async loadManifestObject(t, r) {
    return Ce(await this.loadManifest(t, r), this);
  }
  async loadCollectionObject(t, r) {
    return Ce(await this.loadCollection(t, r), this);
  }
  wrapObject(t) {
    return Ce(this.get(t, { skipSelfReturn: !1 }), this);
  }
  isWrapped(t) {
    return ds(t);
  }
  setMetaValue([t, r, i], n) {
    this.dispatch(
      typeof n == "function" ? Jt.setMetaValueDynamic({
        id: t,
        meta: r,
        key: i,
        updateValue: n
      }) : Jt.setMetaValue({
        id: t,
        meta: r,
        key: i,
        value: n
      })
    );
  }
};
function hs() {
  return typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
function Vr(e) {
  const t = hs();
  try {
    const i = t.IIIF_VAULT;
    if (i)
      return i;
  } catch {
  }
  const r = new Rt(e);
  try {
    t.IIIF_VAULT = r;
  } catch {
  }
  return r;
}
const tt = me.createContext({
  vault: null,
  setVaultInstance: (e) => {
  }
});
function Nr({
  vault: e,
  vaultOptions: t,
  useGlobal: r,
  resources: i,
  children: n
}) {
  const [s, o] = B(() => e || (r ? Vr(t) : t ? new Rt(t) : new Rt()));
  return /* @__PURE__ */ x(tt.Provider, { value: { vault: s, setVaultInstance: o }, children: /* @__PURE__ */ x(Te, { value: i || {}, children: n }) });
}
const V = () => {
  const { vault: e } = H(tt);
  if (e === null)
    throw new Error("Vault not found. Ensure you have your provider set up correctly.");
  return e;
};
function Hr(e, { noCache: t = !1 } = {}) {
  const r = typeof e == "string" ? e : e.id, i = V(), [n, s] = B(r), [o, a] = B(void 0), u = E(() => i.get(r, { skipSelfReturn: !0 }) || void 0, [r, i]), [d, l] = B(u);
  return K(() => {
    (async () => {
      try {
        const p = u && !t ? u : await i.load(r), v = p ? p.id || p["@id"] : null;
        p && n !== v && s(v), l(p);
      } catch (p) {
        a(p);
      }
    })();
  }, [r, t]), {
    isLoaded: !!d,
    id: n,
    requestId: r,
    error: o,
    resource: d,
    cached: !!(d && d === u)
  };
}
function ys(e, t) {
  const { id: r, isLoaded: i, error: n, resource: s, requestId: o, cached: a } = Hr(
    e,
    t
  );
  return { id: r, isLoaded: i, error: n, manifest: s, requestId: o, cached: a };
}
function vs({ manifest: e, children: t }) {
  return /* @__PURE__ */ x(Te, { value: { manifest: e }, children: t });
}
function Lt({ canvas: e, children: t }) {
  return /* @__PURE__ */ x(Te, { value: { canvas: e }, children: t });
}
function Q(e, t = []) {
  const r = V(), [i, n] = B(() => e(r.getState(), r));
  return K(() => r.subscribe(
    (s) => e(s, r),
    (s) => {
      n(s);
    },
    !1
  ), t), i;
}
const rt = me.createContext([]);
function Br() {
  const e = H(rt);
  return Q(
    (t) => e.map((r) => t.iiif.entities.Canvas[r]).filter(Boolean),
    [e]
  );
}
function ke(e = {}, t = []) {
  const { id: r, selector: i } = e, n = be();
  V();
  const s = r || n.manifest, o = Q(
    (a) => s ? a.iiif.entities.Manifest[s] : void 0,
    [s]
  );
  return E(() => {
    if (o)
      return i ? i(o) : o;
  }, [o, i, ...t]);
}
function gs({ range: e, children: t }) {
  return /* @__PURE__ */ x(Te, { value: { range: e }, children: t });
}
function ms(e, t) {
  for (const r of t.items) {
    if (r.type === "Canvas")
      return r;
    if (r.type === "SpecificResource")
      return r.source;
    if (r.type === "Range") {
      const i = ms(e, e.get(r));
      if (i)
        return i;
    }
  }
  return null;
}
function zr(e, t) {
  var i;
  const r = [];
  for (const n of t.items)
    if (n.type === "SpecificResource" && ((i = n.source) == null ? void 0 : i.type) === "Canvas" && (n.source.id.indexOf("#") !== -1 ? r.push({ id: n.source.id.split("#")[0], type: "Canvas" }) : r.push(n.source)), n.type === "Range" && r.push(...zr(e, e.get(n))), n.type === "SpecificResource") {
      const s = typeof n.source == "string" ? n.source : n.source.id;
      r.push({ id: s, type: "Canvas" });
    }
  return r;
}
function Tc(e, t, r) {
  for (const i of t.structures) {
    const n = Wr(e, e.get(i), r);
    if (n)
      return n;
  }
  return null;
}
function Wr(e, t, r) {
  var i, n, s;
  for (const o of t.items) {
    const a = (n = (i = o == null ? void 0 : o.source) == null ? void 0 : i.id) == null ? void 0 : n.split("#")[0];
    if (o.type === "SpecificResource" && o.source === r || o.type === "SpecificResource" && ((s = o.source) == null ? void 0 : s.type) === "Canvas" && r === a)
      return t;
    if (o.type === "Range") {
      const u = Wr(e, e.get(o), r);
      if (u)
        return u;
    }
  }
  return null;
}
function kc(e, t, r, i = !1) {
  const n = t.behavior, s = r ? e.get(r) : null;
  if (!s)
    return [];
  const o = s.behavior, a = i ? !1 : n.includes("paged"), u = a ? !1 : n.includes("continuous"), d = a || u ? !1 : n.includes("individuals"), l = o.includes("facing-pages"), p = o.includes("non-paged");
  if (l || p || d || i)
    return [{ id: s.id, type: "Canvas" }];
  const [v, m] = Qr(e, t);
  if (u)
    return v;
  const h = v.findIndex((g) => g.id === r);
  if (h === -1)
    return [];
  for (const g of m)
    if (g.includes(h))
      return g.map((b) => v[b]);
  return [{ id: s.id, type: "Canvas" }];
}
function Qr(e, t, { disablePaging: r, skipNonPaged: i } = {}) {
  const n = t.behavior, s = n.includes("paged"), o = s ? !1 : n.includes("continuous"), a = s || o ? !1 : n.includes("individuals"), u = t.type === "Manifest" ? t.items : zr(e, t);
  if (o)
    return [u, [u.map((h, g) => g)]];
  if (a || !s || r)
    return [u, u.map((h, g) => [g])];
  const d = [];
  let l = [];
  const p = () => {
    l.length && (d.push([...l]), l = []);
  };
  let v = 0, m = !1;
  for (let h = 0; h < u.length; h++) {
    const g = e.get(u[h]);
    if (g.behavior.includes("non-paged")) {
      h === v && v++, i || (p(), d.push([h]), p());
      continue;
    }
    if (h === v || g.behavior.includes("facing-pages")) {
      l.length && (m = !0), p(), d.push([h]), p();
      continue;
    }
    if (l.push(h), m) {
      p(), m = !1;
      continue;
    }
    l.length > 1 && p();
  }
  return l.length && p(), [u, d];
}
function bs(e = {}, t = []) {
  const { id: r, selector: i } = e, n = be(), s = r || n.range, o = Q((a) => s ? a.iiif.entities.Range[s] : void 0, [s]);
  return E(() => {
    if (o)
      return i ? i(o) : o;
  }, [o, i, ...t]);
}
function As({ startCanvas: e, disablePaging: t }) {
  var h;
  const r = V(), i = ke(), n = bs(), [s, o] = B(void 0), a = n || i;
  if (!a)
    throw new Error("Nothing selected");
  const [u, d] = E(
    () => Qr(r, a, { disablePaging: t }),
    [r, a]
  ), l = D(
    (g) => {
      const b = d.findIndex((A) => A.includes(g));
      o(b === -1 ? 0 : b);
    },
    [u, d]
  ), p = D(
    (g) => {
      const b = u.findIndex((A) => A.id === g);
      b !== -1 ? l(b) : o(0);
    },
    [u, d]
  ), v = D(() => {
    o((g) => g >= d.length ? g : g + 1);
  }, [d]), m = D(() => {
    o((g) => g <= 0 ? 0 : g - 1);
  }, [d]);
  return typeof s > "u" && (e ? p(e) : o(0)), {
    visibleItems: ((h = d[s]) == null ? void 0 : h.map((g) => u[g].id)) || [],
    cursor: s,
    items: u,
    sequence: d,
    setSequenceIndex: o,
    setCanvasIndex: l,
    setCanvasId: p,
    next: v,
    previous: m
  };
}
const Fe = () => {
}, it = ce({
  setCurrentCanvasId: Fe,
  setCurrentCanvasIndex: Fe,
  nextCanvas: Fe,
  previousCanvas: Fe,
  items: [],
  sequence: [],
  setSequenceIndex: Fe,
  currentSequenceIndex: 0
});
function xs(e) {
  const t = ke(), { cursor: r, visibleItems: i, next: n, sequence: s, items: o, setCanvasIndex: a, setCanvasId: u, previous: d, setSequenceIndex: l } = As({
    startCanvas: e.startCanvas,
    disablePaging: e.pagingEnabled === !1
  }), p = E(
    () => ({
      sequence: s,
      items: o,
      // Extra functions.
      setCurrentCanvasId: u,
      nextCanvas: n,
      previousCanvas: d,
      totalCanvases: o.length,
      setCurrentCanvasIndex: a,
      setSequenceIndex: l,
      currentSequenceIndex: r
    }),
    [s, o, u, n, d, o, a, l, r]
  );
  return t ? /* @__PURE__ */ x(it.Provider, { value: p, children: /* @__PURE__ */ x(rt.Provider, { value: i, children: /* @__PURE__ */ x(Lt, { canvas: i[0], children: e.children }) }) }) : (console.warn("The manifest passed to the provider is not a valid IIIF manifest."), /* @__PURE__ */ x("div", { children: "Sorry, something went wrong." }));
}
function ws(e) {
  const t = ys(e.manifest);
  if (!t)
    return console.warn("The manifest passed to the provider is not a valid IIIF manifest."), /* @__PURE__ */ x("div", { children: "Sorry, something went wrong." });
  if (t.error)
    return /* @__PURE__ */ x("div", { children: t.error.toString() });
  if (!t.isLoaded)
    return /* @__PURE__ */ x("div", { children: "Loading..." });
  const r = /* @__PURE__ */ x(xs, { ...e, children: e.children });
  return /* @__PURE__ */ x(vs, { manifest: t.id, children: e.rangeId ? /* @__PURE__ */ x(gs, { range: e.rangeId, children: r }) : r });
}
function Ss() {
  return H(it);
}
function Cs() {
  return {
    VaultContext: H(tt),
    ResourceContext: H(Et),
    SimpleViewerReactContext: H(it),
    VisibleCanvasReactContext: H(rt)
  };
}
function Ms(e) {
  return /* @__PURE__ */ x(Nr, { vault: e.bridge.VaultContext.vault || void 0, resources: e.bridge.ResourceContext, children: /* @__PURE__ */ x(rt.Provider, { value: e.bridge.VisibleCanvasReactContext, children: /* @__PURE__ */ x(it.Provider, { value: e.bridge.SimpleViewerReactContext, children: e.children }) }) });
}
const se = function(e) {
  return function() {
    const t = { type: e, getType: () => e, toString: () => e };
    return (r, i) => ({
      ...t,
      ...r !== void 0 && { payload: r },
      ...i !== void 0 && { meta: i }
    });
  };
}, Rs = "@iiif/IMPORT_ENTITIES", Is = "@iiif/MODIFY_ENTITY_FIELD", Ts = "@iiif/REORDER_ENTITY_FIELD", ks = "@iiif/ADD_REFERENCE", Os = "@iiif/UPDATE_REFERENCE", Es = "@iiif/REMOVE_REFERENCE", Ps = "@iiif/ADD_METADATA", Ls = "@iiif/REMOVE_METADATA", Fs = "@iiif/UPDATE_METADATA", js = "@iiif/REORDER_METADATA", $s = se(Rs)(), Ds = se(Is)(), qs = se(Ts)(), _s = se(ks)(), Us = se(Es)(), Vs = se(Os)(), Ns = se(Ps)(), Hs = se(Fs)(), Bs = se(Ls)(), zs = se(js)(), pt = {
  importEntities: $s,
  modifyEntityField: Ds,
  reorderEntityField: qs,
  addReference: _s,
  removeReference: Us,
  updateReference: Vs,
  addMetadata: Ns,
  removeMetadata: Bs,
  updateMetadata: Hs,
  reorderMetadata: zs
};
function Ws() {
  const t = V().getStore();
  return E(() => (r) => t.dispatch(r), [t]);
}
function ir(e) {
  return typeof e != "string" && e && e.bindToVault;
}
function Qs() {
  const e = V(), t = ge([]), r = Ws(), i = E(() => `vault://annotation-page/${(/* @__PURE__ */ new Date()).getTime()}/${Math.round(Math.random() * 1e9).toString(16)}`, []);
  hr(() => {
    const a = {
      id: i,
      type: "AnnotationPage",
      behavior: [],
      label: null,
      thumbnail: [],
      summary: null,
      requiredStatement: null,
      metadata: [],
      rights: null,
      provider: [],
      items: [],
      seeAlso: [],
      homepage: [],
      rendering: [],
      service: []
    };
    r(
      pt.importEntities({
        entities: {
          AnnotationPage: {
            [a.id]: a
          }
        }
      })
    );
  }, [i]);
  const n = Q(
    (a) => i ? a.iiif.entities.AnnotationPage[i] : null,
    [i]
  ), s = D(
    (a, u) => {
      if (i) {
        if (ir(a)) {
          const p = a;
          p.__vault || p.bindToVault(e), a = typeof p.source == "string" ? p.source : p.source.id, t.current[a] = p;
        } else
          typeof a != "string" && (a = a.id);
        const d = e.get({ id: i, type: "AnnotationPage" }), l = e.get({ id: a, type: "Annotation" });
        d && l && (d.items.find((p) => p.id === l.id) || r(
          pt.addReference({
            id: i,
            type: "AnnotationPage",
            key: "items",
            reference: {
              id: a,
              type: "Annotation"
            },
            index: u
          })
        ));
      }
    },
    [i]
  ), o = D(
    (a) => {
      i && (ir(a) ? a = typeof a.source == "string" ? a.source : a.source.id : typeof a != "string" && (a = a.id), t.current[a] && t.current[a].beforeRemove(), e.get({ id: i, type: "AnnotationPage" }) && r(
        pt.removeReference({
          id: i,
          type: "AnnotationPage",
          key: "items",
          reference: {
            id: a,
            type: "Annotation"
          }
        })
      ));
    },
    [i]
  );
  return [
    n,
    {
      addAnnotation: s,
      removeAnnotation: o
    }
  ];
}
const Yr = ce(null);
function Ys() {
  const e = H(Yr);
  return [
    e.fullPage,
    {
      addAnnotation: e.addAnnotation,
      removeAnnotation: e.removeAnnotation
    }
  ];
}
function Gs({ children: e }) {
  const [t, { addAnnotation: r, removeAnnotation: i }] = Qs();
  return /* @__PURE__ */ x(
    Yr.Provider,
    {
      value: E(() => ({ fullPage: t, addAnnotation: r, removeAnnotation: i }), [t]),
      children: e
    }
  );
}
function Js({
  width: e,
  style: t,
  height: r,
  error: i,
  resetErrorBoundary: n
}) {
  return /* @__PURE__ */ N("div", { style: { width: e, height: r, minHeight: 500, ...t || {}, background: "#f9f9f9" }, children: [
    /* @__PURE__ */ x("h3", { children: "Error occurred" }),
    /* @__PURE__ */ x("p", { children: i.message }),
    /* @__PURE__ */ x("button", { onClick: n, children: "Reset" })
  ] });
}
const Ft = ce(null);
function Ks() {
  return H(Ft);
}
const Gr = ce(
  () => {
  }
), Jr = ce(
  () => {
  }
);
function Le(e, t, r, i, n = []) {
  const s = H(e === "portal" ? Jr : Gr);
  K(() => (e !== "none" && s(t, r, i), () => {
    s(t, null);
  }), [t, e, s, ...n]);
}
function ue(e = {}, t = []) {
  const { id: r, selector: i } = e, n = be(), s = r || n.canvas, o = Q((a) => s ? a.iiif.entities.Canvas[s] : void 0, [s]);
  return E(() => {
    if (o)
      return i ? i(o) : o;
  }, [o, i, ...t]);
}
const Kr = ce(() => {
});
function Zs(e) {
  const t = ue(), r = H(Kr);
  K(() => t && t.id ? (r(t.id, e), () => r(t.id, -1)) : () => {
  }, [t, e]);
}
function Xs({
  children: e,
  errorFallback: t,
  outerContainerProps: r = {},
  worldScale: i,
  ...n
}) {
  const [s, o] = B(), a = Cs(), u = t || Js, [d, l] = B({}), p = Object.entries(d), [v, m] = B({}), h = Object.entries(v), [g, b] = B({}), A = E(() => i || Math.max(...Object.values(g)), [g]), w = E(() => ({ maxOverZoom: A || 1, ...n.runtimeOptions || {} }), [A, n.runtimeOptions]), C = D((I, L) => {
    b((P) => {
      if (L === -1) {
        const { [I]: M, ...$ } = P;
        return $;
      }
      return { ...P, [I]: L };
    });
  }, []), T = D((I, L, P) => {
    l(({ [I]: M, ...$ }) => L ? {
      ...$,
      [I]: { element: L, props: P }
    } : $);
  }, []), j = D((I, L, P) => {
    m(({ [I]: M, ...$ }) => L ? {
      ...$,
      [I]: { element: L, props: P }
    } : $);
  }, []);
  return /* @__PURE__ */ N(wn, { resetKeys: [], fallbackRender: (I) => /* @__PURE__ */ x(u, { ...n, ...I }), children: [
    /* @__PURE__ */ x(
      un,
      {
        ...n,
        containerProps: { style: { position: "relative" }, ...n.containerProps || {} },
        htmlChildren: /* @__PURE__ */ x(Me, { children: p.map(([I, { element: L, props: P }]) => /* @__PURE__ */ x(me.Fragment, { children: /* @__PURE__ */ x(L, { ...P || {} }) }, I)) }),
        onCreated: (I) => {
          o(I), n.onCreated && n.onCreated(I);
        },
        runtimeOptions: w,
        children: /* @__PURE__ */ x(Ft.Provider, { value: s, children: /* @__PURE__ */ x(Kr.Provider, { value: C, children: /* @__PURE__ */ x(Gr.Provider, { value: T, children: /* @__PURE__ */ x(Jr.Provider, { value: j, children: /* @__PURE__ */ x(Ms, { bridge: a, children: /* @__PURE__ */ x(ln.Provider, { value: n.mode || "explore", children: /* @__PURE__ */ x(Gs, { children: e }) }) }) }) }) }) })
      }
    ),
    /* @__PURE__ */ x("div", { children: h.map(([I, { element: L, props: P }]) => /* @__PURE__ */ x(me.Fragment, { children: /* @__PURE__ */ x(L, { ...P || {} }) }, I)) })
  ] });
}
const He = {}, Zr = {
  get(e) {
    return e;
  },
  setMetaValue([e, t, r], i) {
    const n = Zr.getResourceMeta(e, t), s = n ? n[r] : void 0, o = typeof i == "function" ? i(s) : i;
    He[e] = {
      ...He[e] || {},
      [t]: {
        ...(He[e] || {})[t] || {},
        [r]: o
      }
    };
  },
  getResourceMeta: (e, t) => {
    const r = He[e];
    if (r)
      return t ? r[t] : r;
  }
};
function Xr(e = Zr) {
  return {
    addEventListener(t, r, i, n) {
      if (t)
        return e.setMetaValue(
          [t.id, "eventManager", r],
          (s) => {
            const o = s || [];
            for (const a of o)
              if (a.callback === i)
                return o;
            return [...o, { callback: i, scope: n }];
          }
        ), i;
    },
    removeEventListener(t, r, i) {
      t && e.setMetaValue(
        [t.id, "eventManager", r],
        (n) => (n || []).filter((s) => s.callback !== i)
      );
    },
    getListenersAsProps(t, r) {
      const i = typeof t == "string" ? { id: t } : t;
      if (!i || !i.id)
        return {};
      const n = e.getResourceMeta(i.id, "eventManager"), s = {};
      if (n && i)
        for (const o of Object.keys(n))
          s[o] = (a) => {
            const u = e.get(i);
            for (const { callback: d, scope: l } of n[o] || [])
              (!l || r && l.indexOf(r) !== -1) && d(a, u);
          };
      return s;
    }
  };
}
function ei(e, t) {
  const r = V(), i = E(() => Xr(r), [r]), n = Q(() => e && e.id ? r.getResourceMeta(e.id, "eventManager") : null, [e]);
  return E(() => e ? i.getListenersAsProps(e, t) : {}, [n, e, r, t]);
}
const Be = {}, ti = {
  get(e) {
    return e;
  },
  setMetaValue([e, t, r], i) {
    const n = ti.getResourceMeta(e, t), s = n ? n[r] : void 0, o = typeof i == "function" ? i(s) : i;
    Be[e] = {
      ...Be[e] || {},
      [t]: {
        ...(Be[e] || {})[t] || {},
        [r]: o
      }
    };
  },
  getResourceMeta: (e, t) => {
    const r = Be[e];
    if (r)
      return t ? r[t] : r;
  }
};
function jt(e = ti) {
  return {
    applyStyles(t, r, i) {
      const n = typeof t == "string" ? t : t.id;
      return e.setMetaValue([n, "styles", r], i);
    },
    getAppliedStyles(t) {
      const r = typeof t == "string" ? t : t.id;
      return e.getResourceMeta(r, "styles");
    }
  };
}
function et(e, t) {
  const r = V(), i = E(() => jt(r), [r]);
  return Q(() => {
    if (!e)
      return null;
    const n = i.getAppliedStyles(e.id);
    return n ? t ? n[t] : n : void 0;
  }, [e, t]);
}
var eo = Object.defineProperty, to = (e, t, r) => t in e ? eo(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Qe = (e, t, r) => (to(e, typeof t != "symbol" ? t + "" : t, r), r), ro = /* @__PURE__ */ function() {
  function e(t, r) {
    var i = [], n = !0, s = !1, o = void 0;
    try {
      for (var a = t[Symbol.iterator](), u; !(n = (u = a.next()).done) && (i.push(u.value), !(r && i.length === r)); n = !0)
        ;
    } catch (d) {
      s = !0, o = d;
    } finally {
      try {
        !n && a.return && a.return();
      } finally {
        if (s)
          throw o;
      }
    }
    return i;
  }
  return function(t, r) {
    if (Array.isArray(t))
      return t;
    if (Symbol.iterator in Object(t))
      return e(t, r);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
}(), $e = Math.PI * 2, dt = function(e, t, r, i, n, s, o) {
  var a = e.x, u = e.y;
  a *= t, u *= r;
  var d = i * a - n * u, l = n * a + i * u;
  return {
    x: d + s,
    y: l + o
  };
}, io = function(e, t) {
  var r = t === 1.5707963267948966 ? 0.551915024494 : t === -1.5707963267948966 ? -0.551915024494 : 1.3333333333333333 * Math.tan(t / 4), i = Math.cos(e), n = Math.sin(e), s = Math.cos(e + t), o = Math.sin(e + t);
  return [{
    x: i - n * r,
    y: n + i * r
  }, {
    x: s + o * r,
    y: o - s * r
  }, {
    x: s,
    y: o
  }];
}, nr = function(e, t, r, i) {
  var n = e * i - t * r < 0 ? -1 : 1, s = e * r + t * i;
  return s > 1 && (s = 1), s < -1 && (s = -1), n * Math.acos(s);
}, no = function(e, t, r, i, n, s, o, a, u, d, l, p) {
  var v = Math.pow(n, 2), m = Math.pow(s, 2), h = Math.pow(l, 2), g = Math.pow(p, 2), b = v * m - v * g - m * h;
  b < 0 && (b = 0), b /= v * g + m * h, b = Math.sqrt(b) * (o === a ? -1 : 1);
  var A = b * n / s * p, w = b * -s / n * l, C = d * A - u * w + (e + r) / 2, T = u * A + d * w + (t + i) / 2, j = (l - A) / n, I = (p - w) / s, L = (-l - A) / n, P = (-p - w) / s, M = nr(1, 0, j, I), $ = nr(j, I, L, P);
  return a === 0 && $ > 0 && ($ -= $e), a === 1 && $ < 0 && ($ += $e), [C, T, M, $];
}, so = function(e) {
  var t = e.px, r = e.py, i = e.cx, n = e.cy, s = e.rx, o = e.ry, a = e.xAxisRotation, u = a === void 0 ? 0 : a, d = e.largeArcFlag, l = d === void 0 ? 0 : d, p = e.sweepFlag, v = p === void 0 ? 0 : p, m = [];
  if (s === 0 || o === 0)
    return [];
  var h = Math.sin(u * $e / 360), g = Math.cos(u * $e / 360), b = g * (t - i) / 2 + h * (r - n) / 2, A = -h * (t - i) / 2 + g * (r - n) / 2;
  if (b === 0 && A === 0)
    return [];
  s = Math.abs(s), o = Math.abs(o);
  var w = Math.pow(b, 2) / Math.pow(s, 2) + Math.pow(A, 2) / Math.pow(o, 2);
  w > 1 && (s *= Math.sqrt(w), o *= Math.sqrt(w));
  var C = no(t, r, i, n, s, o, l, v, h, g, b, A), T = ro(C, 4), j = T[0], I = T[1], L = T[2], P = T[3], M = Math.abs(P) / ($e / 4);
  Math.abs(1 - M) < 1e-7 && (M = 1);
  var $ = Math.max(Math.ceil(M), 1);
  P /= $;
  for (var ie = 0; ie < $; ie++)
    m.push(io(L, P)), L += P;
  return m.map(function(Z) {
    var U = dt(Z[0], s, o, g, h, j, I), z = U.x, ee = U.y, ne = dt(Z[1], s, o, g, h, j, I), xe = ne.x, O = ne.y, W = dt(Z[2], s, o, g, h, j, I), X = W.x, de = W.y;
    return { x1: z, y1: ee, x2: xe, y2: O, x: X, y: de };
  });
};
function ri(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var oo = co, ht = { a: 7, c: 6, h: 1, l: 2, m: 2, q: 4, s: 4, t: 2, v: 1, z: 0 }, ao = /([astvzqmhlc])([^astvzqmhlc]*)/ig;
function co(e) {
  var t = [];
  return e.replace(ao, function(r, i, n) {
    var s = i.toLowerCase();
    for (n = lo(n), s == "m" && n.length > 2 && (t.push([i].concat(n.splice(0, 2))), s = "l", i = i == "m" ? "l" : "L"); ; ) {
      if (n.length == ht[s])
        return n.unshift(i), t.push(n);
      if (n.length < ht[s])
        throw new Error("malformed path data");
      t.push([i].concat(n.splice(0, ht[s])));
    }
  }), t;
}
var uo = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;
function lo(e) {
  var t = e.match(uo);
  return t ? t.map(Number) : [];
}
const fo = /* @__PURE__ */ ri(oo);
var po = ho;
function ho(e) {
  var t = 0, r = 0, i = 0, n = 0;
  return e.map(function(s) {
    s = s.slice();
    var o = s[0], a = o.toUpperCase();
    if (o != a)
      switch (s[0] = a, o) {
        case "a":
          s[6] += i, s[7] += n;
          break;
        case "v":
          s[1] += n;
          break;
        case "h":
          s[1] += i;
          break;
        default:
          for (var u = 1; u < s.length; )
            s[u++] += i, s[u++] += n;
      }
    switch (a) {
      case "Z":
        i = t, n = r;
        break;
      case "H":
        i = s[1];
        break;
      case "V":
        n = s[1];
        break;
      case "M":
        i = t = s[1], n = r = s[2];
        break;
      default:
        i = s[s.length - 2], n = s[s.length - 1];
    }
    return s;
  });
}
const yo = /* @__PURE__ */ ri(po);
function vo(e) {
  const t = fo(e), r = yo(t);
  let i, n = 0, s = 0, o = 0, a = 0, u, d, l = 0, p = 0;
  const v = [];
  for (let m = 0; m < r.length; m++) {
    let h = r[m];
    const g = h[0];
    switch (g) {
      case "M":
        n = h[1], s = h[2];
        break;
      case "H":
        h = ["L", h[1], s];
        break;
      case "V":
        h = ["L", n, h[1]];
        break;
      case "S":
        {
          let b = l, A = p;
          (i === "C" || i == "S") && (b += b - o, A += A - a), h = ["C", b, A, h[1], h[2], h[3], h[4]];
        }
        break;
      case "T":
        i === "Q" || i == "T" ? (u = l * 2 - u, d = p * 2 - d) : (u = l, d = p), h = ["Q", u, d, h[1], h[2]];
        break;
      case "Q":
        u = h[1], d = h[2];
        break;
      case "A":
        {
          const b = so({
            px: l,
            py: p,
            cx: h[6],
            cy: h[7],
            rx: h[1],
            ry: h[2],
            xAxisRotation: h[3],
            largeArcFlag: h[4],
            sweepFlag: h[5]
          });
          if (!b.length)
            continue;
          for (const [A, w] of b.entries())
            h = ["C", w.x1, w.y1, w.x2, w.y2, w.x, w.y], A < b.length - 1 && v.push(h);
          h = h;
        }
        break;
      case "Z":
        h = ["L", n, s];
        break;
    }
    i = g, l = h[h.length - 2], p = h[h.length - 1], ["C", "Q", "A"].indexOf(g) > -1 ? (o = h[h.length - 4], a = h[h.length - 3]) : (o = l, a = p), v.push(h);
  }
  return v;
}
/** Code to "flatten" quadratic and cubic Bézier curves to polylines.
 *
 * All code in this module is based on JavaScript code by Raph Levien, published on his blog at
 * https://raphlinus.github.io/.
 * I merely changed the structure a bit, removed some unneeded parts and added some comments and type hints.
 *
 * Flattening of quadratic Bézier curves:
 * - Article: https://raphlinus.github.io/graphics/curves/2019/12/23/flatten-quadbez.html
 * - Code: https://github.com/raphlinus/raphlinus.github.io/blob/master/_posts/2019-12-23-flatten-quadbez.md?plain=1#L73-L212
 *
 * Flattening of cubic Bézier curves: https://levien.com/tmp/flatten.html
 *
 * Note that the code in this module has a different license than the rest of the package,
 * due to the inclusion of Apache-licensed third party code.
 *
 * @license
 * Copyright 2022 Johannes Baiter <johannes.baiter@gmail.com>
 * Copyright 2019, 2022 Raph Levien <raph.levien@gmail.com>
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function go(e, t, r, i = 1) {
  return new ii(e, t, r).subdivide(i);
}
function mo(e, t, r, i, n = 1) {
  return new $t(
    new Float64Array([e.x, e.y, t.x, t.y, r.x, r.y, i.x, i.y])
  ).subdivide(n);
}
function bo(e) {
  return e.x * e.x + e.y * e.y;
}
function De(e) {
  return e / (1 - 0.67 + Math.pow(Math.pow(0.67, 4) + 0.25 * e * e, 0.25));
}
function Ee(e) {
  return e * (1 - 0.39 + Math.sqrt(0.39 * 0.39 + 0.25 * e * e));
}
class ii {
  constructor(t, r, i) {
    Qe(this, "start"), Qe(this, "control"), Qe(this, "end"), this.start = t, this.control = r, this.end = i;
  }
  eval(t) {
    const r = 1 - t;
    return {
      x: this.start.x * r * r + 2 * this.control.x * r * t + this.end.x * t * t,
      y: this.start.y * r * r + 2 * this.control.y * r * t + this.end.y * t * t
    };
  }
  mapToBasic() {
    const { x: t, y: r } = this.start, { x: i, y: n } = this.control, { x: s, y: o } = this.end, a = 2 * i - t - s, u = 2 * n - r - o, d = (i - t) * a + (n - r) * u, l = (s - i) * a + (o - n) * u, p = (s - t) * u - (o - r) * a, v = d / p, m = l / p, h = Math.abs(p) / (Math.hypot(a, u) * Math.abs(m - v));
    return { x0: t, x2: s, scale: h, cross: p };
  }
  subdivide(t) {
    const r = this.mapToBasic(), i = De(r.x0), n = De(r.x2), s = 0.5 * Math.abs(n - i) * Math.sqrt(r.scale / t), o = Math.ceil(s), a = Ee(i), u = Ee(n), d = [0];
    for (let l = 1; l < o; l++) {
      const p = (Ee(i + (n - i) * l / o) - a) / (u - a);
      d.push(p);
    }
    return d.push(1), d.map((l) => this.eval(l));
  }
}
class $t {
  /// Argument is array of coordinate values [x0, y0, x1, y1, x2, y2, x3, y3].
  constructor(t) {
    Qe(this, "c"), this.c = t;
  }
  weightsum(t, r, i, n) {
    const s = t * this.c[0] + r * this.c[2] + i * this.c[4] + n * this.c[6], o = t * this.c[1] + r * this.c[3] + i * this.c[5] + n * this.c[7];
    return { x: s, y: o };
  }
  eval(t) {
    const r = 1 - t, i = r * r * r, n = 3 * r * r * t, s = 3 * r * t * t, o = t * t * t;
    return this.weightsum(i, n, s, o);
  }
  deriv(t) {
    const r = 1 - t, i = -3 * r * r, n = 3 * t * t, s = -6 * t * r - i, o = 6 * t * r - n;
    return this.weightsum(i, s, o, n);
  }
  // quadratic bezier with matching endpoints and minimum max vector error
  midpoint_quadbez() {
    const t = this.weightsum(-0.25, 0.75, 0.75, -0.25);
    return new ii({ x: this.c[0], y: this.c[1] }, t, { x: this.c[6], y: this.c[7] });
  }
  subsegment(t, r) {
    const i = new Float64Array(8), n = this.eval(t), s = this.eval(r);
    i[0] = n.x, i[1] = n.y;
    const o = (r - t) / 3, a = this.deriv(t);
    i[2] = n.x + o * a.x, i[3] = n.y + o * a.y;
    const u = this.deriv(r);
    return i[4] = s.x - o * u.x, i[5] = s.y - o * u.y, i[6] = s.x, i[7] = s.y, new $t(i);
  }
  // Very fancy subdivision scheme
  subdivide(t) {
    const r = 0.1 * t, i = t - r, n = Math.sqrt(i), s = bo(this.weightsum(1, -3, 3, -1)), o = Math.ceil(Math.pow(s / (432 * r * r), 1 / 6)), a = [];
    let u = 0;
    for (let h = 0; h < o; h++) {
      const g = h / o, b = (h + 1) / o, A = this.subsegment(g, b).midpoint_quadbez(), w = A.mapToBasic(), C = De(w.x0), T = De(w.x2), j = Math.sqrt(w.scale);
      let I = Math.abs(T - C) * j;
      if (Math.sign(w.x0) != Math.sign(w.x2)) {
        const L = n / j, P = n * Math.abs(T - C) / De(L);
        I = Math.max(I, P);
      }
      a.push({
        quad: A,
        a0: C,
        a2: T,
        val: I
      }), u += I;
    }
    const d = 0.5 * u / n, l = Math.ceil(d), p = [{ x: this.c[0], y: this.c[1] }];
    let v = 0, m = 0;
    for (let h = 1; h < l; h++) {
      const g = u * h / l;
      for (; v + a[m].val < g; )
        v += a[m].val, m++;
      const b = a[m].a0, A = a[m].a2, w = Ee(b), C = Ee(A), T = b + (A - b) * (g - v) / a[m].val, j = (Ee(T) - w) / (C - w);
      p.push(a[m].quad.eval(j));
    }
    return p.push({ x: this.c[6], y: this.c[7] }), p;
  }
}
const Ao = /&?(xywh=)?(pixel:|percent:|pct:)?([0-9]+(?:\.[0-9]+)?),([0-9]+(?:\.[0-9]+)?),([0-9]+(?:\.[0-9]+)?),([0-9]+(?:\.[0-9]+)?)/, xo = /&?(t=)(npt:)?([0-9]+(.[0-9]+)?)?(,([0-9]+(.[0-9]+)?))?/, sr = /^rgba\((\d+),(\d+),(\d+),([0-9.]+)\)$/;
function Ye(e, {
  domParser: t,
  svgPreprocessor: r,
  iiifRenderingHints: i
} = {}) {
  if (Array.isArray(e))
    return te(
      e.reduce(
        (n, s) => {
          const {
            selector: o,
            selectors: a,
            iiifRenderingHints: u
          } = Ye(s, { domParser: t, svgPreprocessor: r, iiifRenderingHints: i });
          return o && (n.selector || (n.selector = o), n.selectors.push(...a)), u && (n.iiifRenderingHints = n.iiifRenderingHints || { type: "ImageApiSelector" }, Object.assign(n.iiifRenderingHints, u)), n;
        },
        {
          selector: null,
          selectors: [],
          iiifRenderingHints: i
        }
      )
    );
  if (!e)
    return te({
      selector: null,
      selectors: [],
      iiifRenderingHints: i
    });
  if (typeof e == "string") {
    const [n, s] = e.split("#");
    return s ? Ye(
      { type: "FragmentSelector", value: s },
      { svgPreprocessor: r, iiifRenderingHints: i, domParser: t }
    ) : te({
      selector: null,
      selectors: [],
      iiifRenderingHints: i
    });
  }
  if (e.type && e.type === "PointSelector" && (e.t || e.t === 0)) {
    const n = {
      type: "TemporalSelector",
      temporal: {
        startTime: e.t
      }
    };
    return te({
      selector: n,
      selectors: [n],
      iiifRenderingHints: i
    });
  }
  if (Mo(e)) {
    const n = [];
    if (e.region) {
      const s = Ye(
        { type: "FragmentSelector", value: "xywh=" + e.region },
        { domParser: t, svgPreprocessor: r, iiifRenderingHints: i }
      );
      n.push(...s.selectors);
    }
    return te({
      selector: n[0],
      selectors: n,
      iiifRenderingHints: i ? { ...i, ...e } : e
    });
  }
  if (e.type === "FragmentSelector") {
    const n = Ao.exec(e.value);
    if (n) {
      const o = {
        type: "BoxSelector",
        spatial: {
          unit: n[2] === "percent:" || n[2] === "pct:" ? "percent" : "pixel",
          x: parseFloat(n[3]),
          y: parseFloat(n[4]),
          width: parseFloat(n[5]),
          height: parseFloat(n[6])
        }
      };
      return te({
        selector: o,
        selectors: [o],
        iiifRenderingHints: i
      });
    }
    const s = e.value.match(xo);
    if (s) {
      const o = {
        type: "TemporalSelector",
        temporal: {
          startTime: s[4] ? parseFloat(s[4]) : 0,
          endTime: s[7] ? parseFloat(s[7]) : void 0
        }
      };
      return te({
        selector: o,
        selectors: [o],
        iiifRenderingHints: i
      });
    }
    return te({
      selector: null,
      selectors: [],
      iiifRenderingHints: i
    });
  }
  if (e.type === "SvgSelector" && "value" in e) {
    t || (typeof window < "u" ? t = new window.DOMParser() : console.warn(
      "No DOMParser available, cannot parse SVG selector, `points`, `spatial` and `style` will be unavailable and the SVG will not be normalized."
    ));
    let n = [], s, o, a = (r == null ? void 0 : r(e.value)) ?? e.value, u;
    if (t) {
      const l = t.parseFromString(e.value, "image/svg+xml").querySelector("svg");
      if (!l)
        return console.warn(`Illegal SVG selector: ${e.value}`), te({
          selector: null,
          selectors: [],
          iiifRenderingHints: i
        });
      const p = ni(l);
      p && (n = p.points, u = p.shapeType, s = [
        Math.min(...n.map((v) => v[0])),
        // llx
        Math.min(...n.map((v) => v[1])),
        // lly
        Math.max(...n.map((v) => v[0])),
        // urx
        Math.max(...n.map((v) => v[1]))
        // ury
      ], { style: o, svg: a } = Co(p.element) ?? { svg: a });
    }
    const d = {
      type: "SvgSelector",
      svg: a,
      svgShape: u,
      style: o,
      points: n.length ? n : void 0,
      spatial: s ? { unit: "pixel", x: s[0], y: s[1], width: s[2] - s[0], height: s[3] - s[1] } : void 0
    };
    return te({
      selector: d,
      selectors: [d],
      iiifRenderingHints: i
    });
  }
  return te({
    selector: null,
    selectors: [],
    iiifRenderingHints: i
  });
}
function wo(e) {
  const t = e.map((i) => i[0]).reduce(
    (i, n) => (i[n] += 1, i),
    { C: 0, Q: 0, L: 0, M: 0 }
  ), r = new Set(e.map((i) => i[0]));
  if (t.C > 0 || t.Q > 0)
    return "path";
  if (t.L > 0 && (r.size === 1 || r.size === 2 && r.has("M"))) {
    if (t.L === 4)
      return "rect";
    const i = e.slice(-1)[0];
    return e[0][0] === "M" && i[0] === "L" && i[1] == e[0][1] && i[2] === e[0][2] || i[1] === 0 && i[2] === 0 ? "polygon" : "polyline";
  }
  return "path";
}
function ni(e) {
  var t;
  for (const r of Array.from(e.children))
    switch (r == null ? void 0 : r.tagName.toLowerCase()) {
      case "g":
        {
          const i = ni(r);
          if (i)
            return i;
        }
        continue;
      case "path": {
        const i = r.getAttribute("d");
        if (!i)
          continue;
        const n = vo(i);
        return { element: r, points: So(n), shapeType: wo(n) };
      }
      case "circle": {
        const i = parseFloat(r.getAttribute("cx") ?? "0"), n = parseFloat(r.getAttribute("cy") ?? "0"), s = parseFloat(r.getAttribute("r") ?? "0");
        if (!s)
          continue;
        const o = [];
        for (let a = 0; a <= 360; a += 12) {
          const u = a * Math.PI / 180;
          o.push([i + s * Math.cos(u), n + s * Math.sin(u)]);
        }
        return { element: r, points: o, shapeType: "circle" };
      }
      case "ellipse": {
        const i = parseFloat(r.getAttribute("cx") ?? "0"), n = parseFloat(r.getAttribute("cy") ?? "0"), s = parseFloat(r.getAttribute("rx") ?? "0"), o = parseFloat(r.getAttribute("ry") ?? "0");
        if (!s && !o)
          continue;
        const a = [];
        for (let u = 0; u <= 360; u += 12) {
          const d = Math.tan(u / 360 * Math.PI), l = s * (1 - d ** 2) / (1 + d ** 2), p = o * 2 * d / (1 + d ** 2);
          a.push([i + l, n + p]);
        }
        return { element: r, points: a, shapeType: "ellipse" };
      }
      case "line": {
        const i = parseFloat(r.getAttribute("x0") ?? "0"), n = parseFloat(r.getAttribute("y0") ?? "0"), s = parseFloat(r.getAttribute("x1") ?? "0"), o = parseFloat(r.getAttribute("y1") ?? "0");
        if (i === s && n === o)
          continue;
        return {
          element: r,
          points: [
            [i, n],
            [s, o]
          ],
          shapeType: "polyline"
        };
      }
      case "polygon":
      case "polyline": {
        const i = ((t = r.getAttribute("points")) == null ? void 0 : t.split(" ").map((s) => s.split(",").map(parseFloat))) ?? [];
        if (!i.length)
          continue;
        let n = "polyline";
        return r.tagName.toLowerCase() === "polygon" && (i.push(i[0]), n = "polygon"), { element: r, points: i, shapeType: n };
      }
      case "rect": {
        const i = parseFloat(r.getAttribute("x") ?? "0"), n = parseFloat(r.getAttribute("y") ?? "0"), s = parseFloat(r.getAttribute("width") ?? "0"), o = parseFloat(r.getAttribute("height") ?? "0");
        if (!s || !o)
          continue;
        return {
          element: r,
          points: [
            [i, n],
            [i + s, n],
            [i + s, n + o],
            [i, n + o],
            [i, n]
          ],
          shapeType: "rect"
        };
      }
      default:
        continue;
    }
  return null;
}
function So(e) {
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const i = t[t.length - 1] ?? [0, 0], n = e[r];
    switch (n[0]) {
      case "M":
      case "L":
        t.push([n[1], n[2]]);
        continue;
      case "C":
        t.push(
          ...mo(
            { x: i[0], y: i[1] },
            { x: n[1], y: n[2] },
            { x: n[3], y: n[4] },
            { x: n[5], y: n[6] }
          ).map((s) => [s.x, s.y]).slice(1)
          // skip first point, already part of output
        );
        continue;
      case "Q":
        t.push(
          ...go(
            { x: i[0], y: i[1] },
            { x: n[1], y: n[2] },
            { x: n[3], y: n[4] }
          ).map((s) => [s.x, s.y]).slice(1)
          // skip first point, already part of output
        );
        continue;
    }
  }
  return t;
}
function Co(e) {
  const t = {};
  if (e.hasAttribute("fill") ? (t.fill = e.getAttribute("fill"), e.removeAttribute("fill")) : e.style.fill && (t.fill = e.style.fill), t.fill) {
    const i = sr.exec(t.fill);
    i && (t.fillOpacity = parseFloat(i[4]), t.fill = `rgb(${i[1]}, ${i[2]}, ${i[3]})`);
  }
  if (e.hasAttribute("fill-opacity") ? (t.fillOpacity = parseFloat(e.getAttribute("fill-opacity")), e.removeAttribute("fill-opacity")) : e.style.fillOpacity && (t.fillOpacity = parseFloat(e.style.fillOpacity)), e.hasAttribute("stroke") ? (t.stroke = e.getAttribute("stroke"), e.removeAttribute("stroke")) : e.style.stroke && (t.stroke = e.style.stroke), t.stroke) {
    const i = sr.exec(t.stroke);
    i && (t.strokeOpacity = parseFloat(i[4]), t.stroke = `rgb(${i[1]}, ${i[2]}, ${i[3]})`);
  }
  e.hasAttribute("stroke-opacity") ? (t.strokeOpacity = parseFloat(e.getAttribute("stroke-opacity")), e.removeAttribute("stroke-opacity")) : e.style.strokeOpacity && (t.strokeOpacity = parseFloat(e.style.strokeOpacity)), e.hasAttribute("stroke-width") ? (t.strokeWidth = e.getAttribute("stroke-width"), e.removeAttribute("stroke-width")) : e.style.strokeWidth && (t.strokeWidth = e.style.strokeWidth), e.hasAttribute("stroke-dasharray") ? (t.strokeDasharray = e.getAttribute("stroke-dasharray"), e.removeAttribute("stroke-dasharray")) : e.style.strokeDasharray && (t.strokeDasharray = e.style.strokeDasharray);
  let r = e;
  for (; r.tagName.toLowerCase() !== "svg"; )
    if (r = r.parentElement, r === null)
      throw new Error("Could not find root SVG element");
  return { svg: r.outerHTML, style: Object.keys(t).length > 0 ? t : void 0 };
}
function Mo(e) {
  return !!e && e.type === "iiif:ImageApiSelector" && e.type === "iiif:ImageApiSelector";
}
function te(e) {
  if (e.iiifRenderingHints) {
    const t = e.iiifRenderingHints;
    if (t.rotation) {
      const r = Ro(t.rotation);
      if (r)
        if (e.selectors.length)
          for (const i of e.selectors)
            i.rotation = r;
        else
          e.selectors.push({
            type: "RotationSelector",
            rotation: r
          });
    }
  } else
    delete e.iiifRenderingHints;
  return e;
}
function Ro(e) {
  let t = parseFloat(e);
  return t && e.startsWith("!") && (t = 360 - t), t && (t = t % 360), t !== t ? 0 : t || 0;
}
function Re(e, t = {}) {
  if (Array.isArray(e))
    return Re(e[0]);
  if (typeof e == "string") {
    const [r, i] = e.split("#");
    return i ? Re({
      type: "SpecificResource",
      source: { id: r, type: "Unknown" },
      selector: {
        type: "FragmentSelector",
        value: i
      }
    }) : {
      type: "SpecificResource",
      source: { id: r, type: t.typeMap && t.typeMap[r] || "Unknown" },
      selector: null,
      selectors: []
    };
  }
  if (e.type === "Choice" || e.type === "List" || e.type === "Composite" || e.type === "Independents")
    return Re(e.items[0]);
  if (e.type === "SpecificResource") {
    e.source.type === "Canvas" && e.source.partOf && typeof e.source.partOf == "string" && (e.source.partOf = [
      {
        id: e.source.partOf,
        type: "Manifest"
      }
    ]);
    const { selector: r, selectors: i } = e.selector ? Ye(e.selector, t) : { selector: null, selectors: [] };
    return {
      type: "SpecificResource",
      source: e.source,
      selector: r,
      selectors: i
    };
  }
  if (e.id) {
    e.type === "Canvas" && e.partOf && typeof e.partOf == "string" && (e.partOf = [
      {
        id: e.partOf,
        type: "Manifest"
      }
    ]);
    const [r, i] = e.id.split("#");
    return i ? Re({
      type: "SpecificResource",
      source: {
        ...e,
        id: r
      },
      selector: {
        type: "FragmentSelector",
        value: i
      }
    }) : {
      type: "SpecificResource",
      source: {
        ...e,
        id: r
      },
      selector: null,
      selectors: []
    };
  }
  return {
    type: "SpecificResource",
    source: e,
    selector: null,
    selectors: []
  };
}
function si(e = {}, t = []) {
  const { id: r, selector: i } = e, n = be(), s = V(), o = r || n.annotation, a = Q(
    (d) => o ? d.iiif.entities.Annotation[o] : void 0,
    [o]
  ), u = Q(
    (d) => a && a.body ? a.body.map((l) => l ? l.type === "SpecificResource" ? {
      ...l,
      source: s.get(l)
    } : l ? d.iiif.entities[l.type][l.id] : null : null).filter(Boolean) : [],
    [a]
  );
  return E(() => {
    if (!a)
      return;
    const d = {
      ...a,
      body: u,
      target: Re(a.target, { typeMap: s.getState().iiif.mapping })
    };
    return i ? i(d) : d;
  }, [a, i, u, ...t]);
}
const oi = ({
  id: e,
  style: t,
  className: r,
  interactive: i
}) => {
  const n = si({ id: e }), s = et(n, "atlas"), o = et(n, "html"), a = ei(n, ["atlas"]), u = ue(), d = E(() => fn(t, s), [t, s]);
  return u && n && n.target && n.target.selector && n.target.selector.type === "BoxSelector" && n.target.source && (n.target.source.id === u.id || n.target.source === u.id) ? /* @__PURE__ */ x(
    pn,
    {
      id: n.id,
      isEditing: !0,
      region: n.target.selector.spatial,
      style: d,
      className: (o == null ? void 0 : o.className) || r,
      interactive: !!(o != null && o.href || i),
      href: (o == null ? void 0 : o.href) || null,
      title: (o == null ? void 0 : o.title) || null,
      hrefTarget: (o == null ? void 0 : o.target) || null,
      onClick: () => {
      },
      ...a
    }
  ) : null;
};
function Io(e = {}, t = []) {
  const { id: r, selector: i } = e, n = be(), s = r || n.annotationPage, o = Q(
    (a) => s ? a.iiif.entities.AnnotationPage[s] : void 0,
    [s]
  );
  return E(() => {
    if (o)
      return i ? i(o) : o;
  }, [o, ...t]);
}
const It = ({
  className: e,
  page: t
}) => {
  var s;
  const r = Io({ id: t.id }) || t, i = et(r, "atlas"), n = et(r, "html");
  return Q((o) => r.id ? o.iiif.entities.AnnotationPage[r.id] : null, []), /* @__PURE__ */ x(Ke, { children: (s = r.items) == null ? void 0 : s.map((o) => /* @__PURE__ */ x(
    oi,
    {
      id: o.id,
      style: i,
      className: (n == null ? void 0 : n.className) || e
    },
    o.id
  )) });
};
function ai({
  id: e,
  image: t,
  thumbnail: r,
  isStatic: i,
  x: n = 0,
  y: s = 0,
  children: o,
  selector: a,
  onClick: u,
  enableSizes: d
}) {
  var p, v;
  const l = E(() => {
    if (!(!a || a.spatial.x === 0 && a.spatial.y === 0))
      return a.spatial;
  }, [a]);
  return /* @__PURE__ */ x(
    "world-object",
    {
      x: n + t.target.spatial.x,
      y: s + t.target.spatial.y,
      width: t.target.spatial.width,
      height: t.target.spatial.height,
      onClick: u,
      children: t.service ? /* @__PURE__ */ N(Ke, { children: [
        /* @__PURE__ */ x(
          dn,
          {
            tiles: {
              id: t.service.id || t.service["@id"] || "unknown",
              height: t.height,
              width: t.width,
              imageService: t.service,
              thumbnail: r && r.type === "fixed" ? r : void 0
            },
            enableSizes: d,
            x: 0,
            y: 0,
            width: (p = t.target) == null ? void 0 : p.spatial.width,
            height: (v = t.target) == null ? void 0 : v.spatial.height,
            crop: l
          }
        ),
        o
      ] }, "service") : /* @__PURE__ */ N(Ke, { children: [
        /* @__PURE__ */ x(
          "world-image",
          {
            onClick: u,
            uri: t.id,
            target: { x: 0, y: 0, width: t.target.spatial.width, height: t.target.spatial.height },
            display: t.width && t.height ? {
              width: t.width,
              height: t.height
            } : void 0,
            crop: l
          }
        ),
        o
      ] }, "no-service")
    },
    e + (t.service ? "server" : "no-service")
  );
}
var To = Object.defineProperty, ko = (e, t, r) => t in e ? To(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Ge = (e, t, r) => (ko(e, typeof t != "symbol" ? t + "" : t, r), r), Oo = /* @__PURE__ */ function() {
  function e(t, r) {
    var i = [], n = !0, s = !1, o = void 0;
    try {
      for (var a = t[Symbol.iterator](), u; !(n = (u = a.next()).done) && (i.push(u.value), !(r && i.length === r)); n = !0)
        ;
    } catch (d) {
      s = !0, o = d;
    } finally {
      try {
        !n && a.return && a.return();
      } finally {
        if (s)
          throw o;
      }
    }
    return i;
  }
  return function(t, r) {
    if (Array.isArray(t))
      return t;
    if (Symbol.iterator in Object(t))
      return e(t, r);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
}(), qe = Math.PI * 2, yt = function(e, t, r, i, n, s, o) {
  var a = e.x, u = e.y;
  a *= t, u *= r;
  var d = i * a - n * u, l = n * a + i * u;
  return {
    x: d + s,
    y: l + o
  };
}, Eo = function(e, t) {
  var r = t === 1.5707963267948966 ? 0.551915024494 : t === -1.5707963267948966 ? -0.551915024494 : 1.3333333333333333 * Math.tan(t / 4), i = Math.cos(e), n = Math.sin(e), s = Math.cos(e + t), o = Math.sin(e + t);
  return [{
    x: i - n * r,
    y: n + i * r
  }, {
    x: s + o * r,
    y: o - s * r
  }, {
    x: s,
    y: o
  }];
}, or = function(e, t, r, i) {
  var n = e * i - t * r < 0 ? -1 : 1, s = e * r + t * i;
  return s > 1 && (s = 1), s < -1 && (s = -1), n * Math.acos(s);
}, Po = function(e, t, r, i, n, s, o, a, u, d, l, p) {
  var v = Math.pow(n, 2), m = Math.pow(s, 2), h = Math.pow(l, 2), g = Math.pow(p, 2), b = v * m - v * g - m * h;
  b < 0 && (b = 0), b /= v * g + m * h, b = Math.sqrt(b) * (o === a ? -1 : 1);
  var A = b * n / s * p, w = b * -s / n * l, C = d * A - u * w + (e + r) / 2, T = u * A + d * w + (t + i) / 2, j = (l - A) / n, I = (p - w) / s, L = (-l - A) / n, P = (-p - w) / s, M = or(1, 0, j, I), $ = or(j, I, L, P);
  return a === 0 && $ > 0 && ($ -= qe), a === 1 && $ < 0 && ($ += qe), [C, T, M, $];
}, Lo = function(e) {
  var t = e.px, r = e.py, i = e.cx, n = e.cy, s = e.rx, o = e.ry, a = e.xAxisRotation, u = a === void 0 ? 0 : a, d = e.largeArcFlag, l = d === void 0 ? 0 : d, p = e.sweepFlag, v = p === void 0 ? 0 : p, m = [];
  if (s === 0 || o === 0)
    return [];
  var h = Math.sin(u * qe / 360), g = Math.cos(u * qe / 360), b = g * (t - i) / 2 + h * (r - n) / 2, A = -h * (t - i) / 2 + g * (r - n) / 2;
  if (b === 0 && A === 0)
    return [];
  s = Math.abs(s), o = Math.abs(o);
  var w = Math.pow(b, 2) / Math.pow(s, 2) + Math.pow(A, 2) / Math.pow(o, 2);
  w > 1 && (s *= Math.sqrt(w), o *= Math.sqrt(w));
  var C = Po(t, r, i, n, s, o, l, v, h, g, b, A), T = Oo(C, 4), j = T[0], I = T[1], L = T[2], P = T[3], M = Math.abs(P) / (qe / 4);
  Math.abs(1 - M) < 1e-7 && (M = 1);
  var $ = Math.max(Math.ceil(M), 1);
  P /= $;
  for (var ie = 0; ie < $; ie++)
    m.push(Eo(L, P)), L += P;
  return m.map(function(Z) {
    var U = yt(Z[0], s, o, g, h, j, I), z = U.x, ee = U.y, ne = yt(Z[1], s, o, g, h, j, I), xe = ne.x, O = ne.y, W = yt(Z[2], s, o, g, h, j, I), X = W.x, de = W.y;
    return { x1: z, y1: ee, x2: xe, y2: O, x: X, y: de };
  });
}, Fo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ci(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var jo = Do, vt = { a: 7, c: 6, h: 1, l: 2, m: 2, q: 4, s: 4, t: 2, v: 1, z: 0 }, $o = /([astvzqmhlc])([^astvzqmhlc]*)/ig;
function Do(e) {
  var t = [];
  return e.replace($o, function(r, i, n) {
    var s = i.toLowerCase();
    for (n = _o(n), s == "m" && n.length > 2 && (t.push([i].concat(n.splice(0, 2))), s = "l", i = i == "m" ? "l" : "L"); ; ) {
      if (n.length == vt[s])
        return n.unshift(i), t.push(n);
      if (n.length < vt[s])
        throw new Error("malformed path data");
      t.push([i].concat(n.splice(0, vt[s])));
    }
  }), t;
}
var qo = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;
function _o(e) {
  var t = e.match(qo);
  return t ? t.map(Number) : [];
}
const Uo = /* @__PURE__ */ ci(jo);
var Vo = No;
function No(e) {
  var t = 0, r = 0, i = 0, n = 0;
  return e.map(function(s) {
    s = s.slice();
    var o = s[0], a = o.toUpperCase();
    if (o != a)
      switch (s[0] = a, o) {
        case "a":
          s[6] += i, s[7] += n;
          break;
        case "v":
          s[1] += n;
          break;
        case "h":
          s[1] += i;
          break;
        default:
          for (var u = 1; u < s.length; )
            s[u++] += i, s[u++] += n;
      }
    switch (a) {
      case "Z":
        i = t, n = r;
        break;
      case "H":
        i = s[1];
        break;
      case "V":
        n = s[1];
        break;
      case "M":
        i = t = s[1], n = r = s[2];
        break;
      default:
        i = s[s.length - 2], n = s[s.length - 1];
    }
    return s;
  });
}
const Ho = /* @__PURE__ */ ci(Vo);
function Bo(e) {
  const t = Uo(e), r = Ho(t);
  let i, n = 0, s = 0, o = 0, a = 0, u, d, l = 0, p = 0;
  const v = [];
  for (let m = 0; m < r.length; m++) {
    let h = r[m];
    const g = h[0];
    switch (g) {
      case "M":
        n = h[1], s = h[2];
        break;
      case "H":
        h = ["L", h[1], s];
        break;
      case "V":
        h = ["L", n, h[1]];
        break;
      case "S":
        {
          let b = l, A = p;
          (i === "C" || i == "S") && (b += b - o, A += A - a), h = ["C", b, A, h[1], h[2], h[3], h[4]];
        }
        break;
      case "T":
        i === "Q" || i == "T" ? (u = l * 2 - u, d = p * 2 - d) : (u = l, d = p), h = ["Q", u, d, h[1], h[2]];
        break;
      case "Q":
        u = h[1], d = h[2];
        break;
      case "A":
        {
          const b = Lo({
            px: l,
            py: p,
            cx: h[6],
            cy: h[7],
            rx: h[1],
            ry: h[2],
            xAxisRotation: h[3],
            largeArcFlag: h[4],
            sweepFlag: h[5]
          });
          if (!b.length)
            continue;
          for (const [A, w] of b.entries())
            h = ["C", w.x1, w.y1, w.x2, w.y2, w.x, w.y], A < b.length - 1 && v.push(h);
          h = h;
        }
        break;
      case "Z":
        h = ["L", n, s];
        break;
    }
    i = g, l = h[h.length - 2], p = h[h.length - 1], ["C", "Q", "A"].indexOf(g) > -1 ? (o = h[h.length - 4], a = h[h.length - 3]) : (o = l, a = p), v.push(h);
  }
  return v;
}
/** Code to "flatten" quadratic and cubic Bézier curves to polylines.
 *
 * All code in this module is based on JavaScript code by Raph Levien, published on his blog at
 * https://raphlinus.github.io/.
 * I merely changed the structure a bit, removed some unneeded parts and added some comments and type hints.
 *
 * Flattening of quadratic Bézier curves:
 * - Article: https://raphlinus.github.io/graphics/curves/2019/12/23/flatten-quadbez.html
 * - Code: https://github.com/raphlinus/raphlinus.github.io/blob/master/_posts/2019-12-23-flatten-quadbez.md?plain=1#L73-L212
 *
 * Flattening of cubic Bézier curves: https://levien.com/tmp/flatten.html
 *
 * Note that the code in this module has a different license than the rest of the package,
 * due to the inclusion of Apache-licensed third party code.
 *
 * @license
 * Copyright 2022 Johannes Baiter <johannes.baiter@gmail.com>
 * Copyright 2019, 2022 Raph Levien <raph.levien@gmail.com>
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function zo(e, t, r, i = 1) {
  return new ui(e, t, r).subdivide(i);
}
function Wo(e, t, r, i, n = 1) {
  return new Dt(
    new Float64Array([e.x, e.y, t.x, t.y, r.x, r.y, i.x, i.y])
  ).subdivide(n);
}
function Qo(e) {
  return e.x * e.x + e.y * e.y;
}
function _e(e) {
  return e / (1 - 0.67 + Math.pow(Math.pow(0.67, 4) + 0.25 * e * e, 0.25));
}
function Pe(e) {
  return e * (1 - 0.39 + Math.sqrt(0.39 * 0.39 + 0.25 * e * e));
}
class ui {
  constructor(t, r, i) {
    Ge(this, "start"), Ge(this, "control"), Ge(this, "end"), this.start = t, this.control = r, this.end = i;
  }
  eval(t) {
    const r = 1 - t;
    return {
      x: this.start.x * r * r + 2 * this.control.x * r * t + this.end.x * t * t,
      y: this.start.y * r * r + 2 * this.control.y * r * t + this.end.y * t * t
    };
  }
  mapToBasic() {
    const { x: t, y: r } = this.start, { x: i, y: n } = this.control, { x: s, y: o } = this.end, a = 2 * i - t - s, u = 2 * n - r - o, d = (i - t) * a + (n - r) * u, l = (s - i) * a + (o - n) * u, p = (s - t) * u - (o - r) * a, v = d / p, m = l / p, h = Math.abs(p) / (Math.hypot(a, u) * Math.abs(m - v));
    return { x0: t, x2: s, scale: h, cross: p };
  }
  subdivide(t) {
    const r = this.mapToBasic(), i = _e(r.x0), n = _e(r.x2), s = 0.5 * Math.abs(n - i) * Math.sqrt(r.scale / t), o = Math.ceil(s), a = Pe(i), u = Pe(n), d = [0];
    for (let l = 1; l < o; l++) {
      const p = (Pe(i + (n - i) * l / o) - a) / (u - a);
      d.push(p);
    }
    return d.push(1), d.map((l) => this.eval(l));
  }
}
class Dt {
  /// Argument is array of coordinate values [x0, y0, x1, y1, x2, y2, x3, y3].
  constructor(t) {
    Ge(this, "c"), this.c = t;
  }
  weightsum(t, r, i, n) {
    const s = t * this.c[0] + r * this.c[2] + i * this.c[4] + n * this.c[6], o = t * this.c[1] + r * this.c[3] + i * this.c[5] + n * this.c[7];
    return { x: s, y: o };
  }
  eval(t) {
    const r = 1 - t, i = r * r * r, n = 3 * r * r * t, s = 3 * r * t * t, o = t * t * t;
    return this.weightsum(i, n, s, o);
  }
  deriv(t) {
    const r = 1 - t, i = -3 * r * r, n = 3 * t * t, s = -6 * t * r - i, o = 6 * t * r - n;
    return this.weightsum(i, s, o, n);
  }
  // quadratic bezier with matching endpoints and minimum max vector error
  midpoint_quadbez() {
    const t = this.weightsum(-0.25, 0.75, 0.75, -0.25);
    return new ui({ x: this.c[0], y: this.c[1] }, t, { x: this.c[6], y: this.c[7] });
  }
  subsegment(t, r) {
    const i = new Float64Array(8), n = this.eval(t), s = this.eval(r);
    i[0] = n.x, i[1] = n.y;
    const o = (r - t) / 3, a = this.deriv(t);
    i[2] = n.x + o * a.x, i[3] = n.y + o * a.y;
    const u = this.deriv(r);
    return i[4] = s.x - o * u.x, i[5] = s.y - o * u.y, i[6] = s.x, i[7] = s.y, new Dt(i);
  }
  // Very fancy subdivision scheme
  subdivide(t) {
    const r = 0.1 * t, i = t - r, n = Math.sqrt(i), s = Qo(this.weightsum(1, -3, 3, -1)), o = Math.ceil(Math.pow(s / (432 * r * r), 1 / 6)), a = [];
    let u = 0;
    for (let h = 0; h < o; h++) {
      const g = h / o, b = (h + 1) / o, A = this.subsegment(g, b).midpoint_quadbez(), w = A.mapToBasic(), C = _e(w.x0), T = _e(w.x2), j = Math.sqrt(w.scale);
      let I = Math.abs(T - C) * j;
      if (Math.sign(w.x0) != Math.sign(w.x2)) {
        const L = n / j, P = n * Math.abs(T - C) / _e(L);
        I = Math.max(I, P);
      }
      a.push({
        quad: A,
        a0: C,
        a2: T,
        val: I
      }), u += I;
    }
    const d = 0.5 * u / n, l = Math.ceil(d), p = [{ x: this.c[0], y: this.c[1] }];
    let v = 0, m = 0;
    for (let h = 1; h < l; h++) {
      const g = u * h / l;
      for (; v + a[m].val < g; )
        v += a[m].val, m++;
      const b = a[m].a0, A = a[m].a2, w = Pe(b), C = Pe(A), T = b + (A - b) * (g - v) / a[m].val, j = (Pe(T) - w) / (C - w);
      p.push(a[m].quad.eval(j));
    }
    return p.push({ x: this.c[6], y: this.c[7] }), p;
  }
}
const Yo = /&?(xywh=)?(pixel:|percent:|pct:)?([0-9]+(?:\.[0-9]+)?),([0-9]+(?:\.[0-9]+)?),([0-9]+(?:\.[0-9]+)?),([0-9]+(?:\.[0-9]+)?)/, Go = /&?(t=)(npt:)?([0-9]+(.[0-9]+)?)?(,([0-9]+(.[0-9]+)?))?/, ar = /^rgba\((\d+),(\d+),(\d+),([0-9.]+)\)$/;
function Je(e, {
  domParser: t,
  svgPreprocessor: r,
  iiifRenderingHints: i
} = {}) {
  if (Array.isArray(e))
    return re(
      e.reduce(
        (n, s) => {
          const {
            selector: o,
            selectors: a,
            iiifRenderingHints: u
          } = Je(s, { domParser: t, svgPreprocessor: r, iiifRenderingHints: i });
          return o && (n.selector || (n.selector = o), n.selectors.push(...a)), u && (n.iiifRenderingHints = n.iiifRenderingHints || { type: "ImageApiSelector" }, Object.assign(n.iiifRenderingHints, u)), n;
        },
        {
          selector: null,
          selectors: [],
          iiifRenderingHints: i
        }
      )
    );
  if (!e)
    return re({
      selector: null,
      selectors: [],
      iiifRenderingHints: i
    });
  if (typeof e == "string") {
    const [n, s] = e.split("#");
    return s ? Je(
      { type: "FragmentSelector", value: s },
      { svgPreprocessor: r, iiifRenderingHints: i, domParser: t }
    ) : re({
      selector: null,
      selectors: [],
      iiifRenderingHints: i
    });
  }
  if (e.type && e.type === "PointSelector" && (e.t || e.t === 0)) {
    const n = {
      type: "TemporalSelector",
      temporal: {
        startTime: e.t
      }
    };
    return re({
      selector: n,
      selectors: [n],
      iiifRenderingHints: i
    });
  }
  if (Xo(e)) {
    const n = [];
    if (e.region) {
      const s = Je(
        { type: "FragmentSelector", value: "xywh=" + e.region },
        { domParser: t, svgPreprocessor: r, iiifRenderingHints: i }
      );
      n.push(...s.selectors);
    }
    return re({
      selector: n[0],
      selectors: n,
      iiifRenderingHints: i ? { ...i, ...e } : e
    });
  }
  if (e.type === "FragmentSelector") {
    const n = Yo.exec(e.value);
    if (n) {
      const o = {
        type: "BoxSelector",
        spatial: {
          unit: n[2] === "percent:" || n[2] === "pct:" ? "percent" : "pixel",
          x: parseFloat(n[3]),
          y: parseFloat(n[4]),
          width: parseFloat(n[5]),
          height: parseFloat(n[6])
        }
      };
      return re({
        selector: o,
        selectors: [o],
        iiifRenderingHints: i
      });
    }
    const s = e.value.match(Go);
    if (s) {
      const o = {
        type: "TemporalSelector",
        temporal: {
          startTime: s[4] ? parseFloat(s[4]) : 0,
          endTime: s[7] ? parseFloat(s[7]) : void 0
        }
      };
      return re({
        selector: o,
        selectors: [o],
        iiifRenderingHints: i
      });
    }
    return re({
      selector: null,
      selectors: [],
      iiifRenderingHints: i
    });
  }
  if (e.type === "SvgSelector" && "value" in e) {
    t || (typeof window < "u" ? t = new window.DOMParser() : console.warn(
      "No DOMParser available, cannot parse SVG selector, `points`, `spatial` and `style` will be unavailable and the SVG will not be normalized."
    ));
    let n = [], s, o, a = (r == null ? void 0 : r(e.value)) ?? e.value, u;
    if (t) {
      const l = t.parseFromString(e.value, "image/svg+xml").querySelector("svg");
      if (!l)
        return console.warn(`Illegal SVG selector: ${e.value}`), re({
          selector: null,
          selectors: [],
          iiifRenderingHints: i
        });
      const p = li(l);
      p && (n = p.points, u = p.shapeType, s = [
        Math.min(...n.map((v) => v[0])),
        // llx
        Math.min(...n.map((v) => v[1])),
        // lly
        Math.max(...n.map((v) => v[0])),
        // urx
        Math.max(...n.map((v) => v[1]))
        // ury
      ], { style: o, svg: a } = Zo(p.element) ?? { svg: a });
    }
    const d = {
      type: "SvgSelector",
      svg: a,
      svgShape: u,
      style: o,
      points: n.length ? n : void 0,
      spatial: s ? { unit: "pixel", x: s[0], y: s[1], width: s[2] - s[0], height: s[3] - s[1] } : void 0
    };
    return re({
      selector: d,
      selectors: [d],
      iiifRenderingHints: i
    });
  }
  return re({
    selector: null,
    selectors: [],
    iiifRenderingHints: i
  });
}
function Jo(e) {
  const t = e.map((i) => i[0]).reduce(
    (i, n) => (i[n] += 1, i),
    { C: 0, Q: 0, L: 0, M: 0 }
  ), r = new Set(e.map((i) => i[0]));
  if (t.C > 0 || t.Q > 0)
    return "path";
  if (t.L > 0 && (r.size === 1 || r.size === 2 && r.has("M"))) {
    if (t.L === 4)
      return "rect";
    const i = e.slice(-1)[0];
    return e[0][0] === "M" && i[0] === "L" && i[1] == e[0][1] && i[2] === e[0][2] || i[1] === 0 && i[2] === 0 ? "polygon" : "polyline";
  }
  return "path";
}
function li(e) {
  var t;
  for (const r of Array.from(e.children))
    switch (r == null ? void 0 : r.tagName.toLowerCase()) {
      case "g":
        {
          const i = li(r);
          if (i)
            return i;
        }
        continue;
      case "path": {
        const i = r.getAttribute("d");
        if (!i)
          continue;
        const n = Bo(i);
        return { element: r, points: Ko(n), shapeType: Jo(n) };
      }
      case "circle": {
        const i = parseFloat(r.getAttribute("cx") ?? "0"), n = parseFloat(r.getAttribute("cy") ?? "0"), s = parseFloat(r.getAttribute("r") ?? "0");
        if (!s)
          continue;
        const o = [];
        for (let a = 0; a <= 360; a += 12) {
          const u = a * Math.PI / 180;
          o.push([i + s * Math.cos(u), n + s * Math.sin(u)]);
        }
        return { element: r, points: o, shapeType: "circle" };
      }
      case "ellipse": {
        const i = parseFloat(r.getAttribute("cx") ?? "0"), n = parseFloat(r.getAttribute("cy") ?? "0"), s = parseFloat(r.getAttribute("rx") ?? "0"), o = parseFloat(r.getAttribute("ry") ?? "0");
        if (!s && !o)
          continue;
        const a = [];
        for (let u = 0; u <= 360; u += 12) {
          const d = Math.tan(u / 360 * Math.PI), l = s * (1 - d ** 2) / (1 + d ** 2), p = o * 2 * d / (1 + d ** 2);
          a.push([i + l, n + p]);
        }
        return { element: r, points: a, shapeType: "ellipse" };
      }
      case "line": {
        const i = parseFloat(r.getAttribute("x0") ?? "0"), n = parseFloat(r.getAttribute("y0") ?? "0"), s = parseFloat(r.getAttribute("x1") ?? "0"), o = parseFloat(r.getAttribute("y1") ?? "0");
        if (i === s && n === o)
          continue;
        return {
          element: r,
          points: [
            [i, n],
            [s, o]
          ],
          shapeType: "polyline"
        };
      }
      case "polygon":
      case "polyline": {
        const i = ((t = r.getAttribute("points")) == null ? void 0 : t.split(" ").map((s) => s.split(",").map(parseFloat))) ?? [];
        if (!i.length)
          continue;
        let n = "polyline";
        return r.tagName.toLowerCase() === "polygon" && (i.push(i[0]), n = "polygon"), { element: r, points: i, shapeType: n };
      }
      case "rect": {
        const i = parseFloat(r.getAttribute("x") ?? "0"), n = parseFloat(r.getAttribute("y") ?? "0"), s = parseFloat(r.getAttribute("width") ?? "0"), o = parseFloat(r.getAttribute("height") ?? "0");
        if (!s || !o)
          continue;
        return {
          element: r,
          points: [
            [i, n],
            [i + s, n],
            [i + s, n + o],
            [i, n + o],
            [i, n]
          ],
          shapeType: "rect"
        };
      }
      default:
        continue;
    }
  return null;
}
function Ko(e) {
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const i = t[t.length - 1] ?? [0, 0], n = e[r];
    switch (n[0]) {
      case "M":
      case "L":
        t.push([n[1], n[2]]);
        continue;
      case "C":
        t.push(
          ...Wo(
            { x: i[0], y: i[1] },
            { x: n[1], y: n[2] },
            { x: n[3], y: n[4] },
            { x: n[5], y: n[6] }
          ).map((s) => [s.x, s.y]).slice(1)
          // skip first point, already part of output
        );
        continue;
      case "Q":
        t.push(
          ...zo(
            { x: i[0], y: i[1] },
            { x: n[1], y: n[2] },
            { x: n[3], y: n[4] }
          ).map((s) => [s.x, s.y]).slice(1)
          // skip first point, already part of output
        );
        continue;
    }
  }
  return t;
}
function Zo(e) {
  const t = {};
  if (e.hasAttribute("fill") ? (t.fill = e.getAttribute("fill"), e.removeAttribute("fill")) : e.style.fill && (t.fill = e.style.fill), t.fill) {
    const i = ar.exec(t.fill);
    i && (t.fillOpacity = parseFloat(i[4]), t.fill = `rgb(${i[1]}, ${i[2]}, ${i[3]})`);
  }
  if (e.hasAttribute("fill-opacity") ? (t.fillOpacity = parseFloat(e.getAttribute("fill-opacity")), e.removeAttribute("fill-opacity")) : e.style.fillOpacity && (t.fillOpacity = parseFloat(e.style.fillOpacity)), e.hasAttribute("stroke") ? (t.stroke = e.getAttribute("stroke"), e.removeAttribute("stroke")) : e.style.stroke && (t.stroke = e.style.stroke), t.stroke) {
    const i = ar.exec(t.stroke);
    i && (t.strokeOpacity = parseFloat(i[4]), t.stroke = `rgb(${i[1]}, ${i[2]}, ${i[3]})`);
  }
  e.hasAttribute("stroke-opacity") ? (t.strokeOpacity = parseFloat(e.getAttribute("stroke-opacity")), e.removeAttribute("stroke-opacity")) : e.style.strokeOpacity && (t.strokeOpacity = parseFloat(e.style.strokeOpacity)), e.hasAttribute("stroke-width") ? (t.strokeWidth = e.getAttribute("stroke-width"), e.removeAttribute("stroke-width")) : e.style.strokeWidth && (t.strokeWidth = e.style.strokeWidth), e.hasAttribute("stroke-dasharray") ? (t.strokeDasharray = e.getAttribute("stroke-dasharray"), e.removeAttribute("stroke-dasharray")) : e.style.strokeDasharray && (t.strokeDasharray = e.style.strokeDasharray);
  let r = e;
  for (; r.tagName.toLowerCase() !== "svg"; )
    if (r = r.parentElement, r === null)
      throw new Error("Could not find root SVG element");
  return { svg: r.outerHTML, style: Object.keys(t).length > 0 ? t : void 0 };
}
function Xo(e) {
  return !!e && e.type === "iiif:ImageApiSelector" && e.type === "iiif:ImageApiSelector";
}
function re(e) {
  if (e.iiifRenderingHints) {
    const t = e.iiifRenderingHints;
    if (t.rotation) {
      const r = ea(t.rotation);
      if (r)
        if (e.selectors.length)
          for (const i of e.selectors)
            i.rotation = r;
        else
          e.selectors.push({
            type: "RotationSelector",
            rotation: r
          });
    }
  } else
    delete e.iiifRenderingHints;
  return e;
}
function ea(e) {
  let t = parseFloat(e);
  return t && e.startsWith("!") && (t = 360 - t), t && (t = t % 360), t !== t ? 0 : t || 0;
}
function je(e, t = {}) {
  if (Array.isArray(e))
    return je(e[0]);
  if (typeof e == "string") {
    const [r, i] = e.split("#");
    return i ? je({
      type: "SpecificResource",
      source: { id: r, type: "Unknown" },
      selector: {
        type: "FragmentSelector",
        value: i
      }
    }) : {
      type: "SpecificResource",
      source: { id: r, type: t.typeMap && t.typeMap[r] || "Unknown" },
      selector: null,
      selectors: []
    };
  }
  if (e.type === "Choice" || e.type === "List" || e.type === "Composite" || e.type === "Independents")
    return je(e.items[0]);
  if (e.type === "SpecificResource") {
    e.source.type === "Canvas" && e.source.partOf && typeof e.source.partOf == "string" && (e.source.partOf = [
      {
        id: e.source.partOf,
        type: "Manifest"
      }
    ]);
    const { selector: r, selectors: i } = e.selector ? Je(e.selector, t) : { selector: null, selectors: [] };
    return {
      type: "SpecificResource",
      source: e.source,
      selector: r,
      selectors: i
    };
  }
  if (e.id) {
    e.type === "Canvas" && e.partOf && typeof e.partOf == "string" && (e.partOf = [
      {
        id: e.partOf,
        type: "Manifest"
      }
    ]);
    const [r, i] = e.id.split("#");
    return i ? je({
      type: "SpecificResource",
      source: {
        ...e,
        id: r
      },
      selector: {
        type: "FragmentSelector",
        value: i
      }
    }) : {
      type: "SpecificResource",
      source: {
        ...e,
        id: r
      },
      selector: null,
      selectors: []
    };
  }
  return {
    type: "SpecificResource",
    source: e,
    selector: null,
    selectors: []
  };
}
var ta = Object.defineProperty, ra = (e, t, r) => t in e ? ta(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, cr = (e, t, r) => (ra(e, typeof t != "symbol" ? t + "" : t, r), r);
function ia(e) {
  return Array.isArray(e) ? e : e ? [e] : [];
}
const ur = [
  "sc:Collection",
  "sc:Manifest",
  "sc:Canvas",
  "sc:AnnotationList",
  "oa:Annotation",
  "sc:Range",
  "sc:Layer",
  "sc:Sequence",
  "oa:Choice",
  "Service",
  "ContentResource"
];
function na(e) {
  if (typeof e > "u" || e === null)
    throw new Error("Null or undefined is not a valid entity.");
  if (Array.isArray(e))
    throw new Error("Array is not a valid entity");
  if (typeof e != "object")
    throw new Error(`${typeof e} is not a valid entity`);
  if (typeof e["@type"] == "string") {
    const t = ur.indexOf(e["@type"]);
    if (t !== -1)
      return ur[t];
  }
  if (e.profile)
    return "Service";
  if (e.format || e["@type"])
    return "ContentResource";
  throw new Error("Resource type is not known");
}
class qt {
  constructor(t, r = {}) {
    cr(this, "traversals"), cr(this, "options"), this.traversals = {
      collection: [],
      manifest: [],
      canvas: [],
      annotationList: [],
      sequence: [],
      annotation: [],
      contentResource: [],
      choice: [],
      range: [],
      service: [],
      layer: [],
      ...t
    }, this.options = {
      convertPropsToArray: !0,
      mergeMemberProperties: !0,
      allowUndefinedReturn: !1,
      ...r
    };
  }
  static all(t) {
    return new qt({
      collection: [t],
      manifest: [t],
      canvas: [t],
      annotationList: [t],
      sequence: [t],
      annotation: [t],
      contentResource: [t],
      choice: [t],
      range: [t],
      service: [t],
      layer: [t]
    });
  }
  traverseCollection(t) {
    return this.traverseType(
      this.traverseDescriptive(this.traverseLinking(this.traverseCollectionItems(t))),
      this.traversals.collection
    );
  }
  traverseCollectionItems(t) {
    if (this.options.mergeMemberProperties) {
      const r = [
        ...(t.manifests || []).map((i) => typeof i == "string" ? { "@id": i, "@type": "sc:Manifest" } : i),
        ...(t.collections || []).map((i) => typeof i == "string" ? { "@id": i, "@type": "sc:Collection" } : i),
        ...t.members || []
      ];
      delete t.collections, delete t.manifests, t.members = r;
    }
    return t.manifests && (t.manifests = t.manifests.map(
      (r) => this.traverseManifest(
        typeof r == "string" ? { "@id": r, "@type": "sc:Manifest" } : r
      )
    )), t.collections && (t.collections = t.collections.map(
      (r) => this.traverseCollection(
        typeof r == "string" ? { "@id": r, "@type": "sc:Collection" } : r
      )
    )), t.members && (t.members = t.members.map((r) => typeof r == "string" ? r : this.traverseUnknown(r))), t;
  }
  traverseManifest(t) {
    return this.traverseType(
      this.traverseDescriptive(this.traverseLinking(this.traverseManifestItems(t))),
      this.traversals.manifest
    );
  }
  traverseManifestItems(t) {
    return t.sequences && (t.sequences = t.sequences.map((r) => this.traverseSequence(r))), t.structures && (t.structures = t.structures.map((r) => this.traverseRange(r))), t;
  }
  traverseSequence(t) {
    return this.traverseType(
      this.traverseDescriptive(this.traverseLinking(this.traverseSequenceItems(t))),
      this.traversals.sequence
    );
  }
  traverseSequenceItems(t) {
    return t.canvases && (t.canvases = t.canvases.map((r) => this.traverseCanvas(r))), t;
  }
  traverseCanvas(t) {
    return this.traverseType(
      this.traverseDescriptive(this.traverseLinking(this.traverseCanvasItems(t))),
      this.traversals.canvas
    );
  }
  traverseCanvasItems(t) {
    return t.images && (t.images = t.images.map((r) => this.traverseAnnotation(r))), t.otherContent && (t.otherContent = t.otherContent.map((r) => this.traverseAnnotationList(r))), t;
  }
  traverseRange(t) {
    return this.traverseType(
      this.traverseDescriptive(this.traverseLinking(this.traverseRangeItems(t))),
      this.traversals.range
    );
  }
  traverseRangeItems(t) {
    if (this.options.mergeMemberProperties) {
      const r = [
        ...(t.ranges || []).map((i) => typeof i == "string" ? { "@id": i, "@type": "sc:Range" } : i),
        ...(t.canvases || []).map((i) => typeof i == "string" ? { "@id": i, "@type": "sc:Canvas" } : i),
        ...t.members || []
      ];
      delete t.ranges, delete t.canvases, t.members = r.length ? r.map((i) => this.traverseUnknown(i)) : void 0;
    }
    return t;
  }
  traverseAnnotationList(t) {
    const r = typeof t == "string" ? { "@id": t, "@type": "sc:AnnotationList" } : t;
    return this.traverseType(
      this.traverseDescriptive(this.traverseAnnotationListItems(r)),
      this.traversals.annotationList
    );
  }
  traverseAnnotationListItems(t) {
    return t.resources && (t.resources = t.resources.map((r) => this.traverseAnnotation(r))), t;
  }
  traverseAnnotation(t) {
    return this.traverseType(
      this.traverseDescriptive(this.traverseLinking(this.traverseAnnotationItems(t))),
      this.traversals.annotation
    );
  }
  traverseAnnotationItems(t) {
    return t.resource && (Array.isArray(t.resource) ? t.resource = t.resource.map(
      (r) => this.traverseContentResource(r)
    ) : t.resource = this.traverseContentResource(t.resource)), t.on, t;
  }
  traverseLayer(t) {
    return this.traverseType(this.traverseLinking(this.traverseLayerItems(t)), this.traversals.layer);
  }
  traverseLayerItems(t) {
    return t.otherContent && (t.otherContent = t.otherContent.map((r) => this.traverseAnnotationList(r))), t;
  }
  traverseChoice(t) {
    return this.traverseType(this.traverseChoiceItems(t), this.traversals.choice);
  }
  traverseChoiceItems(t) {
    return t.default && t.default !== "rdf:nil" && (t.default = this.traverseContentResource(t.default)), t.item && t.item !== "rdf:nil" && (t.item = t.item.map((r) => this.traverseContentResource(r))), t;
  }
  traverseService(t) {
    return this.traverseType(this.traverseLinking(t), this.traversals.service);
  }
  traverseContentResource(t) {
    return t["@type"] === "oa:Choice" ? this.traverseChoice(t) : this.traverseType(
      this.traverseDescriptive(this.traverseLinking(t)),
      this.traversals.contentResource
    );
  }
  traverseUnknown(t) {
    if (!t["@type"] || typeof t == "string")
      return t;
    switch (na(t)) {
      case "sc:Collection":
        return this.traverseCollection(t);
      case "sc:Manifest":
        return this.traverseManifest(t);
      case "sc:Canvas":
        return this.traverseCanvas(t);
      case "sc:Sequence":
        return this.traverseSequence(t);
      case "sc:Range":
        return this.traverseRange(t);
      case "oa:Annotation":
        return this.traverseAnnotation(t);
      case "sc:AnnotationList":
        return this.traverseAnnotationList(t);
      case "sc:Layer":
        return this.traverseLayer(t);
      case "Service":
        return this.traverseService(t);
      case "oa:Choice":
        return this.traverseChoice(t);
      case "ContentResource":
        return this.traverseContentResource(t);
    }
    return t.profile ? this.traverseService(t) : t;
  }
  traverseImageResource(t) {
    const r = Array.isArray(t), i = Array.isArray(t) ? t : [t], n = [];
    for (const s of i)
      typeof s == "string" ? n.push(
        this.traverseContentResource({
          "@id": s,
          "@type": "dctypes:Image"
        })
      ) : n.push(this.traverseContentResource(s));
    return !r && !this.options.convertPropsToArray ? n[0] : n;
  }
  traverseDescriptive(t) {
    return t.thumbnail && (t.thumbnail = this.traverseImageResource(t.thumbnail)), t.logo && (t.logo = this.traverseImageResource(t.logo)), t;
  }
  traverseOneOrMoreServices(t) {
    const r = Array.isArray(t), i = Array.isArray(t) ? t : [t], n = [];
    for (const s of i)
      n.push(this.traverseService(s));
    return !r && !this.options.convertPropsToArray ? n[0] : n;
  }
  traverseLinking(t) {
    return t.related && (t.related = this.traverseOneOrManyType(t.related, this.traversals.contentResource)), t.rendering && (t.rendering = this.traverseOneOrManyType(t.rendering, this.traversals.contentResource)), t.service && (t.service = this.traverseOneOrMoreServices(t.service)), t.seeAlso && (t.seeAlso = this.traverseOneOrManyType(t.seeAlso, this.traversals.contentResource)), t.within && (typeof t.within == "string" || (t.within = this.traverseOneOrManyType(
      t.within,
      this.traversals.contentResource
    ))), t.startCanvas && (typeof t.startCanvas == "string" ? t.startCanvas = this.traverseType(
      { "@id": t.startCanvas, "@type": "sc:Canvas" },
      this.traversals.canvas
    ) : t.startCanvas && this.traverseType(t.startCanvas, this.traversals.canvas)), t.contentLayer && (typeof t.contentLayer == "string" ? t.contentLayer = this.traverseLayer({
      "@id": t.contentLayer,
      "@type": "sc:Layer"
    }) : t.contentLayer = this.traverseLayer(t.contentLayer)), t;
  }
  traverseOneOrManyType(t, r) {
    if (!Array.isArray(t))
      if (this.options.convertPropsToArray)
        t = [t];
      else
        return this.traverseType(t, r);
    return t.map((i) => this.traverseType(i, r));
  }
  traverseType(t, r) {
    return r.reduce((i, n) => {
      const s = n(i);
      return typeof s > "u" && !this.options.allowUndefinedReturn ? i : s;
    }, t);
  }
}
const sa = "http://library.stanford.edu/iiif/image-api/compliance.html#level0", fi = "http://library.stanford.edu/iiif/image-api/compliance.html#level1", pi = "http://library.stanford.edu/iiif/image-api/compliance.html#level2", oa = "http://library.stanford.edu/iiif/image-api/conformance.html#level0", di = "http://library.stanford.edu/iiif/image-api/conformance.html#level1", hi = "http://library.stanford.edu/iiif/image-api/conformance.html#level2", aa = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level0", yi = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level1", vi = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level2", ca = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level0", gi = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level1", mi = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level2", ua = "http://iiif.io/api/image/1/level0.json", la = "http://iiif.io/api/image/1/profiles/level0.json", bi = "http://iiif.io/api/image/1/level1.json", Ai = "http://iiif.io/api/image/1/profiles/level1.json", xi = "http://iiif.io/api/image/1/level2.json", wi = "http://iiif.io/api/image/1/profiles/level2.json", fa = "http://iiif.io/api/image/2/level0.json", pa = "http://iiif.io/api/image/2/profiles/level0.json", Si = "http://iiif.io/api/image/2/level1.json", Ci = "http://iiif.io/api/image/2/profiles/level1.json", Mi = "http://iiif.io/api/image/2/level2.json", Ri = "http://iiif.io/api/image/2/profiles/level2.json", da = "level0", Ii = "level1", Ti = "level2", ha = "http://iiif.io/api/image/2/level0", ki = "http://iiif.io/api/image/2/level1", Oi = "http://iiif.io/api/image/2/level2", ya = [
  ki,
  Oi,
  fi,
  pi,
  di,
  hi,
  yi,
  vi,
  gi,
  mi,
  bi,
  Ai,
  xi,
  wi,
  Si,
  Ci,
  Mi,
  Ri,
  Ii,
  Ti
], va = [
  ha,
  ki,
  Oi,
  sa,
  fi,
  pi,
  oa,
  di,
  hi,
  aa,
  yi,
  vi,
  ca,
  gi,
  mi,
  ua,
  la,
  bi,
  Ai,
  xi,
  wi,
  fa,
  pa,
  Si,
  Ci,
  Mi,
  Ri,
  da,
  Ii,
  Ti
];
function le(e) {
  for (const t in e)
    (typeof e[t] > "u" || e[t] === null) && delete e[t];
  return e;
}
const Tt = {
  attributionLabel: "Attribution",
  lang: "none",
  providerId: "http://example.org/provider",
  providerName: "Unknown"
};
function Ie(e, t = "none") {
  if (!e)
    return {};
  const r = Array.isArray(e) ? e : [e], i = {};
  for (const n of r) {
    if (typeof n == "string") {
      i[t] = i[t] ? i[t] : [], i[t].push(n || "");
      continue;
    }
    if (!n["@language"]) {
      i[t] = i[t] ? i[t] : [], i[t].push(n["@value"] || "");
      continue;
    }
    const s = n["@language"];
    i[s] = i[s] ? i[s] : [], i[s].push(n["@value"] || "");
  }
  return i;
}
function Ei(e) {
  if (Array.isArray(e))
    return Ei(e.find((t) => typeof t == "string"));
  if (va.indexOf(e) !== -1)
    return "level2";
  if (ya.indexOf(e) !== -1)
    return "level1";
  if (typeof e == "string")
    return e;
}
function ga(e) {
  const t = Array.isArray(e) ? e : [e];
  for (const r of t)
    switch (r) {
      case "http://iiif.io/api/image/2/context.json":
      case "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level2":
        return "ImageService2";
      case "http://iiif.io/api/image/1/context.json":
      case "http://library.stanford.edu/iiif/image-api/1.1/context.json":
        return "ImageService1";
      case "http://iiif.io/api/annex/openannotation/context.json":
        return "ImageApiSelector";
    }
}
function ma(e) {
  switch (e) {
    case "http://iiif.io/api/image/2/level0.json":
    case "http://iiif.io/api/image/2/level1.json":
    case "http://iiif.io/api/image/2/level2.json":
      return "ImageService2";
    case "http://iiif.io/api/auth/1/kiosk":
    case "http://iiif.io/api/auth/1/login":
    case "http://iiif.io/api/auth/1/clickthrough":
    case "http://iiif.io/api/auth/1/external":
    case "http://iiif.io/api/auth/0/kiosk":
    case "http://iiif.io/api/auth/0/login":
    case "http://iiif.io/api/auth/0/clickthrough":
    case "http://iiif.io/api/auth/0/external":
      return "AuthCookieService1";
    case "http://iiif.io/api/auth/1/token":
    case "http://iiif.io/api/auth/0/token":
      return "AuthTokenService1";
    case "http://iiif.io/api/auth/1/logout":
    case "http://iiif.io/api/auth/0/logout":
      return "AuthLogoutService1";
    case "http://iiif.io/api/search/1/search":
    case "http://iiif.io/api/search/0/search":
      return "SearchService1";
    case "http://iiif.io/api/search/1/autocomplete":
    case "http://iiif.io/api/search/0/autocomplete":
      return "AutoCompleteService1";
  }
}
function lr(e) {
  for (const t of ["sc", "oa", "dcterms", "dctypes", "iiif"])
    if (e.startsWith(`${t}:`))
      return e.slice(t.length + 1);
  return e;
}
const ba = ["Collection", "Manifest", "Annotation", "AnnotationPage", "Range", "Service"];
function _t(e) {
  const t = e["@id"] || e.id;
  let r = e["@type"] || e.type;
  const i = e.profile || void 0, n = e["@context"] || void 0;
  if (i) {
    const s = ma(i);
    if (s)
      return s;
  }
  if (n) {
    const s = ga(n);
    if (s)
      return s;
  }
  if (r) {
    if (Array.isArray(r)) {
      if (r.indexOf("oa:CssStylesheet") !== -1)
        return "CssStylesheet";
      if (r.indexOf("cnt:ContentAsText") !== -1)
        return "TextualBody";
      r = r[0];
    }
    for (const s of ["sc", "oa", "dcterms", "dctypes", "iiif"])
      if (r.startsWith(`${s}:`)) {
        r = r.slice(s.length + 1);
        break;
      }
    switch (r) {
      case "Layer":
        return "AnnotationCollection";
      case "AnnotationList":
        return "AnnotationPage";
      case "cnt:ContentAsText":
        return "TextualBody";
    }
  }
  if (r && ba.indexOf(r) !== -1)
    return r;
  if (e.format) {
    if (e.format.startsWith("image/"))
      return "Image";
    if (e.format.startsWith("text/") || e.format === "application/pdf")
      return "Text";
    if (e.format.startsWith("application/"))
      return "Dataset";
  }
  return t && (t.endsWith(".jpg") || t.endsWith(".png") || t.endsWith(".jpeg")) ? "Image" : r || "unknown";
}
const Aa = /http(s)?:\/\/(creativecommons.org|rightsstatements.org)[^"'\\<\n]+/gm;
function xa(e) {
  const t = e.match(Aa);
  return t ? t[0] : e;
}
function wa(e, t = "Rights/License", r = "none") {
  let i = null;
  const n = [], s = Array.isArray(e) ? e : [e];
  for (const o of s) {
    const a = o ? xa(o) : void 0;
    if (a && (a.indexOf("creativecommons.org") !== -1 || a.indexOf("rightsstatements.org") !== -1)) {
      a.startsWith("https://") ? i = `http://${a.slice(8)}` : i = a;
      continue;
    }
    a && n.push({
      label: { [r]: [t] },
      value: { [r]: [a] }
    });
  }
  return [i, n];
}
const Sa = [
  "http://iiif.io/api/presentation/2/context.json",
  "http://iiif.io/api/image/2/context.json",
  "http://iiif.io/api/image/1/context.json",
  "http://library.stanford.edu/iiif/image-api/1.1/context.json",
  "http://iiif.io/api/search/1/context.json",
  "http://iiif.io/api/search/0/context.json",
  "http://iiif.io/api/auth/1/context.json",
  "http://iiif.io/api/auth/0/context.json",
  "http://iiif.io/api/annex/openannotation/context.json"
];
function Ca(e) {
  if (e) {
    const t = Array.isArray(e) ? e : [e], r = [];
    for (const i of t)
      i === "http://iiif.io/api/presentation/2/context.json" && r.push("http://iiif.io/api/presentation/3/context.json"), Sa.indexOf(i) === -1 && r.push(i);
    if (t.length)
      return r.length === 1 ? r[0] : r;
  }
}
function Ma(e) {
  return e ? e.map((t) => ({
    label: Ie(t.label),
    value: Ie(t.value)
  })) : [];
}
let fr = 0;
function Pi(e, t) {
  const r = encodeURI(e.id || e["@id"] || "").trim();
  return r && t ? `${r}/${t}` : r || (fr++, `http://example.org/${e["@type"]}${t ? `/${t}` : ""}/${fr}`);
}
function fe(e) {
  const t = [...e.behavior || []];
  e.viewingHint && t.push(e.viewingHint);
  let r;
  return Array.isArray(e.motivation) ? r = e.motivation.map(lr) : e.motivation && (r = lr(e.motivation)), {
    "@context": e["@context"] ? Ca(e["@context"]) : void 0,
    id: (e["@id"] || Pi(e)).trim(),
    type: _t(e),
    behavior: t.length ? t : void 0,
    height: e.height ? e.height : void 0,
    width: e.width ? e.width : void 0,
    motivation: r,
    viewingDirection: e.viewingDirection,
    profile: e.profile,
    format: e.format ? e.format : void 0,
    duration: void 0,
    timeMode: void 0
  };
}
function pe(e) {
  const [t, r] = wa(e.license), i = [...e.metadata ? Ma(e.metadata) : [], ...r];
  return {
    rights: t,
    metadata: i.length ? i : void 0,
    label: e.label ? Ie(e.label) : void 0,
    requiredStatement: e.attribution ? {
      label: Ie(Tt.attributionLabel),
      value: Ie(e.attribution)
    } : void 0,
    navDate: e.navDate,
    summary: e.description ? Ie(e.description) : void 0,
    thumbnail: Ra(e.thumbnail)
  };
}
function Ra(e) {
  return e && (Array.isArray(e) ? e : [e]).map((t) => typeof t == "string" ? { id: t, type: "Image" } : (t.type === "unknown" && (t.type = "Image"), t));
}
function Ia(e) {
  if (!e.within)
    return;
  const t = Array.isArray(e.within) ? e.within : [e.within], r = [];
  for (const i of t)
    if (typeof i == "string") {
      if (i)
        switch (e["@type"]) {
          case "sc:Manifest":
            r.push({ id: i, type: "Collection" });
            break;
        }
    } else
      i["@id"] && r.push({
        id: i["@id"],
        type: _t(i)
      });
  return r.length ? r : void 0;
}
function Ae(e) {
  const t = e.related ? Array.isArray(e.related) ? e.related : [e.related] : [], r = e.contentLayer;
  return {
    provider: e.logo || t.length ? [
      {
        id: Tt.providerId,
        type: "Agent",
        homepage: t.length ? [t[0]] : void 0,
        logo: e.logo ? Array.isArray(e.logo) ? e.logo : [e.logo] : void 0,
        label: Ie(Tt.providerName)
      }
    ] : void 0,
    partOf: Ia(e),
    rendering: e.rendering,
    seeAlso: e.seeAlso,
    start: e.startCanvas,
    service: e.service ? ia(e.service) : void 0,
    supplementary: r ? [r] : void 0
  };
}
function Ta(e) {
  return {
    chars: e.chars,
    format: e.format ? e.format : void 0,
    language: e.language
  };
}
function ka(e) {
  return le({
    ...fe(e),
    ...pe(e),
    ...Ae(e),
    items: e.members
  });
}
function Oa(e) {
  const t = [], r = [];
  let i;
  for (const s of e.sequences || [])
    s.canvases.length && t.push(...s.canvases), s.behavior && r.push(...s.behavior), s.startCanvas && (i = s.startCanvas);
  const n = fe(e);
  return r.length && (n.behavior ? n.behavior.push(...r) : n.behavior = r), le({
    ...n,
    ...pe(e),
    ...Ae(e),
    start: i,
    items: t,
    structures: e.structures
  });
}
function Ea(e) {
  return le({
    ...fe(e),
    ...pe(e),
    ...Ae(e),
    annotations: e.otherContent && e.otherContent.length ? e.otherContent : void 0,
    items: e.images && e.images.length ? [
      {
        id: Pi(e, "annotation-page"),
        type: "AnnotationPage",
        items: e.images
      }
    ] : void 0
  });
}
function Pa(e) {
  return le({
    ...fe(e),
    ...pe(e),
    ...Ae(e),
    items: e.resources && e.resources.length ? e.resources : void 0
  });
}
function La(e) {
  return !e.canvases || e.canvases.length === 0 ? {
    canvases: [],
    behavior: []
  } : {
    canvases: e.canvases,
    behavior: e.viewingHint ? [e.viewingHint] : [],
    startCanvas: e.startCanvas
  };
}
function Fa(e) {
  function t(r) {
    if (Array.isArray(r)) {
      if (r.length > 1)
        return { type: "List", items: r.map(t) };
      r = r[0];
    }
    if (typeof r == "string")
      return encodeURI(r).trim();
    if ("@type" in r) {
      let i;
      if (typeof r.full == "string")
        i = r.full;
      else if (r.full["@type"] === "dctypes:Image")
        i = { id: r.full["@id"], type: "Image" };
      else if (r.full["@type"] === "sc:Canvas")
        i = { id: r.full["@id"], type: "Canvas" };
      else
        throw new Error(`Unsupported source type on annotation: ${r.full["@type"]}`);
      return {
        type: "SpecificResource",
        source: i,
        selector: Ot(r.selector)
      };
    } else
      return encodeURI(r["@id"]).trim();
  }
  return le({
    ...fe(e),
    ...pe(e),
    ...Ae(e),
    target: t(e.on),
    body: Array.isArray(e.resource) ? e.resource.map(kt) : kt(e.resource)
  });
}
function kt(e) {
  const t = e;
  return le({
    ...fe(t),
    ...pe(t),
    ...Ae(t),
    ...Ta(t)
  });
}
function ja(e) {
  const t = [];
  return e.default && e.default !== "rdf:nil" && t.push(e.default), e.item && e.item !== "rdf:nil" && t.push(...e.item), {
    ...fe(e),
    ...pe(e),
    items: t
  };
}
function $a(e) {
  return le({
    ...fe(e),
    ...pe(e),
    ...Ae(e),
    items: e.members
  });
}
function Da(e) {
  const { "@id": t, "@type": r, "@context": i, profile: n, ...s } = e, o = {};
  return t && (o["@id"] = t), o["@type"] = _t(e), o["@type"] === "unknown" && (i && i.length && (o["@context"] = i), o["@type"] = "Service"), n && (o.profile = Ei(n)), le({
    ...o,
    ...s
  });
}
function qa(e) {
  return le({
    ...fe(e),
    ...pe(e),
    ...Ae(e)
  });
}
new qt({
  collection: [ka],
  manifest: [Oa],
  canvas: [Ea],
  annotationList: [Pa],
  sequence: [La],
  annotation: [Fa],
  contentResource: [kt],
  choice: [ja],
  range: [$a],
  service: [Da],
  layer: [qa]
});
function Ot(e) {
  if ((Array.isArray(e["@type"]) && e["@type"].includes("oa:SvgSelector") || e["@type"] == "oa:SvgSelector") && ("chars" in e || "value" in e))
    return {
      type: "SvgSelector",
      value: "chars" in e ? e.chars : e.value
    };
  if (e["@type"] === "oa:FragmentSelector")
    return {
      type: "FragmentSelector",
      value: e.value
    };
  if (e["@type"] === "oa:Choice")
    return [
      Ot(e.default),
      ...(Array.isArray(e.item) ? e.item : [e.item]).map(
        Ot
      )
    ];
  if (e["@type"] == "iiif:ImageApiSelector")
    return {
      type: "ImageApiSelector",
      region: "region" in e ? e.region : void 0,
      rotation: "rotation" in e ? e.rotation : void 0
    };
  throw new Error(`Unsupported selector type: ${e["@type"]}`);
}
var pr = { exports: {} };
(function(e, t) {
  var r = Object.defineProperty, i = (s, o, a) => o in s ? r(s, o, { enumerable: !0, configurable: !0, writable: !0, value: a }) : s[o] = a, n = (s, o, a) => (i(s, typeof o != "symbol" ? o + "" : o, a), a);
  (function(s, o) {
    o(t);
  })(Fo, function(s) {
    const o = "http://library.stanford.edu/iiif/image-api/compliance.html#level1", a = "http://library.stanford.edu/iiif/image-api/compliance.html#level2", u = "http://library.stanford.edu/iiif/image-api/conformance.html#level1", d = "http://library.stanford.edu/iiif/image-api/conformance.html#level2", l = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level1", p = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level2", v = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level1", m = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level2", h = "http://iiif.io/api/image/1/level1.json", g = "http://iiif.io/api/image/1/profiles/level1.json", b = "http://iiif.io/api/image/1/level2.json", A = "http://iiif.io/api/image/1/profiles/level2.json", w = "http://iiif.io/api/image/2/level1.json", C = "http://iiif.io/api/image/2/profiles/level1.json", T = "http://iiif.io/api/image/2/level2.json", j = "http://iiif.io/api/image/2/profiles/level2.json", I = "level1", L = "level2", P = "http://iiif.io/api/image/2/level1", M = "http://iiif.io/api/image/2/level2", $ = [P, M, o, a, u, d, l, p, v, m, h, g, b, A, w, C, T, j, I, L], ie = ["http://iiif.io/api/image/2/level0", P, M, "http://library.stanford.edu/iiif/image-api/compliance.html#level0", o, a, "http://library.stanford.edu/iiif/image-api/conformance.html#level0", u, d, "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level0", l, p, "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level0", v, m, "http://iiif.io/api/image/1/level0.json", "http://iiif.io/api/image/1/profiles/level0.json", h, g, b, A, "http://iiif.io/api/image/2/level0.json", "http://iiif.io/api/image/2/profiles/level0.json", w, C, T, j, "level0", I, L], Z = ["sc:Collection", "sc:Manifest", "sc:Canvas", "sc:AnnotationList", "oa:Annotation", "sc:Range", "sc:Layer", "sc:Sequence", "oa:Choice", "Service", "ContentResource"];
    class U {
      constructor(c, y = {}) {
        n(this, "traversals"), n(this, "options"), this.traversals = { collection: [], manifest: [], canvas: [], annotationList: [], sequence: [], annotation: [], contentResource: [], choice: [], range: [], service: [], layer: [], ...c }, this.options = { convertPropsToArray: !0, mergeMemberProperties: !0, allowUndefinedReturn: !1, ...y };
      }
      static all(c) {
        return new U({ collection: [c], manifest: [c], canvas: [c], annotationList: [c], sequence: [c], annotation: [c], contentResource: [c], choice: [c], range: [c], service: [c], layer: [c] });
      }
      traverseCollection(c) {
        return this.traverseType(this.traverseDescriptive(this.traverseLinking(this.traverseCollectionItems(c))), this.traversals.collection);
      }
      traverseCollectionItems(c) {
        if (this.options.mergeMemberProperties) {
          const y = [...(c.manifests || []).map((S) => typeof S == "string" ? { "@id": S, "@type": "sc:Manifest" } : S), ...(c.collections || []).map((S) => typeof S == "string" ? { "@id": S, "@type": "sc:Collection" } : S), ...c.members || []];
          delete c.collections, delete c.manifests, c.members = y;
        }
        return c.manifests && (c.manifests = c.manifests.map((y) => this.traverseManifest(typeof y == "string" ? { "@id": y, "@type": "sc:Manifest" } : y))), c.collections && (c.collections = c.collections.map((y) => this.traverseCollection(typeof y == "string" ? { "@id": y, "@type": "sc:Collection" } : y))), c.members && (c.members = c.members.map((y) => typeof y == "string" ? y : this.traverseUnknown(y))), c;
      }
      traverseManifest(c) {
        return this.traverseType(this.traverseDescriptive(this.traverseLinking(this.traverseManifestItems(c))), this.traversals.manifest);
      }
      traverseManifestItems(c) {
        return c.sequences && (c.sequences = c.sequences.map((y) => this.traverseSequence(y))), c.structures && (c.structures = c.structures.map((y) => this.traverseRange(y))), c;
      }
      traverseSequence(c) {
        return this.traverseType(this.traverseDescriptive(this.traverseLinking(this.traverseSequenceItems(c))), this.traversals.sequence);
      }
      traverseSequenceItems(c) {
        return c.canvases && (c.canvases = c.canvases.map((y) => this.traverseCanvas(y))), c;
      }
      traverseCanvas(c) {
        return this.traverseType(this.traverseDescriptive(this.traverseLinking(this.traverseCanvasItems(c))), this.traversals.canvas);
      }
      traverseCanvasItems(c) {
        return c.images && (c.images = c.images.map((y) => this.traverseAnnotation(y))), c.otherContent && (c.otherContent = c.otherContent.map((y) => this.traverseAnnotationList(y))), c;
      }
      traverseRange(c) {
        return this.traverseType(this.traverseDescriptive(this.traverseLinking(this.traverseRangeItems(c))), this.traversals.range);
      }
      traverseRangeItems(c) {
        if (this.options.mergeMemberProperties) {
          const y = [...(c.ranges || []).map((S) => typeof S == "string" ? { "@id": S, "@type": "sc:Range" } : S), ...(c.canvases || []).map((S) => typeof S == "string" ? { "@id": S, "@type": "sc:Canvas" } : S), ...c.members || []];
          delete c.ranges, delete c.canvases, c.members = y.length ? y.map((S) => this.traverseUnknown(S)) : void 0;
        }
        return c;
      }
      traverseAnnotationList(c) {
        const y = typeof c == "string" ? { "@id": c, "@type": "sc:AnnotationList" } : c;
        return this.traverseType(this.traverseDescriptive(this.traverseAnnotationListItems(y)), this.traversals.annotationList);
      }
      traverseAnnotationListItems(c) {
        return c.resources && (c.resources = c.resources.map((y) => this.traverseAnnotation(y))), c;
      }
      traverseAnnotation(c) {
        return this.traverseType(this.traverseDescriptive(this.traverseLinking(this.traverseAnnotationItems(c))), this.traversals.annotation);
      }
      traverseAnnotationItems(c) {
        return c.resource && (Array.isArray(c.resource) ? c.resource = c.resource.map((y) => this.traverseContentResource(y)) : c.resource = this.traverseContentResource(c.resource)), c.on, c;
      }
      traverseLayer(c) {
        return this.traverseType(this.traverseLinking(this.traverseLayerItems(c)), this.traversals.layer);
      }
      traverseLayerItems(c) {
        return c.otherContent && (c.otherContent = c.otherContent.map((y) => this.traverseAnnotationList(y))), c;
      }
      traverseChoice(c) {
        return this.traverseType(this.traverseChoiceItems(c), this.traversals.choice);
      }
      traverseChoiceItems(c) {
        return c.default && c.default !== "rdf:nil" && (c.default = this.traverseContentResource(c.default)), c.item && c.item !== "rdf:nil" && (c.item = c.item.map((y) => this.traverseContentResource(y))), c;
      }
      traverseService(c) {
        return this.traverseType(this.traverseLinking(c), this.traversals.service);
      }
      traverseContentResource(c) {
        return c["@type"] === "oa:Choice" ? this.traverseChoice(c) : this.traverseType(this.traverseDescriptive(this.traverseLinking(c)), this.traversals.contentResource);
      }
      traverseUnknown(c) {
        if (!c["@type"] || typeof c == "string")
          return c;
        switch (function(y) {
          if (y == null)
            throw new Error("Null or undefined is not a valid entity.");
          if (Array.isArray(y))
            throw new Error("Array is not a valid entity");
          if (typeof y != "object")
            throw new Error(typeof y + " is not a valid entity");
          if (typeof y["@type"] == "string") {
            const S = Z.indexOf(y["@type"]);
            if (S !== -1)
              return Z[S];
          }
          if (y.profile)
            return "Service";
          if (y.format || y["@type"])
            return "ContentResource";
          throw new Error("Resource type is not known");
        }(c)) {
          case "sc:Collection":
            return this.traverseCollection(c);
          case "sc:Manifest":
            return this.traverseManifest(c);
          case "sc:Canvas":
            return this.traverseCanvas(c);
          case "sc:Sequence":
            return this.traverseSequence(c);
          case "sc:Range":
            return this.traverseRange(c);
          case "oa:Annotation":
            return this.traverseAnnotation(c);
          case "sc:AnnotationList":
            return this.traverseAnnotationList(c);
          case "sc:Layer":
            return this.traverseLayer(c);
          case "Service":
            return this.traverseService(c);
          case "oa:Choice":
            return this.traverseChoice(c);
          case "ContentResource":
            return this.traverseContentResource(c);
        }
        return c.profile ? this.traverseService(c) : c;
      }
      traverseImageResource(c) {
        const y = Array.isArray(c), S = Array.isArray(c) ? c : [c], F = [];
        for (const k of S)
          typeof k == "string" ? F.push(this.traverseContentResource({ "@id": k, "@type": "dctypes:Image" })) : F.push(this.traverseContentResource(k));
        return y || this.options.convertPropsToArray ? F : F[0];
      }
      traverseDescriptive(c) {
        return c.thumbnail && (c.thumbnail = this.traverseImageResource(c.thumbnail)), c.logo && (c.logo = this.traverseImageResource(c.logo)), c;
      }
      traverseOneOrMoreServices(c) {
        const y = Array.isArray(c), S = Array.isArray(c) ? c : [c], F = [];
        for (const k of S)
          F.push(this.traverseService(k));
        return y || this.options.convertPropsToArray ? F : F[0];
      }
      traverseLinking(c) {
        return c.related && (c.related = this.traverseOneOrManyType(c.related, this.traversals.contentResource)), c.rendering && (c.rendering = this.traverseOneOrManyType(c.rendering, this.traversals.contentResource)), c.service && (c.service = this.traverseOneOrMoreServices(c.service)), c.seeAlso && (c.seeAlso = this.traverseOneOrManyType(c.seeAlso, this.traversals.contentResource)), c.within && (typeof c.within == "string" || (c.within = this.traverseOneOrManyType(c.within, this.traversals.contentResource))), c.startCanvas && (typeof c.startCanvas == "string" ? c.startCanvas = this.traverseType({ "@id": c.startCanvas, "@type": "sc:Canvas" }, this.traversals.canvas) : c.startCanvas && this.traverseType(c.startCanvas, this.traversals.canvas)), c.contentLayer && (typeof c.contentLayer == "string" ? c.contentLayer = this.traverseLayer({ "@id": c.contentLayer, "@type": "sc:Layer" }) : c.contentLayer = this.traverseLayer(c.contentLayer)), c;
      }
      traverseOneOrManyType(c, y) {
        if (!Array.isArray(c)) {
          if (!this.options.convertPropsToArray)
            return this.traverseType(c, y);
          c = [c];
        }
        return c.map((S) => this.traverseType(S, y));
      }
      traverseType(c, y) {
        return y.reduce((S, F) => {
          const k = F(S);
          return k !== void 0 || this.options.allowUndefinedReturn ? k : S;
        }, c);
      }
    }
    function z(f) {
      for (const c in f)
        f[c] !== void 0 && f[c] !== null || delete f[c];
      return f;
    }
    const ee = "Attribution", ne = "http://example.org/provider", xe = "Unknown";
    function O(f, c = "none") {
      if (!f)
        return {};
      const y = Array.isArray(f) ? f : [f], S = {};
      for (const F of y) {
        if (typeof F == "string") {
          S[c] = S[c] ? S[c] : [], S[c].push(F || "");
          continue;
        }
        if (!F["@language"]) {
          S[c] = S[c] ? S[c] : [], S[c].push(F["@value"] || "");
          continue;
        }
        const k = F["@language"];
        S[k] = S[k] ? S[k] : [], S[k].push(F["@value"] || "");
      }
      return S;
    }
    function W(f) {
      return Array.isArray(f) ? W(f.find((c) => typeof c == "string")) : ie.indexOf(f) !== -1 ? "level2" : $.indexOf(f) !== -1 ? "level1" : typeof f == "string" ? f : void 0;
    }
    function X(f) {
      for (const c of ["sc", "oa", "dcterms", "dctypes", "iiif"])
        if (f.startsWith(`${c}:`))
          return f.slice(c.length + 1);
      return f;
    }
    const de = ["Collection", "Manifest", "Annotation", "AnnotationPage", "Range", "Service"];
    function nt(f) {
      const c = f["@id"] || f.id;
      let y = f["@type"] || f.type;
      const S = f.profile || void 0, F = f["@context"] || void 0;
      if (S) {
        const k = function(Y) {
          switch (Y) {
            case "http://iiif.io/api/image/2/level0.json":
            case "http://iiif.io/api/image/2/level1.json":
            case "http://iiif.io/api/image/2/level2.json":
              return "ImageService2";
            case "http://iiif.io/api/auth/1/kiosk":
            case "http://iiif.io/api/auth/1/login":
            case "http://iiif.io/api/auth/1/clickthrough":
            case "http://iiif.io/api/auth/1/external":
            case "http://iiif.io/api/auth/0/kiosk":
            case "http://iiif.io/api/auth/0/login":
            case "http://iiif.io/api/auth/0/clickthrough":
            case "http://iiif.io/api/auth/0/external":
              return "AuthCookieService1";
            case "http://iiif.io/api/auth/1/token":
            case "http://iiif.io/api/auth/0/token":
              return "AuthTokenService1";
            case "http://iiif.io/api/auth/1/logout":
            case "http://iiif.io/api/auth/0/logout":
              return "AuthLogoutService1";
            case "http://iiif.io/api/search/1/search":
            case "http://iiif.io/api/search/0/search":
              return "SearchService1";
            case "http://iiif.io/api/search/1/autocomplete":
            case "http://iiif.io/api/search/0/autocomplete":
              return "AutoCompleteService1";
          }
        }(S);
        if (k)
          return k;
      }
      if (F) {
        const k = function(Y) {
          const Ue = Array.isArray(Y) ? Y : [Y];
          for (const Ve of Ue)
            switch (Ve) {
              case "http://iiif.io/api/image/2/context.json":
              case "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level2":
                return "ImageService2";
              case "http://iiif.io/api/image/1/context.json":
              case "http://library.stanford.edu/iiif/image-api/1.1/context.json":
                return "ImageService1";
              case "http://iiif.io/api/annex/openannotation/context.json":
                return "ImageApiSelector";
            }
        }(F);
        if (k)
          return k;
      }
      if (y) {
        if (Array.isArray(y)) {
          if (y.indexOf("oa:CssStylesheet") !== -1)
            return "CssStylesheet";
          if (y.indexOf("cnt:ContentAsText") !== -1)
            return "TextualBody";
          y = y[0];
        }
        for (const k of ["sc", "oa", "dcterms", "dctypes", "iiif"])
          if (y.startsWith(`${k}:`)) {
            y = y.slice(k.length + 1);
            break;
          }
        switch (y) {
          case "Layer":
            return "AnnotationCollection";
          case "AnnotationList":
            return "AnnotationPage";
          case "cnt:ContentAsText":
            return "TextualBody";
        }
      }
      if (y && de.indexOf(y) !== -1)
        return y;
      if (f.format) {
        if (f.format.startsWith("image/"))
          return "Image";
        if (f.format.startsWith("text/") || f.format === "application/pdf")
          return "Text";
        if (f.format.startsWith("application/"))
          return "Dataset";
      }
      return c && (c.endsWith(".jpg") || c.endsWith(".png") || c.endsWith(".jpeg")) ? "Image" : y || "unknown";
    }
    const Ki = /http(s)?:\/\/(creativecommons.org|rightsstatements.org)[^"'\\<\n]+/gm;
    function Zi(f) {
      const c = f.match(Ki);
      return c ? c[0] : f;
    }
    const Xi = ["http://iiif.io/api/presentation/2/context.json", "http://iiif.io/api/image/2/context.json", "http://iiif.io/api/image/1/context.json", "http://library.stanford.edu/iiif/image-api/1.1/context.json", "http://iiif.io/api/search/1/context.json", "http://iiif.io/api/search/0/context.json", "http://iiif.io/api/auth/1/context.json", "http://iiif.io/api/auth/0/context.json", "http://iiif.io/api/annex/openannotation/context.json"];
    function en(f) {
      if (f) {
        const c = Array.isArray(f) ? f : [f], y = [];
        for (const S of c)
          S === "http://iiif.io/api/presentation/2/context.json" && y.push("http://iiif.io/api/presentation/3/context.json"), Xi.indexOf(S) === -1 && y.push(S);
        if (c.length)
          return y.length === 1 ? y[0] : y;
      }
    }
    let Bt = 0;
    function zt(f, c) {
      const y = encodeURI(f.id || f["@id"] || "").trim();
      return y && c ? `${y}/${c}` : y || (Bt++, `http://example.org/${f["@type"]}${c ? `/${c}` : ""}/${Bt}`);
    }
    function oe(f) {
      const c = [...f.behavior || []];
      let y;
      return f.viewingHint && c.push(f.viewingHint), Array.isArray(f.motivation) ? y = f.motivation.map(X) : f.motivation && (y = X(f.motivation)), { "@context": f["@context"] ? en(f["@context"]) : void 0, id: (f["@id"] || zt(f)).trim(), type: nt(f), behavior: c.length ? c : void 0, height: f.height ? f.height : void 0, width: f.width ? f.width : void 0, motivation: y, viewingDirection: f.viewingDirection, profile: f.profile, format: f.format ? f.format : void 0, duration: void 0, timeMode: void 0 };
    }
    function ae(f) {
      const [c, y] = function(k, Y = "Rights/License", Ue = "none") {
        let Ve = null;
        const Wt = [], on = Array.isArray(k) ? k : [k];
        for (const Qt of on) {
          const ye = Qt ? Zi(Qt) : void 0;
          !ye || ye.indexOf("creativecommons.org") === -1 && ye.indexOf("rightsstatements.org") === -1 ? ye && Wt.push({ label: { [Ue]: [Y] }, value: { [Ue]: [ye] } }) : Ve = ye.startsWith("https://") ? `http://${ye.slice(8)}` : ye;
        }
        return [Ve, Wt];
      }(f.license), S = [...f.metadata ? (F = f.metadata, F ? F.map((k) => ({ label: O(k.label), value: O(k.value) })) : []) : [], ...y];
      var F;
      return { rights: c, metadata: S.length ? S : void 0, label: f.label ? O(f.label) : void 0, requiredStatement: f.attribution ? { label: O(ee), value: O(f.attribution) } : void 0, navDate: f.navDate, summary: f.description ? O(f.description) : void 0, thumbnail: tn(f.thumbnail) };
    }
    function tn(f) {
      return f && (Array.isArray(f) ? f : [f]).map((c) => typeof c == "string" ? { id: c, type: "Image" } : (c.type === "unknown" && (c.type = "Image"), c));
    }
    function rn(f) {
      if (!f.within)
        return;
      const c = Array.isArray(f.within) ? f.within : [f.within], y = [];
      for (const S of c)
        typeof S == "string" ? S && f["@type"] === "sc:Manifest" && y.push({ id: S, type: "Collection" }) : S["@id"] && y.push({ id: S["@id"], type: nt(S) });
      return y.length ? y : void 0;
    }
    function he(f) {
      const c = f.related ? Array.isArray(f.related) ? f.related : [f.related] : [], y = f.contentLayer;
      return { provider: f.logo || c.length ? [{ id: ne, type: "Agent", homepage: c.length ? [c[0]] : void 0, logo: f.logo ? Array.isArray(f.logo) ? f.logo : [f.logo] : void 0, label: O(xe) }] : void 0, partOf: rn(f), rendering: f.rendering, seeAlso: f.seeAlso, start: f.startCanvas, service: f.service ? (S = f.service, Array.isArray(S) ? S : S ? [S] : []) : void 0, supplementary: y ? [y] : void 0 };
      var S;
    }
    function st(f) {
      const c = f;
      return z({ ...oe(c), ...ae(c), ...he(c), ...(y = c, { chars: y.chars, format: y.format ? y.format : void 0, language: y.language }) });
      var y;
    }
    const nn = new U({ collection: [function(f) {
      return z({ ...oe(f), ...ae(f), ...he(f), items: f.members });
    }], manifest: [function(f) {
      const c = [], y = [];
      let S;
      for (const k of f.sequences || [])
        k.canvases.length && c.push(...k.canvases), k.behavior && y.push(...k.behavior), k.startCanvas && (S = k.startCanvas);
      const F = oe(f);
      return y.length && (F.behavior ? F.behavior.push(...y) : F.behavior = y), z({ ...F, ...ae(f), ...he(f), start: S, items: c, structures: f.structures });
    }], canvas: [function(f) {
      return z({ ...oe(f), ...ae(f), ...he(f), annotations: f.otherContent && f.otherContent.length ? f.otherContent : void 0, items: f.images && f.images.length ? [{ id: zt(f, "annotation-page"), type: "AnnotationPage", items: f.images }] : void 0 });
    }], annotationList: [function(f) {
      return z({ ...oe(f), ...ae(f), ...he(f), items: f.resources && f.resources.length ? f.resources : void 0 });
    }], sequence: [function(f) {
      return f.canvases && f.canvases.length !== 0 ? { canvases: f.canvases, behavior: f.viewingHint ? [f.viewingHint] : [], startCanvas: f.startCanvas } : { canvases: [], behavior: [] };
    }], annotation: [function(f) {
      return z({ ...oe(f), ...ae(f), ...he(f), target: function c(y) {
        if (Array.isArray(y)) {
          if (y.length > 1)
            return { type: "List", items: y.map(c) };
          y = y[0];
        }
        if (typeof y == "string")
          return encodeURI(y).trim();
        if ("@type" in y) {
          let S;
          if (typeof y.full == "string")
            S = y.full;
          else if (y.full["@type"] === "dctypes:Image")
            S = { id: y.full["@id"], type: "Image" };
          else {
            if (y.full["@type"] !== "sc:Canvas")
              throw new Error(`Unsupported source type on annotation: ${y.full["@type"]}`);
            S = { id: y.full["@id"], type: "Canvas" };
          }
          return { type: "SpecificResource", source: S, selector: ot(y.selector) };
        }
        return encodeURI(y["@id"]).trim();
      }(f.on), body: Array.isArray(f.resource) ? f.resource.map(st) : st(f.resource) });
    }], contentResource: [st], choice: [function(f) {
      const c = [];
      return f.default && f.default !== "rdf:nil" && c.push(f.default), f.item && f.item !== "rdf:nil" && c.push(...f.item), { ...oe(f), ...ae(f), items: c };
    }], range: [function(f) {
      return z({ ...oe(f), ...ae(f), ...he(f), items: f.members });
    }], service: [function(f) {
      const { "@id": c, "@type": y, "@context": S, profile: F, ...k } = f, Y = {};
      return c && (Y["@id"] = c), Y["@type"] = nt(f), Y["@type"] === "unknown" && (S && S.length && (Y["@context"] = S), Y["@type"] = "Service"), F && (Y.profile = W(F)), z({ ...Y, ...k });
    }], layer: [function(f) {
      return z({ ...oe(f), ...ae(f), ...he(f) });
    }] });
    function ot(f) {
      if ((Array.isArray(f["@type"]) && f["@type"].includes("oa:SvgSelector") || f["@type"] == "oa:SvgSelector") && ("chars" in f || "value" in f))
        return { type: "SvgSelector", value: "chars" in f ? f.chars : f.value };
      if (f["@type"] === "oa:FragmentSelector")
        return { type: "FragmentSelector", value: f.value };
      if (f["@type"] === "oa:Choice")
        return [ot(f.default), ...(Array.isArray(f.item) ? f.item : [f.item]).map(ot)];
      if (f["@type"] == "iiif:ImageApiSelector")
        return { type: "ImageApiSelector", region: "region" in f ? f.region : void 0, rotation: "rotation" in f ? f.rotation : void 0 };
      throw new Error(`Unsupported selector type: ${f["@type"]}`);
    }
    const sn = function(f) {
      return f && f["@context"] && (f["@context"] === "http://iiif.io/api/presentation/2/context.json" || f["@context"].indexOf("http://iiif.io/api/presentation/2/context.json") !== -1 || f["@context"] === "http://www.shared-canvas.org/ns/context.json") || f["@context"] === "http://iiif.io/api/image/2/context.json" ? nn.traverseUnknown(f) : f;
    };
    s.upgrade = sn, Object.defineProperties(s, { __esModule: { value: !0 }, [Symbol.toStringTag]: { value: "Module" } });
  });
})(pr, pr.exports);
function Oc(e) {
  return e.type === "SpecificResource" ? [e.source, { selector: e.selector }] : [e, { selector: null }];
}
function Li(e, t) {
  const { selector: r, source: i } = je(t);
  if (i.id !== e.id)
    return [null, i];
  const n = {
    type: "BoxSelector",
    spatial: {
      x: 0,
      y: 0,
      width: Number(e.width),
      height: Number(e.height)
    }
  };
  return [
    r ? r.type === "TemporalSelector" ? {
      type: "TemporalBoxSelector",
      temporal: r.temporal,
      spatial: n.spatial
    } : r : null,
    i
  ];
}
const _a = {
  makeChoice: () => {
  }
}, gt = { type: "unknown" }, _ = (e) => ({ type: "unknown", reason: e, annotations: { pages: [] } }), Ua = (e, t) => ({ type: "empty", width: e, height: t, annotations: { pages: [] }, image: null, images: [] });
function Va(e, t) {
  var i;
  const r = (i = e == null ? void 0 : e.iiif) == null ? void 0 : i.meta[t];
  return r ? r.annotationPageManager : null;
}
function Na(e, t) {
  return Q(
    (r) => {
      const i = [];
      if (!e)
        return i;
      const n = Object.keys(r.iiif.entities.AnnotationPage);
      for (const s of n)
        if (!t || t.indexOf(s) !== -1) {
          const o = Va(r, s);
          o && o.views && o.views[e] && i.push(s);
        }
      return i;
    },
    [e, t]
  );
}
function Ha({
  canvas: e,
  manifest: t,
  all: r,
  canvases: i
}) {
  const n = [];
  if (t)
    for (const s of t.annotations)
      n.indexOf(s.id) === -1 && n.push(s.id);
  if (r) {
    if (i && i.length)
      for (const s of i)
        for (const o of s.annotations)
          n.indexOf(o.id) === -1 && n.push(o.id);
  } else if (e)
    for (const s of e.annotations)
      n.indexOf(s.id) === -1 && n.push(s.id);
  return n;
}
function Ba(e, t) {
  var i;
  const r = (i = e == null ? void 0 : e.iiif) == null ? void 0 : i.meta[t];
  return r ? r.annotationPageManager : null;
}
function za(e, t = {}) {
  const r = V(), i = ke(), n = ue(), s = Br(), o = E(() => Ha({
    all: t.all,
    manifest: i,
    canvas: n,
    canvases: s
  }), [t.all, n, s, i]), a = Na(e, t.all ? void 0 : o), u = D(
    (l) => {
      e && r.setMetaValue(
        [l, "annotationPageManager", "views"],
        (p) => p && !p[e] ? p : {
          ...p || {},
          [e]: !1
        }
      );
    },
    [e, r]
  ), d = D(
    (l, p = {}) => {
      if (!e)
        return;
      const v = r.getState(), m = [];
      if (p != null && p.deselectOthers) {
        const h = Object.keys(v.iiif.entities.AnnotationPage);
        for (const g of h) {
          const b = Ba(v, g);
          b && b.views && b.views[e] && m.push(g);
        }
      }
      for (const h of m)
        u(h);
      r.setMetaValue(
        [l, "annotationPageManager", "views"],
        (h) => h && h[e] ? h : {
          ...h || {},
          [e]: !0
        }
      );
    },
    [e, u, r]
  );
  return {
    availablePageIds: o,
    enabledPageIds: a,
    setPageEnabled: d,
    setPageDisabled: u
  };
}
function Wa(e, t) {
  return Q((r, i) => i.get(e.map((n) => ({ id: n, type: t }))), [e, t]);
}
const Qa = me.createContext(new gr());
function Ut() {
  return H(Qa);
}
function Ya() {
  const e = Ut(), [t, r] = B({}), i = ge(!1);
  return K(() => () => {
    i.current = !0;
  }, []), [D(
    (s, { height: o, width: a }) => {
      if (s) {
        const u = s.id || s["@id"], d = e.loadServiceSync({
          id: u,
          width: s.width || a,
          height: s.height || o,
          source: s
        });
        d ? s = d : t[u] || (i.current || r((l) => ({
          ...l,
          [u]: "loading"
        })), e.loadService({
          id: u,
          width: s.width || a,
          height: s.height || o
        }).then(() => {
          i.current || r((l) => ({
            ...l,
            [u]: "done"
          }));
        }));
      }
      return s;
    },
    [e, t]
  ), t];
}
function Vt(e = {}) {
  const t = si(), r = ue(e.canvasId ? { id: e.canvasId } : void 0);
  return Q(
    (i, n) => {
      if (!r)
        return [];
      if (t && e.enableSingleAnnotation)
        return [t];
      const s = n.get(r.items), o = [];
      for (const a of s)
        o.push(...n.get(a.items));
      return o;
    },
    [r]
  );
}
function Ga(e) {
  return e.type === "SpecificResource" ? [e.source, { selector: e.selector }] : [e, { selector: null }];
}
const ze = {}, Fi = {
  get(e) {
    return e;
  },
  setMetaValue([e, t, r], i) {
    const n = Fi.getResourceMeta(e, t), s = n ? n[r] : void 0, o = typeof i == "function" ? i(s) : i;
    ze[e] = {
      ...ze[e] || {},
      [t]: {
        ...(ze[e] || {})[t] || {},
        [r]: o
      }
    };
  },
  getResourceMeta: (e, t) => {
    const r = ze[e];
    if (r)
      return t ? r[t] : r;
  }
};
function Ja(e = Fi) {
  function t(n) {
    const s = n ? typeof n == "string" ? e.get(n) : n : null;
    if (!s)
      return [];
    const o = e.get(s.items, { parent: s }), a = [];
    for (const u of o)
      a.push(...e.get(u.items, { parent: u }));
    return a;
  }
  function r(n, s = []) {
    const o = Array.isArray(n) ? n : t(n), a = [];
    let u = null;
    const d = [];
    for (const l of o) {
      if (l.type !== "Annotation")
        throw new Error("getPaintables() accept either a canvas or list of annotations");
      const p = Array.from(Array.isArray(l.body) ? l.body : [l.body]);
      for (const v of p) {
        const [m, { selector: h }] = Ga(v), g = e.get(m), b = (g.type || "unknown").toLowerCase();
        if (b === "choice") {
          const A = e.get(g.items, { parent: g.id }), w = s.length ? s.map((C) => A.find((T) => T.id === C)).filter(Boolean) : [A[0]];
          w.length === 0 && w.push(A[0]), u = {
            type: "single-choice",
            items: A.map((C) => ({
              id: C.id,
              label: C.label,
              selected: w.indexOf(C) !== -1
            })),
            label: m.label
          }, p.push(...w);
          continue;
        }
        a.indexOf(b) === -1 && a.push(b), d.push({
          type: b,
          annotationId: l.id,
          resource: g,
          target: l.target,
          selector: h
        });
      }
    }
    return {
      types: a,
      items: d,
      choice: u
    };
  }
  function i(n) {
    const { choice: s } = r(n);
    return s;
  }
  return {
    getAllPaintingAnnotations: t,
    getPaintables: r,
    extractChoices: i
  };
}
function Ka(e, t = []) {
  const r = V(), i = E(() => Ja(r), []), n = Vt({ enableSingleAnnotation: e == null ? void 0 : e.enableSingleAnnotation }), [s, o] = B((e == null ? void 0 : e.defaultChoices) || []), a = E(
    () => i.getPaintables(n, s),
    [r, n, s, ...t]
  ), d = { makeChoice: D(
    (l, { deselectOthers: p = !0, deselect: v = !1 } = {}) => {
      if (a.choice) {
        if (a.choice.type !== "single-choice")
          throw new Error("Complex choice not supported yet");
        o((m) => {
          if (v) {
            const g = m.filter((b) => b !== l);
            if (g.length === 0) {
              const b = a.items[0].resource.id;
              return b ? [b] : [];
            }
            return g;
          }
          if (p)
            return [l];
          const h = [...m];
          if (h.length === 0 && a.items.length) {
            const g = a.items[0].resource.id;
            g && h.push(g);
          }
          return m.indexOf(l) !== -1 ? m : [...m, l];
        });
      }
    },
    [a.choice]
  ) };
  return [a, d];
}
function Za(e, t, r) {
  const i = [];
  for (const n of t.items) {
    const s = n.resource && n.resource.type === "SpecificResource" ? n.resource.source : n.resource;
    if (!s.id)
      return _("No resource Identifier");
    let o;
    if (s.service) {
      const m = mt(s);
      m[0] && (o = r(m[0], e));
    }
    const a = {
      type: "BoxSelector",
      spatial: {
        x: 0,
        y: 0,
        width: Number(e.width),
        height: Number(e.height)
      }
    }, [u, d] = Li(e, n.target);
    if (d.id !== e.id)
      continue;
    n.resource.width && n.resource.height && (n.resource.width, n.resource.height);
    let l = n.resource.type === "SpecificResource" ? Re(n.resource) : null;
    if (n.selector) {
      const m = Re({
        type: "SpecificResource",
        source: n.resource,
        selector: n.selector
      });
      m && (l = m);
    }
    const p = l && l.selector && (l.selector.type === "BoxSelector" || l.selector.type === "TemporalBoxSelector") ? {
      type: "BoxSelector",
      spatial: {
        x: l.selector.spatial.x,
        y: l.selector.spatial.y,
        width: l.selector.spatial.width,
        height: l.selector.spatial.height
      }
    } : void 0;
    o && !o.id && (o.id = o["@id"]);
    const v = {
      id: s.id,
      type: "Image",
      annotationId: n.annotationId,
      width: Number(u || p ? s.width : e.width),
      height: Number(u || p ? s.height : e.height),
      service: o,
      sizes: o && o.sizes ? o.sizes : s.width && s.height ? [{ width: s.width, height: s.height }] : [],
      target: u && u.type !== "PointSelector" ? u : a,
      selector: p
    };
    i.push(v);
  }
  return {
    type: "images",
    image: i[0],
    images: i,
    choice: t.choice
  };
}
const Xa = ["model/gltf-binary"];
function ec(e, t) {
  const i = t.items[0].resource;
  return i.format ? Xa.indexOf(i.format) === -1 ? _(`3D format: ${i.format} is unsupported`) : {
    type: "3d-model",
    model: i
  } : _("Unknown format");
}
function tc(e, t) {
  var i;
  if (!e.duration)
    return _("No duration on canvas");
  if (t.items.length > 1)
    return _("Only one audio source supported");
  const r = (i = t.items[0]) == null ? void 0 : i.resource;
  return r ? r.format ? {
    type: "media",
    media: {
      annotationId: t.items[0].annotationId,
      duration: e.duration,
      url: r.id,
      type: "Sound",
      target: {
        type: "TemporalSelector",
        temporal: {
          startTime: 0,
          endTime: e.duration
        }
      },
      format: r.format,
      selector: {
        type: "TemporalSelector",
        temporal: {
          startTime: 0,
          endTime: e.duration
        }
      }
    },
    annotations: {
      pages: []
    }
  } : _("Audio does not have format") : _("Unknown audio");
}
const rc = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?vi?=|&vi?=))([^#&?]*).*/;
function ic(e, t) {
  var o;
  const r = t.items.filter((a) => a.type === "video");
  if (!e.duration)
    return _("No duration on canvas");
  if (r.length > 1)
    return _("Only one video source supported");
  const i = (o = r[0]) == null ? void 0 : o.resource, n = !!(i.service || []).find(
    (a) => (a.profile || "").includes("youtube.com")
  );
  if (!i)
    return _("Unknown video");
  if ((!i.format || i.format === "text/html") && !n)
    return _("Video does not have format");
  const s = {
    annotationId: t.items[0].annotationId,
    duration: e.duration,
    url: i.id,
    type: "Video",
    items: [],
    target: {
      type: "TemporalSelector",
      temporal: {
        startTime: 0,
        endTime: e.duration
      }
    },
    format: i.format,
    selector: {
      type: "TemporalSelector",
      temporal: {
        startTime: 0,
        endTime: e.duration
      }
    }
  };
  if (n) {
    s.type = "VideoYouTube";
    const a = i.id.match(rc);
    if (!a[1])
      return _("Video is not known youtube video");
    s.youTubeId = a[1];
  }
  return {
    type: "media",
    media: s,
    annotations: {
      pages: []
    }
  };
}
function ji(e, t = {}, r) {
  const i = e.language || r || "none";
  switch (e.type) {
    case "TextualBody": {
      typeof e.value < "u" && (t[i] = e.value);
      break;
    }
    case "List":
    case "Composite":
    case "Choice":
      e.items && e.items.forEach((n) => ji(n, t, i));
  }
  return t;
}
function nc(e, t) {
  const r = [];
  return t.items.forEach((i) => {
    if (i.resource) {
      const [n] = Li(e, i.target);
      r.push({ annotationId: i.annotationId, text: ji(i.resource), target: n });
    }
  }), {
    type: "textual-content",
    items: r
  };
}
function sc(e) {
  const t = ke(), r = ue(), i = V(), [n, s] = Ya(), { enabledPageIds: o } = za((e == null ? void 0 : e.annotationPageManagerId) || (t == null ? void 0 : t.id) || (r == null ? void 0 : r.id), {
    all: !1
  }), a = Wa(o, "AnnotationPage"), u = (e == null ? void 0 : e.strategies) || [
    "empty",
    "images",
    "media",
    "textual-content",
    "complex-timeline"
  ], [d, l] = Ka(e, [s]), p = E(() => {
    if (!r)
      return console.log("No canvas"), gt;
    if (d.types.length === 0)
      return u.indexOf("empty") !== -1 ? Ua(r.width, r.height) : (console.log("No paintables"), gt);
    if (d.types.length !== 1)
      if (d.types.length === 2 && d.types.indexOf("text") !== -1)
        d.types = d.types.filter((m) => m !== "text");
      else
        return u.indexOf("complex-timeline") === -1 ? _("Complex timeline not supported") : _("ComplexTimelineStrategy not yet supported");
    const v = d.types[0];
    return v === "image" ? u.indexOf("images") === -1 ? _("Image not supported") : Za(r, d, n) : v === "Model" || v === "model" ? u.indexOf("3d-model") === -1 ? _("3D not supported") : ec(r, d) : v === "textualbody" ? u.indexOf("textual-content") === -1 ? _("Textual content not supported") : nc(r, d) : v === "sound" || v === "audio" ? u.indexOf("media") === -1 ? _("Media not supported") : tc(r, d) : v === "video" ? u.indexOf("media") === -1 ? _("Media not supported") : ic(r, d) : (console.log("No idea"), gt);
  }, [r, d, i, l.makeChoice]);
  return E(() => p.type === "unknown" ? [p, _a] : [
    {
      ...p,
      annotations: { pages: a }
    },
    l
  ], [p, a]);
}
const oc = (e, t = []) => {
  const r = V();
  K(() => {
    e(r);
  }, [r, ...t]);
}, We = {}, $i = {
  get(e) {
    return e;
  },
  setMetaValue([e, t, r], i) {
    const n = $i.getResourceMeta(e, t), s = n ? n[r] : void 0, o = typeof i == "function" ? i(s) : i;
    We[e] = {
      ...We[e] || {},
      [t]: {
        ...(We[e] || {})[t] || {},
        [r]: o
      }
    };
  },
  getResourceMeta: (e, t) => {
    const r = We[e];
    if (r)
      return t ? r[t] : r;
  }
}, ac = new gr();
function cc(e = $i, t = {}) {
  const r = t.imageServiceLoader || ac;
  async function i(n, s, o = !1, a = [], u) {
    const d = () => r.getThumbnailFromResource(void 0, s, o, a);
    if (!n)
      return await r.getThumbnailFromResource(void 0, s, o, a);
    if (typeof n == "string") {
      const p = Yt(n);
      return p && a.push(p), await r.getThumbnailFromResource(void 0, s, o, a);
    }
    const l = e.get(n, { skipSelfReturn: !1 });
    if (typeof l == "string")
      return { best: Yt(l), fallback: [], log: [] };
    if (!l)
      return await d();
    switch (await (async (p) => {
      if (p && p.thumbnail && p.thumbnail.length) {
        const v = e.get(p.thumbnail[0]), m = await r.getImageCandidates(v, o);
        m && m.length && a.push(...m);
      }
    })(l), l.type) {
      case "Annotation": {
        const p = Array.isArray(l.body) ? l.body : [l.body], v = e.get(p[0]);
        return u && !v.width && (v.width = u.width, v.height = u.height), await r.getThumbnailFromResource(v, s, o, a);
      }
      case "Canvas": {
        const p = l;
        return i(p.items[0], s, o, a, {
          width: p.width,
          height: p.height
        });
      }
      case "AnnotationPage":
        return i(l.items[0], s, o, a, u);
      case "Choice": {
        const p = l;
        return !p.items || p.items[0] ? await d() : i(p.items[0], s, o, a, u);
      }
      case "Collection": {
        const p = l.items[0];
        return p ? i(p, s, o, a, u) : await d();
      }
      case "Manifest": {
        const p = l.items[0];
        return p ? i(p, s, o, a, u) : await d();
      }
      case "SpecificResource":
      case "Image":
      case "Dataset":
      case "Sound":
      case "Text":
      case "TextualBody":
      case "Video":
        return u && !l.width && (l.width = u.width, l.height = u.height), r.getThumbnailFromResource(l, s, o, a);
    }
    return await d();
  }
  return {
    getBestThumbnailAtSize: i
  };
}
function uc(e, t, { canvasId: r, manifestId: i } = {}) {
  const n = V(), s = Ut(), o = E(() => cc(n, { imageServiceLoader: s }), [n, s]), [a, u] = B(), d = ke(i ? { id: i } : void 0), l = ue(r ? { id: r } : void 0), p = l || d, v = ge(!1);
  if (K(() => (v.current = !1, () => {
    v.current = !0;
  }), []), !p)
    throw new Error("Must be called under a manifest or canvas context.");
  return oc(
    (m) => {
      o.getBestThumbnailAtSize(p, e, t).then((h) => {
        h.best && !v.current && u(h.best);
      });
    },
    [p]
  ), a;
}
function lc(e) {
  return { isMuted: !1, playRequested: !1, isPlaying: !1, isFinished: !1, volume: 100, duration: e };
}
function fc(e, t) {
  switch (t.type) {
    case "FINISHED":
      return { ...e, isFinished: !0, isPlaying: !1, playRequested: !1 };
    case "PLAY_PAUSE":
      return { ...e, isFinished: !1, isPlaying: !e.isPlaying };
    case "PLAY_REQUESTED":
      return { ...e, isFinished: !1, playRequested: !0 };
    case "PAUSE":
      return { ...e, isPlaying: !1 };
    case "PLAY":
      return { ...e, isFinished: !1, playRequested: !1, isPlaying: !0 };
    case "MUTE":
      return { ...e, isMuted: !0 };
    case "SET_VOLUME":
      return { ...e, volume: t.volume, isMuted: t.volume === 0 };
    case "TOGGLE_MUTE":
      return { ...e, isMuted: !e.isMuted };
    case "UNMUTE":
      return { ...e, isMuted: !1 };
  }
  return e;
}
function pc(e) {
  const t = Math.round(e);
  return `${Math.floor(t / 60)}:${`${t % 60}`.padStart(2, "0")}`;
}
function Nt(e) {
  const [t, r] = an(fc, lc(e.duration)), i = ge(null), n = ge(null), s = ge(null), o = ge(!1), a = D(() => {
    n.current && i.current && (n.current.innerHTML = pc(i.current.currentTime), s.current && (s.current.style.width = `${i.current.currentTime / e.duration * 100}%`), o.current !== i.current.muted && (o.current = i.current.muted, r(i.current.muted ? { type: "MUTE" } : { type: "UNMUTE" })));
  }, [e.duration]), u = D(() => {
    i.current && (r({ type: "PLAY_REQUESTED" }), i.current.play().then(() => {
      r({ type: "PLAY" });
    }), a());
  }, [a]), d = D(() => {
    i.current && (i.current.duration > 0 && i.current.paused ? u() : l());
  }, [a]), l = D(() => {
    i.current && (i.current.pause(), r({ type: "PAUSE" }), a());
  }, [a]), p = D(() => {
    i.current && (i.current.muted = !i.current.muted, r(i.current.muted ? { type: "MUTE" } : { type: "UNMUTE" }));
  }, []), v = D(() => {
    i.current && (i.current.muted = !0, r({ type: "MUTE" }));
  }, []), m = D(() => {
    i.current && (i.current.muted = !1, r({ type: "UNMUTE" }));
  }, []), h = D((A) => {
    i.current && (i.current.muted = !1, i.current.volume = A / 100, r({ type: "SET_VOLUME", volume: A }));
  }, []), g = D((A) => {
    i.current && (i.current.currentTime = Math.max(0, Math.min(A * e.duration, e.duration)), a());
  }, []), b = D((A) => {
    i.current && (i.current.currentTime = Math.max(0, Math.min(A, e.duration)), a());
  }, []);
  return K(() => {
    const A = setInterval(() => {
      a();
    }, 350);
    return () => clearInterval(A);
  }, [a, e.duration]), K(() => {
    const A = () => {
      r({ type: "FINISHED" });
    }, w = i.current;
    return w == null || w.addEventListener("ended", A), () => w == null ? void 0 : w.removeEventListener("ended", A);
  }, []), [
    { element: i, currentTime: n, progress: s },
    t,
    {
      play: u,
      pause: l,
      playPause: d,
      mute: v,
      unmute: m,
      toggleMute: p,
      setVolume: h,
      setDurationPercent: g,
      setTime: b
    }
  ];
}
const Di = ce(null), qi = ce(null), _i = ce(null);
function Ec() {
  const e = H(Di);
  if (!e)
    throw new Error("Ctx not found");
  return e;
}
function Pc() {
  const e = H(qi);
  if (!e)
    throw new Error("Ctx not found");
  return e;
}
function Lc() {
  const e = H(_i);
  if (!e)
    throw new Error("Ctx not found");
  return e;
}
function Ui({
  actions: e,
  state: t,
  children: r,
  currentTime: i,
  progress: n,
  element: s
}) {
  return /* @__PURE__ */ x(_i.Provider, { value: { currentTime: i, progress: n, element: s }, children: /* @__PURE__ */ x(qi.Provider, { value: e, children: /* @__PURE__ */ x(Di.Provider, { value: t, children: r }) }) });
}
function Vi({ media: e, children: t }) {
  const [{ element: r, currentTime: i, progress: n }, s, o] = Nt({ duration: e.duration });
  return /* @__PURE__ */ N(
    Ui,
    {
      state: s,
      actions: o,
      currentTime: i,
      progress: n,
      element: r,
      children: [
        /* @__PURE__ */ x("audio", { ref: r, src: e.url }),
        t
      ]
    }
  );
}
function Ni({
  media: e,
  mediaControlsDeps: t,
  children: r
}) {
  return Le("portal", "audio", Vi, { media: e, children: r }, [e, ...t || []]), null;
}
function Hi({
  element: e,
  media: t,
  playPause: r
}) {
  return /* @__PURE__ */ N("div", { className: "video-container", part: "video-container", onClick: r, children: [
    /* @__PURE__ */ x("style", { children: `
            .video-container {
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              background: #000;
              z-index: 13;
              display: flex;
              justify-content: center;
              pointer-events: visible;
            }
          ` }),
    /* @__PURE__ */ x("video", { ref: e, src: t.url, style: { width: "100%", objectFit: "contain" } })
  ] });
}
function Bi({
  media: e,
  mediaControlsDeps: t,
  children: r
}) {
  const [{ element: i, currentTime: n, progress: s }, o, a] = Nt({ duration: e.duration });
  return Le("overlay", "video-element", Hi, {
    element: i,
    media: e,
    playPause: a.playPause
  }), Le(
    "portal",
    "custom-controls",
    Ui,
    {
      state: o,
      actions: a,
      currentTime: n,
      progress: s,
      element: i,
      children: r
    },
    [n, o, e, ...t || []]
  ), null;
}
function zi({ model: e }) {
  return /* @__PURE__ */ N(Me, { children: [
    /* @__PURE__ */ x("style", { children: `
            .model-container {
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              background: #000;
              z-index: 13;
              display: flex;
              justify-content: center;
              pointer-events: visible;
            }
          ` }),
    /* @__PURE__ */ x("div", { className: "model-container", children: /* @__PURE__ */ x(
      "model-viewer",
      {
        "interaction-prompt": "none",
        style: { width: "100%", height: "100%" },
        "camera-controls": "",
        "ar-status": "not-presenting",
        src: e.id
      }
    ) })
  ] });
}
function Wi({ model: e, name: t }) {
  return Le("overlay", `model-${t}`, zi, { model: e }, [e]), null;
}
function Qi({ style: e }) {
  const t = ue();
  return !t || !t.height || !t.width ? null : /* @__PURE__ */ x(
    "box",
    {
      interactive: !1,
      target: { x: 0, y: 0, width: Number(t.width), height: Number(t.height) },
      style: e
    }
  );
}
const Yi = me.createContext("en");
function Fc(e) {
  return /* @__PURE__ */ x(Yi.Provider, { value: e.language, children: e.children });
}
function Ht() {
  return me.useContext(Yi);
}
function dr(e) {
  return e.indexOf("-") !== -1 ? e.slice(0, e.indexOf("-")) : e;
}
function dc({ as: e, language: t, children: r, viewingDirection: i, ...n }) {
  const s = Ht();
  return E(() => dr(s) === dr(t), [s, t]) ? e ? /* @__PURE__ */ x(e, { ...n, children: r }) : /* @__PURE__ */ x("span", { ...n, children: r }) : e ? /* @__PURE__ */ x(e, { ...n, lang: t, dir: i, children: r }) : /* @__PURE__ */ x("span", { ...n, lang: t, dir: i, children: r });
}
function Gi(e, t, r) {
  if (t.length === 0)
    return;
  if (t.length === 1)
    return t[0];
  if (t.indexOf(e) !== -1)
    return e;
  const i = e.indexOf("-") !== -1 ? e.slice(0, e.indexOf("-")) : null;
  if (i && t.indexOf(i) !== -1)
    return i;
  for (const n of r)
    if (t.indexOf(n) !== -1)
      return n;
  return t.indexOf("none") !== -1 ? "none" : t.indexOf("@none") !== -1 ? "@none" : t[0];
}
const hc = (e, t = []) => {
  const r = Ht();
  return E(() => {
    const i = e();
    return Gi(r, i, []);
  }, [r, ...t]);
};
function yc(e, t) {
  const r = hc(() => Object.keys(e || {}), [e]);
  return [
    E(() => {
      if (!e)
        return t || "";
      if (typeof e == "string")
        return e;
      const i = r ? e[r] : void 0;
      return i ? typeof i == "string" ? i : i.join(`
`) : "";
    }, [r, t, e]),
    r
  ];
}
function jc() {
  const e = Ht();
  return function(r, i, n) {
    const s = Object.keys(r || {}), o = Gi(e, s, []);
    if (!r)
      return i || "";
    if (typeof r == "string")
      return r;
    const a = o ? r[o] : void 0;
    return a ? typeof a == "string" ? a : a.join(typeof n < "u" ? n : `
`) : "";
  };
}
const vc = ({ as: e, defaultText: t, enableDangerouslySetInnerHTML: r, children: i, ...n }) => {
  const [s, o] = yc(i, t);
  return o ? /* @__PURE__ */ x(
    dc,
    {
      ...n,
      as: e,
      language: o,
      title: r ? void 0 : s,
      dangerouslySetInnerHTML: r ? {
        __html: s
      } : void 0,
      children: r ? void 0 : s
    }
  ) : e ? /* @__PURE__ */ x(e, { ...n, children: s }) : /* @__PURE__ */ x(
    "span",
    {
      ...n,
      title: r ? void 0 : s,
      dangerouslySetInnerHTML: r ? {
        __html: s
      } : void 0,
      children: r ? void 0 : s
    }
  );
};
function gc({
  element: e,
  media: t,
  playPause: r
}) {
  const i = ge(null);
  return t.youTubeId ? /* @__PURE__ */ N("div", { className: "video-container", part: "video-container", onClick: r, children: [
    /* @__PURE__ */ x("style", { children: `
            .video-container {
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              background: #000;
              z-index: 13;
              display: flex;
              justify-content: center;
              pointer-events: visible;
            }
            .video-yt {
              border: none;
              width: 100%;
              object-fit: contain;
            }
          ` }),
    /* @__PURE__ */ x(
      "iframe",
      {
        className: "video-yt",
        ref: i,
        src: `https://www.youtube.com/embed/${t.youTubeId}?enablejsapi=1&origin=${window.location.host}`,
        referrerPolicy: "no-referrer",
        sandbox: "allow-scripts allow-same-origin allow-presentation"
      }
    )
  ] }) : null;
}
function mc({
  media: e,
  mediaControlsDeps: t,
  children: r
}) {
  const [{ element: i, currentTime: n, progress: s }, o, a] = Nt({ duration: e.duration });
  return Le("overlay", "video-element", gc, {
    element: i,
    media: e,
    playPause: a.playPause
  }), null;
}
function Ji({
  x: e,
  y: t,
  onChoiceChange: r,
  registerActions: i,
  defaultChoices: n,
  isStatic: s,
  renderViewerControls: o,
  renderMediaControls: a,
  viewControlsDeps: u,
  mediaControlsDeps: d,
  strategies: l,
  throwOnUnknown: p,
  backgroundStyle: v,
  alwaysShowBackground: m,
  keepCanvasScale: h = !1,
  enableSizes: g = !1,
  enableYouTube: b = !0,
  onClickPaintingAnnotation: A,
  children: w
}) {
  const C = ue(), T = ei(C, ["deep-zoom"]), [j] = Ys(), I = Ks(), L = V(), P = E(() => jt(L), [L]), [M, $] = sc({
    strategies: l || ["images"],
    defaultChoices: n == null ? void 0 : n.map(({ id: O }) => O)
  }), ie = M.type === "images" ? M.choice : void 0, Z = E(() => h ? 1 : Math.max(
    1,
    ...M.type === "images" ? M.images.map((O) => {
      var W;
      return (O.width || 0) / ((W = O.target) == null ? void 0 : W.spatial.width);
    }) : []
  ), [h, M]);
  Zs(Z), K(() => {
    i && i($);
  }, [M.annotations]), K(() => {
    if (n)
      for (const O of n)
        typeof O.opacity < "u" && P.applyStyles({ id: O.id }, "atlas", {
          opacity: O.opacity
        });
  }, [n]), hr(() => {
    r && r(ie);
  }, [ie]), Le(
    I && (M.type === "images" || M.type === "empty" || M.type === "textual-content" && o) ? "overlay" : "none",
    `canvas-portal-controls-${C == null ? void 0 : C.id}`,
    Ft.Provider,
    o ? {
      value: I || null,
      children: o(M)
    } : {},
    [C, I, M, ...u || []]
  );
  const U = uc({ maxWidth: 256, maxHeight: 256 });
  if (!C)
    return null;
  const z = C.accompanyingCanvas, ee = U && U.type === "fixed" ? /* @__PURE__ */ x("world-object", { height: C.height, width: C.width, x: e, y: t, children: /* @__PURE__ */ x(
    "world-image",
    {
      uri: U.id,
      target: { x: 0, y: 0, width: C.width, height: C.height },
      display: U.width && U.height ? {
        width: U.width,
        height: U.height
      } : void 0,
      crop: void 0
    }
  ) }) : null;
  if (M.type === "unknown") {
    if (ee)
      return ee;
    if (p)
      throw new Error(M.reason || "Unknown image strategy");
    return null;
  }
  const ne = /* @__PURE__ */ N(Ke, { children: [
    j ? /* @__PURE__ */ x(It, { page: j }) : null,
    M.annotations && M.annotations.pages ? M.annotations.pages.map((O) => /* @__PURE__ */ x(It, { page: O }, O.id)) : null,
    w
  ] }), xe = M.type === "images" ? M.images.length : 0;
  return /* @__PURE__ */ N(Me, { children: [
    /* @__PURE__ */ N(
      "world-object",
      {
        height: C.height,
        width: C.width,
        x: e,
        y: t,
        ...T,
        children: [
          M.type === "empty" || m ? /* @__PURE__ */ x(Qi, { style: v }) : null,
          M.type === "textual-content" ? M.items.map((O, W) => {
            var X;
            return /* @__PURE__ */ N(Me, { children: [
              /* @__PURE__ */ x(
                hn,
                {
                  onClick: A ? (de) => {
                    de.stopPropagation(), A(O.annotationId, O, de);
                  } : void 0,
                  target: ((X = O.target) == null ? void 0 : X.spatial) || void 0,
                  children: /* @__PURE__ */ x("div", { "data-textual-content": !0, children: /* @__PURE__ */ x(vc, { enableDangerouslySetInnerHTML: !0, children: O.text }) })
                },
                W
              ),
              ne
            ] });
          }) : null,
          M.type === "images" ? /* @__PURE__ */ N(Me, { children: [
            M.images.map((O, W) => /* @__PURE__ */ x(
              ai,
              {
                isStatic: s,
                image: O,
                id: O.id,
                thumbnail: W === 0 ? U : void 0,
                selector: O.selector,
                enableSizes: g,
                onClick: A ? (X) => {
                  X.stopPropagation(), A(O.annotationId, O, X);
                } : void 0
              },
              O.id + W
            )),
            ne
          ] }) : null,
          M.type === "3d-model" ? /* @__PURE__ */ x(Wi, { model: M.model }) : null,
          M.type === "media" ? /* @__PURE__ */ x(Me, { children: M.media.type === "Sound" ? /* @__PURE__ */ N(Ni, { media: M.media, mediaControlsDeps: d, children: [
            ee,
            a ? a(M) : null
          ] }) : M.media.type === "Video" ? /* @__PURE__ */ N(Bi, { media: M.media, mediaControlsDeps: d, children: [
            ee,
            a ? a(M) : null
          ] }) : M.media.type === "VideoYouTube" && b ? /* @__PURE__ */ N(mc, { media: M.media, mediaControlsDeps: d, children: [
            ee,
            a ? a(M) : null
          ] }) : null }) : null
        ]
      },
      `${C.id}/${M.type}/${xe}`
    ),
    M.type === "media" && M.media.type === "Sound" && z ? /* @__PURE__ */ x(Lt, { canvas: z.id, children: /* @__PURE__ */ x(Ji, { renderViewerControls: o }) }) : null
  ] });
}
function bc() {
  const e = H(tt);
  return e && e.vault ? e.vault : Vr();
}
const Ac = yr(function(t, r) {
  const i = ke(), n = Br(), s = Ss(), { ViewerControls: o, MediaControls: a } = t.components || {};
  if (cn(r, () => s, [s]), !i)
    return /* @__PURE__ */ x("div", {});
  let u = 0;
  return /* @__PURE__ */ N(Me, { children: [
    t.header,
    /* @__PURE__ */ x(
      J.Viewer,
      {
        height: t.height,
        mode: t.mode,
        children: n.map((d, l) => {
          const p = u;
          return u += d.width + (t.spacing || 0), /* @__PURE__ */ x(Lt, { canvas: d.id, children: /* @__PURE__ */ x(
            J.RenderCanvas,
            {
              strategies: ["3d-model", "media", "images", "empty", "textual-content"],
              renderViewerControls: l === 0 && o ? () => /* @__PURE__ */ x(o, {}) : void 0,
              renderMediaControls: l === 0 && a ? () => /* @__PURE__ */ x(a, {}) : void 0,
              x: p,
              ...t.canvasProps || {},
              children: t.annotations
            },
            d.id
          ) }, d.id);
        })
      },
      t.reuseAtlas ? "" : s.currentSequenceIndex
    ),
    t.children
  ] });
}), J = yr(function({ children: t, height: r, annotations: i, canvasProps: n, spacing: s, header: o, components: a, mode: u, ...d }, l) {
  const p = bc();
  return /* @__PURE__ */ x(Nr, { vault: p, children: /* @__PURE__ */ x(ws, { ...d, children: /* @__PURE__ */ x(
    Ac,
    {
      ref: l,
      height: r,
      components: a,
      spacing: s,
      canvasProps: n,
      annotations: i,
      header: o,
      mode: u,
      children: t
    }
  ) }) });
});
J.RenderImage = ai;
J.RenderCanvas = Ji;
J.RenderAnnotationPage = It;
J.RenderAnnotation = oi;
J.Viewer = Xs;
J.CanvasBackground = Qi;
J.Audio = Ni;
J.Video = Bi;
J.Model = Wi;
J.AudioHTML = Vi;
J.VideoHTML = Hi;
J.ModelHTML = zi;
function $c({ annotation: e, children: t }) {
  return /* @__PURE__ */ x(Te, { value: { annotation: e }, children: t });
}
function Dc({ annotationPage: e, children: t }) {
  return /* @__PURE__ */ x(Te, { value: { annotationPage: e }, children: t });
}
function qc({ collection: e, children: t }) {
  return /* @__PURE__ */ x(Te, { value: { collection: e }, children: t });
}
function _c(e, t = {}) {
  return Vt(t);
}
function Uc(e, t = !1) {
}
function Vc(e) {
  const r = be().manifest, i = e ? e.map((n) => typeof n == "string" ? n : n == null ? void 0 : n.id) : [];
  return Q(
    (n) => {
      const s = r ? n.iiif.entities.Manifest[r] : void 0, o = (s == null ? void 0 : s.items) || [];
      if (typeof e > "u")
        return o;
      const a = [];
      for (const u of (s == null ? void 0 : s.items) || [])
        i.indexOf(u.id) !== -1 && a.push(u);
      return a;
    },
    [i.join("/")]
  );
}
function Nc(e, t = []) {
  const { id: r, selector: i } = e, n = be(), s = r || n.collection, o = Q(
    (a) => s ? a.iiif.entities.Collection[s] : void 0,
    [s]
  );
  return E(() => {
    if (o)
      return i ? i(o) : o;
  }, [o, i, ...t]);
}
function Hc(e, t, r, i, n = []) {
  const s = V(), o = E(() => Xr(s), [s]);
  K(() => {
    const a = e;
    return a ? (o.addEventListener(a, t, r, i), () => {
      o.removeEventListener(a, t, r);
    }) : () => {
    };
  }, [o, e, t, ...n]);
}
function Bc(e, t) {
  const { id: r, isLoaded: i, error: n, resource: s, requestId: o, cached: a } = Hr(
    e,
    t
  );
  return { id: r, isLoaded: i, error: n, manifest: s, requestId: o, cached: a };
}
function xc({ cacheKey: e } = {}) {
  const t = ue(), r = Vt(), i = V(), n = Ut(), [s, o] = B(void 0), [a, u] = B(!1), [d, l] = B("idle"), [p, v] = B(void 0), m = t ? t.id : "undefined", h = E(() => {
    try {
      if (t && r.length) {
        const b = r[0], A = i.get(b.body[0]), C = mt(A)[0];
        return C && n.loadServiceSync({
          id: C.id || C["@id"],
          width: C.width || t.width,
          height: C.height || t.height
        }) || void 0;
      }
    } catch (b) {
      console.error(b);
    }
  }, [m, e, t]), g = d === "success" && s ? s : h;
  return K(() => {
    (async () => {
      try {
        if (t && r.length) {
          const b = r[0], A = i.get(b.body[0]), C = mt(A)[0];
          if (!C)
            return;
          u(!0), l("loading");
          try {
            const T = await n.loadService({
              id: C.id || C["@id"],
              width: C.width || t.width,
              height: C.height || t.height
            }) || void 0;
            o(T), l("success"), u(!1);
          } catch (T) {
            l("error"), v(T);
          }
        }
      } catch (b) {
        l("error"), v(b);
      }
    })();
  }, [m, e]), E(() => ({
    data: g,
    isFetching: a,
    status: d,
    error: p
  }), [g, a, d, p]);
}
function zc() {
  const e = xc();
  return {
    isLoading: e.isFetching,
    tile: e.data ? {
      id: e.data.id || e.data["@id"],
      width: e.data.width,
      height: e.data.height,
      imageService: e.data,
      thumbnail: void 0
    } : null
  };
}
function Wc() {
  const e = ke();
  return e ? e.service.find(
    (t) => t.profile === "SearchService1" || t.profile === "http://iiif.io/api/search/1/search"
  ) : void 0;
}
function Qc() {
  const e = V();
  return E(() => jt(e), [e]);
}
export {
  $c as AnnotationContext,
  Dc as AnnotationPageContext,
  Lt as CanvasContext,
  J as CanvasPanel,
  qc as CollectionContext,
  Ms as ContextBridge,
  Qa as ImageServiceLoaderContext,
  xs as InnerViewerProvider,
  Fc as LanguageProvider,
  dc as LanguageString,
  vc as LocaleString,
  vs as ManifestContext,
  Ui as MediaPlayerProvider,
  gs as RangeContext,
  tt as ReactVaultContext,
  Te as ResourceProvider,
  Et as ResourceReactContext,
  ws as SimpleViewerProvider,
  it as SimpleViewerReactContext,
  Nr as VaultProvider,
  Ft as ViewerPresetContext,
  Gs as VirtualAnnotationProvider,
  rt as VisibleCanvasReactContext,
  _a as emptyActions,
  Ua as emptyStrategy,
  Re as expandTarget,
  zr as findAllCanvasesInRange,
  ms as findFirstCanvasFromRange,
  Tc as findManifestSelectedRange,
  Wr as findSelectedRange,
  Ha as flattenAnnotationPageIds,
  pc as formatTime,
  Za as getImageStrategy,
  Qr as getManifestSequence,
  Li as getParsedTargetSelector,
  kc as getVisibleCanvasesFromCanvasId,
  Mo as isImageApiSelector,
  Ro as parseRotation,
  Ye as parseSelector,
  Oc as parseSpecificResource,
  gt as unknownResponse,
  _ as unsupportedStrategy,
  si as useAnnotation,
  Io as useAnnotationPage,
  za as useAnnotationPageManager,
  _c as useAnnotationsAtTime,
  ue as useCanvas,
  Uc as useCanvasClock,
  As as useCanvasSequence,
  Vc as useCanvasSubset,
  hc as useClosestLanguage,
  Nc as useCollection,
  Cs as useContextBridge,
  jc as useCreateLocaleString,
  Ws as useDispatch,
  Hc as useEventListener,
  bc as useExistingVault,
  Bc as useExternalCollection,
  ys as useExternalManifest,
  Hr as useExternalResource,
  Ht as useIIIFLanguage,
  xc as useImageService,
  Ut as useImageServiceLoader,
  zc as useImageTile,
  Ya as useLoadImageService,
  yc as useLocaleString,
  ke as useManifest,
  Pc as useMediaActions,
  Lc as useMediaElements,
  Ec as useMediaState,
  Ka as usePaintables,
  Vt as usePaintingAnnotations,
  bs as useRange,
  sc as useRenderingStrategy,
  be as useResourceContext,
  ei as useResourceEvents,
  Wa as useResources,
  Wc as useSearchService,
  Nt as useSimpleMediaPlayer,
  Ss as useSimpleViewer,
  Qc as useStyleHelper,
  et as useStyles,
  uc as useThumbnail,
  V as useVault,
  oc as useVaultEffect,
  Q as useVaultSelector,
  Ks as useViewerPreset,
  Qs as useVirtualAnnotationPage,
  Ys as useVirtualAnnotationPageContext,
  Br as useVisibleCanvases
};
//# sourceMappingURL=index.mjs.map
